import React, { Fragment, useState, useEffect, useRef } from "react";
import {
  TabContent, TabPane, Nav, NavItem, NavLink, Row, Col, Button, FormGroup, Label,
  Input, Alert, Modal, ModalHeader, ModalBody, ModalFooter, InputGroup, InputGroupAddon, InputGroupText,
} from "reactstrap";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import Navbarh from "../navbar/Navbar";
//import { API } from "aws-amplify";
import "../estilos.css";
import {
  listRecibaSeriales, listEmbarques, listEmbarqueSeriales, listEmbarqueUltimoNumeros, listClientes,
  listUbicacions,
} from "../../graphql/queries";
import {
  createEmbarque as createEmbarqueMutation,
  createEmbarqueUltimoNumero,
  createEmbarqueSeriales,
  createUbicacion,
  updateEmbarque,
  updateRecibaSeriales,
  updateEmbarqueUltimoNumero,
  updateEmbarqueSeriales,
  updateUbicacion,
  updateRecibaSerialesMP,
  deleteRecibaSerialesMP,
  createRecibaSerialesMP,
  createNotificaciones,
  createNotificacionesNuevas,
} from "../../graphql/mutations";
import * as IoIcons from "react-icons/io";
import Pagination from "react-js-pagination";
import Moment, { updateLocale } from "moment";
import classnames from "classnames";
import { useReactToPrint } from "react-to-print";
import Bargenerator from "../codereader/barcodegeneratorComp";
import { CSVLink, CSVDownload } from "react-csv";
import {
  GetClientes, GetEmbarques, GetEmbarquesID, GetEmbarquesSeriales, GetEmbarquesSerialesID, GetPProduccion, GetProductosID, GetRecibaSeriales,
  GetRecibaSerialesID, GetRecibaSerialesMP, GetUbicacion,
  GetUsuarios,
} from "../queries/Queries";
import * as xlsx from "xlsx";
import { ObtenerSerialesEmbarques, ObtenerServiciosEmbarques, cambioUbicacionSeriales, combinarIDS, datosRSerial, decodificarTextoJSON } from "../queries/DCUbicaciones";
import { manageResumenOperacion, marcarMaterialFueradePlanta } from "../queries/Mutations";
import BarcodeReader from "react-barcode-reader";
import GeneralProduccion from "../produccion/GeneralProduccion";
import CargaPintado from "../produccion/CargaPintado";
import { generateClient } from "aws-amplify/api";

const API = generateClient();
const initialfFormState = { formType: "Embarques" };

function Embarques() {
  //Declaración de variables
  const [clientes, setClientes] = useState([]);
  const [reciba, setReciba] = useState([]);
  const [recibaDevolucion, setRecibaDevolucion] = useState([]);
  const [recibaSinFiltro, setRecibaSinFiltro] = useState([]);
  const [embarquesSinFiltro, setEmbarquesSinFiltro] = useState([]);
  const [embarqueEditando, setEmbarqueEditando] = useState("");
  const [embarques, setEmbarques] = useState([]);
  const [embarcando, setEmbarcando] = useState({});
  const [embarqueParticular, setEmbarqueParticular] = useState(false);
  const [embarqueEliminar, setEmbarqueEliminar] = useState([]);
  const [editar, setEditar] = useState(false);
  const [cambiosCheck, setCambiosCheck] = useState(false);
  const [numeroP, setNumeroP] = useState(0);
  const [ultimoNumeroP, setultimoNumeroP] = useState(0);
  const [formState, updateFormState] = useState(initialfFormState);
  const [isDisabled, setisDisabled] = useState(false);
  const [servicios, setServicios] = useState(false);
  const [buscarporFecha, setBuscarporFecha] = useState(false);
  const [busquedaxClientes, setBusquedaxClientes] = useState("todos");
  const [search, setSearch] = useState("");
  const [fechaPBusqueda, setFechaPBusqueda] = useState("");
  const [searchBy, setSearchBy] = useState("cliente");
  const [searchReciba, setSearchReciba] = useState("");
  const [searchByReciba, setSearchByReciba] = useState("serial");
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalRecordsNP, setTotalRecordsNP] = useState(0);
  const [totalRecordsEmbarque, setTotalRecordsEmbarque] = useState(0);
  const { formType } = formState;
  const [mensajeAlert, setMensajeAlert] = useState("Hola");
  const [color, setColor] = useState("warning");
  const [mensajeAlertr, setMensajeAlertr] = useState("Hola");
  const [colorr, setColorr] = useState("warning");
  const userName = window.$name;
  const pembarques = window.$Embarques ? window.$Embarques : false;
  const pembarquesinventario = window.$EmbarquesDInventario ? window.$EmbarquesDInventario : false;
  const ppEmbarquesMEmbarcado = window.$MarcarEmbarcadoEmbarques ? window.$MarcarEmbarcadoEmbarques : false;
  const verEmbarques = window.$verEmbarques ? window.$verEmbarques : false;
  const [tituloTab, setTituloTab] = useState(
    pembarques ? "Nuevo embarque" : "Detalle de embarque"
  );
  const [aVisible, setAVisible] = useState(false);
  const [aVisibler, setAVisibler] = useState(false);
  const [dRegresarAE, setDRegresarAE] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [cargando1, setCargando1] = useState(false);
  const [clienteID, setClienteID] = useState("");
  const [rCliente, setRCliente] = useState("");
  const [clienteEntregaID, setClienteEntregaID] = useState("");
  const [rClienteEntrega, setRClienteEntrega] = useState("");
  const [rClienteFacturarA, setRClienteFacturarA] = useState("");
  const [fechaDeEmbarque, setFechaDeEmbarque] = useState("");
  const [atencionA, setAtencionA] = useState("");
  const [ordenDeCompra, setOrdenDeCompra] = useState("");
  const [aMRecuperado, setAMRecuperado] = useState(false);
  const [iTotalNParte, setITotalNParte] = useState(false);
  const [sinTotalScrap, setSinTotalScrapt] = useState(false);
  const [imprimirComentario, setImprimirComentario] = useState(false);
  const [sinTotalScrapFactura, setSinTotalScraptFactura] = useState(true);
  const [desgloceVer, setDesgloceVer] = useState(false);
  const [comCAS, setComCAS] = useState(false);
  const [fechaDeEmbarqueM, setFechaDeEmbarqueM] = useState("");
  const [sumTarimas, setSumTarimas] = useState("");
  const [sumCajas, setSumCajas] = useState("");
  const [sumContenedores, setSumContenedores] = useState("");
  const [totalNumeroParte, setTotalNumeroParte] = useState([]);
  const [sumPiezas, setSumPiezas] = useState("");
  const onDismiss = () => setAVisible(false);
  const onDismissr = () => setAVisibler(false);
  const [inputList, setInputList] = useState([]);
  const [inputListServicios, setInputListServicios] = useState([]);
  const [embarqueSerialEditar, setEmbarqueSerialEditar] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [paginas, setPaginas] = useState([]);
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [modal3, setModal3] = useState(false);
  const [indexImp, setIndexImp] = useState(0);
  const [datosSerial, setDatosSerial] = useState({});
  const [valCP, setVarCP] = useState("");
  const [datosReciba, SetDatosReciba] = useState(false);
  Moment.locale("en");
  var now = new Date();
  var now2 = new Date();
  now2.setMonth(now2.getMonth() - 1);
  now.setDate(now.getDate() + 5);

  const [rfechaini, setRfechaini] = useState(Moment(now2).format("YYYY-MM-DD"));
  const [rfechafin, setRfechafin] = useState(Moment(now).format("YYYY-MM-DD"));
  const [rfechainiag, setRfechainiag] = useState(Moment(now2).format("YYYY-MM-DD"));
  const [rfechafinag, setRfechafinag] = useState(Moment(new Date()).format("YYYY-MM-DD"));
  const serviciosIniciales = {
    orden: 0, materialEnCantidad: 0, numerodeParte: "", serial: "",
    descripcion: "", shipper: "", materialEn: "Contenedor", piezasPintadas: 0,
    totalCantidad: 0, precioUnitario: 0.0, divisa: "Dólar", precioTotal: 0, createdAt: "",
    updatedAt: "", Reg_Ins_Usuario: userName, Reg_Mod_Usuario: ""
  }

  const toggle1 = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
    if (tab > 1) setAVisible(false);
  };

  const toggle = () => setModal(!modal);
  const toggle2 = () => setModal2(!modal2);
  const toggle3 = () => setModal3(!modal3);
  const handleCallback = (childData) => {
    setVarCP(childData);
    SetDatosReciba(childData.completo);
    if ((childData.aEmbarcar ? childData.aEmbarcar : false) === true && childData.serial) {
      clicAgregarMaterial(childData.serial);

    }
  };

  const componentRefTEV = useRef();
  const handlePrintTEV = useReactToPrint({
    content: () => componentRefTEV.current,
  });

  const componentRef = React.useMemo(
    () =>
      Array(100)
        .fill(0)
        .map((i) => React.createRef()),
    []
  );
  const handlePrint = useReactToPrint({
    content: () => componentRef[indexImp].current,
  });

  function handleError(err) {
    console.error(err);
  }

  async function handleScan(data) {
    setAVisible(false);

    setModal2(modal2 ? !modal2 : false);
    //data = data.replace('\'', '-')
    if (data) {
      const serialID = data.replaceAll("'", "-");
      const datoSerial = await datosRSerial(serialID);
      if (datoSerial.length > 0) {
        //const datosSerialF = datoSerial.filter((serial) => serial.cliente === rCliente || serial.cliente === "CAS");
        if (datoSerial[0].cliente === rCliente || datoSerial[0].cliente === "CAS") {
          const piezasTotales = parseInt(datoSerial[0].piezasCalidad ? datoSerial[0].piezasCalidad : 0) +
            parseInt(datoSerial[0].piezasNoAceptadas ? datoSerial[0].piezasNoAceptadas : 0);
          if (piezasTotales >= datoSerial[0].cantidadRecibida) {

            clicAgregarMaterial(datoSerial[0].serial);
          } else {
            await setDatosSerial(datoSerial[0]);
            SetDatosReciba(true);
          }
        } else {
          setMensajeAlert("El serial leído no corresponde al cliente del que se está realizando el packing");
          setColor("warning");
          setAVisible(true);
          SetDatosReciba(false);
        }
      } else {
        setMensajeAlert("Serial no encontrado; el serial no se encuentra en la línea de producción, ya sea porque no se ha registrado en la reciba, se marcó fuera de planta o se embarcó en su totalidad");
        setColor("warning");
        setAVisible(true);
        SetDatosReciba(false);
      }

    } else {
      setMensajeAlert("Serial no encontrado");
      setColor("warning");
      setAVisible(true);
      SetDatosReciba(false);
    }
    return <p>{data}</p>;
  }


  // current page
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageNPintado, setCurrentPageNPintado] = useState(1);
  const [currentPageEmbarques, setCurrentPageEmbarques] = useState(1);

  // total records per page to display
  const recordPerPage = 20;
  const recordPerPageEmbarque = 20;

  // range of pages in paginator
  const pageRange = 5;

  // handle change event
  function handlePageChange(pageNumber, pageNumberNPintado) {
    setAVisible(false);
    setCargando(false);
    setCurrentPage(pageNumber);
    busqueda(
      recibaSinFiltro,
      busquedaxClientes,
      searchByReciba,
      searchReciba,
      pageNumber,
      currentPageNPintado,
      aMRecuperado
    );
  }

  // handle change event
  function handlePageChangeNP(pageNumberNPintado) {
    setAVisible(false);
    setCargando(false);
    setCurrentPageNPintado(pageNumberNPintado);
    busqueda(
      recibaSinFiltro,
      busquedaxClientes,
      searchByReciba,
      searchReciba,
      currentPage,
      pageNumberNPintado,
      aMRecuperado
    );
  }

  // handle change event
  function handlePageChangeEmbarques(pageNumber) {
    setAVisible(false);
    setCargando(false);
    setCurrentPageEmbarques(pageNumber);
    busquedaEmbarques(
      embarquesSinFiltro,
      searchBy,
      search,
      pageNumber,
      fechaPBusqueda
    );
  }

  async function busquedaEmbarques(embarquessf, searchb, search, currentPage) {
    var i = 1;
    var paginasp = [];
    var p = 1;
    var pi = 1;
    var racks = 0;

    const embarqueFromAPI = embarquessf
      .sort((a, b) =>
        a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0
      )
      .filter((reciba) =>
        searchb === "numero de parte"
          ? reciba.numerosdeParte.toLowerCase().includes(search.toLowerCase())
          : searchb === "cliente"
            ? reciba.cliente.toLowerCase().includes(search.toLowerCase())
            : searchb === "id de embarques"
              ? reciba.numero.toString().includes(search.toLowerCase())
              : searchb === "serial"
                ? reciba.seriales.toLowerCase().includes(search.toLowerCase())
                : searchb === "paking"
                  ? reciba.packings.toLowerCase().includes(search.toLowerCase())
                  : searchb === "lote"
                    ? reciba.lotes.toLowerCase().includes(search.toLowerCase())
                    : Moment(reciba.fechaDeEmbarque)
                      .format("DD/MM/YYYY")
                      .includes(Moment(search).format("DD/MM/YYYY"))
      );

    await Promise.all(
      embarqueFromAPI.map(async (embarques) => {
        embarques.paginacion = pi;
        p++;
        if (p > recordPerPageEmbarque) {
          p = 1;
          paginasp.push({ pagina: pi });
          pi++;
        }
        return embarques;
      })
    );

    const lengthEmbarque = embarqueFromAPI.length;
    if (lengthEmbarque <= 0) setCurrentPageEmbarques(1);

    const embarquescp = embarqueFromAPI
      .filter((embarques) => embarques.paginacion === currentPage)
      .sort((a, b) =>
        a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0
      );
    if (embarquescp.length)
      setFechaDeEmbarqueM(embarquescp[0].fechaDeEmbarques);
    setEmbarques(embarquescp);

    setTotalRecordsEmbarque(lengthEmbarque);
    const prepaginas = parseInt(lengthEmbarque / recordPerPageEmbarque);
    const paginas =
      prepaginas * recordPerPageEmbarque < lengthEmbarque
        ? prepaginas + 1
        : prepaginas;
    if (paginas > paginasp.length) paginasp.push({ pagina: paginas });

    if (currentPage > 1 && lengthEmbarque > 0) {
      if (currentPage > paginas) {
        setCurrentPageEmbarques(paginas);
      }
    }

    if (lengthEmbarque > 0) {
      setPaginas(paginasp);
      setultimoNumeroP(paginasp[paginasp.length - 1].pagina);
    } else {
      setPaginas([]);
      setultimoNumeroP(0);
    }
  }
  async function busqueda(recibasinf, busquedaxClientesb, searchb, search, currentPage, currentPageNPintado, materialNoRecuperado) {
    var pag = 1;
    var bandera = 1;
    var pagNP = 1;
    var banderaNP = 1;
    //Filtrado de datos por la búsqueda de las piezas pintadas listas para embarcar
    const recibaFromAPI = recibasinf
      .sort((a, b) =>
        a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0
      )
      .filter((reciba) => reciba.piezasAEmbarcar > 0)
      .filter((reciba) =>
        busquedaxClientesb === "todos"
          ? reciba.clienteID === reciba.clienteID
          : reciba.clienteID === busquedaxClientesb
      )
      .filter((reciba) =>
        materialNoRecuperado === true
          ? reciba.piezasAEmbarcar > 0 &&
          reciba.clienteID.toLowerCase().includes(busquedaxClientesb.toLowerCase())
          : (reciba.piezasPintadas > 0 || reciba.piezasPintadasPC > 0) &&
          reciba.clienteID.toLowerCase().includes(busquedaxClientesb.toLowerCase())
      )
      .filter((reciba) =>
        searchb === "numero de parte"
          ? reciba.numerodeParte.toLowerCase().includes(search.toLowerCase())
          : searchb === "serial BTI"
            ? reciba.serialRecibaBTI.toLowerCase().includes(search.toLowerCase())
            : searchb === "clienteID"
              ? aMRecuperado
                ? reciba.clienteID.toLowerCase().includes(search.toLowerCase()) &&
                reciba.piezasAEmbarcar > 0
                : reciba.clienteID.toLowerCase().includes(search.toLowerCase()) &&
                (reciba.piezasPintadas > 0 || reciba.piezasPintadasPC > 0)
              : searchb === "id de reciba"
                ? reciba.numero.toLowerCase().includes(search.toLowerCase())
                : searchb === "serial"
                  ? reciba.serial.toLowerCase().includes(search.toLowerCase())
                  : searchb === "paking"
                    ? reciba.packing.toLowerCase().includes(search.toLowerCase())
                    : searchb === "lote"
                      ? reciba.lote.toLowerCase().includes(search.toLowerCase())
                      : searchb === "po"
                        ? reciba.po.toLowerCase().includes(search.toLowerCase())
                        /*: searchb === "aMRecuperado"
                          ? search === true
                            ? reciba.piezasAEmbarcar > 0 &&
                            reciba.clienteID.toLowerCase().includes(busquedaxClientesb.toLowerCase())
                            : reciba.piezasPintadas > 0 &&
                            reciba.clienteID.toLowerCase().includes(busquedaxClientesb.toLowerCase())*/
                        : reciba.fechayHoraDeReciba.includes(
                          Moment(search).format("DD/MM/YYYY")
                        )
      );

    const recibaPintados = recibaFromAPI.filter(
      (reciba) => reciba.piezasPintadas > 0 || reciba.piezasNRecuperadas > 0 || reciba.piezasPintadasPC > 0 || reciba.piezasNRecuperadasPC > 0
    );

    //Pintadas
    await Promise.all(
      recibaPintados.map(async (reciba, i) => {
        reciba.indexpag = pag;
        bandera++;
        if (bandera > recordPerPage) {
          bandera = 1;
          pag++;
        }
        return reciba;
      })
    );

    //Piezas pintadas
    const lengthreciba = recibaPintados.length;

    if (lengthreciba <= 0) setCurrentPage(1);

    setReciba(
      recibaPintados
        .filter((reciba) => reciba.indexpag === currentPage)
        .sort((a, b) =>
          a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0
        )
    );
    setTotalRecords(lengthreciba);

    if (currentPage > 1 && lengthreciba > 0) {
      const prepaginas = parseInt(lengthreciba / recordPerPage);
      const paginas =
        prepaginas * recordPerPage < lengthreciba ? prepaginas + 1 : prepaginas;
      if (currentPage > paginas) {
        setCurrentPage(paginas);
        const recibaFromAPIp = recibaPintados
          .sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0
          )
          .filter((reciba) => reciba.indexpag === paginas);
        setReciba(
          recibaFromAPIp.sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0
          )
        );
      }
    }

    //Piezas no pintadas
    //Filtrado de datos por la búsqueda de las piezas no pintadas, listas para embarcar
    const recibaNoPintados = recibasinf
      .sort((a, b) =>
        a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0
      )
      .filter((reciba) => reciba.piezasCtnaNAEmbarcar > 0)
      .filter((reciba) =>
        busquedaxClientesb === "todos"
          ? reciba.clienteID === reciba.clienteID
          : reciba.clienteID === busquedaxClientesb
      )
      .filter((reciba) =>
        searchb === "numero de parte"
          ? reciba.numerodeParte.toLowerCase().includes(search.toLowerCase())
          : searchb === "serial BTI"
            ? reciba.serialRecibaBTI.toLowerCase().includes(search.toLowerCase())
            : searchb === "clienteID"
              ? aMRecuperado
                ? reciba.clienteID.toLowerCase().includes(search.toLowerCase()) &&
                reciba.piezasAEmbarcar > 0
                : reciba.clienteID.toLowerCase().includes(search.toLowerCase()) &&
                (reciba.piezasPintadas > 0 || reciba.piezasPintadasPC > 0)
              : searchb === "id de reciba"
                ? reciba.numero.toLowerCase().includes(search.toLowerCase())
                : searchb === "serial"
                  ? reciba.serial.toLowerCase().includes(search.toLowerCase())
                  : searchb === "paking"
                    ? reciba.packing.toLowerCase().includes(search.toLowerCase())
                    : searchb === "lote"
                      ? reciba.lote.toLowerCase().includes(search.toLowerCase())
                      : reciba.fechayHoraDeReciba === reciba.fechayHoraDeReciba
      );

    await Promise.all(
      recibaNoPintados.map(async (reciba, i) => {
        reciba.indexpag = pagNP;
        banderaNP++;
        if (banderaNP > recordPerPage) {
          banderaNP = 1;
          pagNP++;
        }
        return reciba;
      })
    );
    const lengthrecibaNP = recibaNoPintados.length;

    if (lengthrecibaNP <= 0) setCurrentPageNPintado(1);
    setRecibaDevolucion(
      recibaNoPintados
        .filter((reciba) => reciba.indexpag === currentPageNPintado)
        .sort((a, b) =>
          a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0
        )
    );
    setTotalRecordsNP(lengthrecibaNP);

    if (currentPageNPintado > 1 && lengthrecibaNP > 0) {
      const prepaginasNP = parseInt(lengthrecibaNP / recordPerPage);
      const paginasNP =
        prepaginasNP * recordPerPage < lengthrecibaNP
          ? prepaginasNP + 1
          : prepaginasNP;
      if (currentPageNPintado > paginasNP) {
        setCurrentPageNPintado(paginasNP);
        const recibaFromAPIp = recibaNoPintados
          .sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0
          )
          .filter((reciba) => reciba.indexpag === paginasNP);
        setRecibaDevolucion(
          recibaFromAPIp.sort((a, b) =>
            a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0
          )
        );
      }
    }
    //setCargando1(false);
  }
  //Método useEffect
  useEffect(() => {
    fetchEmbarques(rfechaini, rfechafin);
    fetchClientes();
  }, []);

  //Obtiene los datos guardados de los clientes
  async function fetchClientes() {
    const clientesFromAPI = await GetClientes();
    setClientes(clientesFromAPI);
  }
  //Obtiene los datos guardados de los embarques
  async function fetchEmbarques(fechainicial, fechafinal) {
    //Filtro por embarque activo y fecha
    setCargando(true);
    let filter = {
      and: [
        {
          activo: {
            eq: true,
          },
        },
        {
          fechaDeEmbarque: {
            ge: fechainicial,
          },
        },
        {
          fechaDeEmbarque: {
            le: fechafinal,
          },
        },
      ],
    };
    //const apiData = await API.graphql({ query: listEmbarques, variables: { filter: filter, limit: 100000000 } });
    const apiData = await GetEmbarques(filter);
    const EmbarquesFromAPI = apiData.sort((a, b) =>
      a.numero < b.numero ? 1 : a.numero > b.numero ? -1 : 0
    );
    await Promise.all(
      EmbarquesFromAPI.map(async (embarques) => {
        if (!embarques.clienteEntregaID) {
          embarques.clienteEntregaID = embarques.clienteID;
          embarques.clienteEntrega = embarques.cliente;
        }
        embarques.cantidadDisponible = 20000;
        /*var listr = recibaSeriales.filter(reciba => reciba.id === embarques.recibaSerialID)
            if (listr.length > 0) {
                //planeacion.cantidadDisponible=planeacion.cantidadPiezas;
                listr.map(reciba => {
                    embarques.cantidadDisponible = (reciba.piezasAEmbarcar - reciba.piezasEmbarcadas) > 0 ? embarques.piezasembarcadas + (reciba.piezasAEmbarcar - reciba.piezasEmbarcadas) : embarques.piezasembarcadas;
                });
            }*/
        return embarques;
      })
    );
    if (EmbarquesFromAPI.length > 0) {
      const embarquesf = EmbarquesFromAPI;
      setEmbarquesSinFiltro(embarquesf);
      busquedaEmbarques(
        EmbarquesFromAPI,
        searchBy,
        search,
        currentPageEmbarques
      );
    } else {
      setEmbarques([]);
    }
    setCargando(false);
  }
  //Procedimiento especial para marcar el material como embarcado por fechas
  async function marcarEmbarcado(fechainicial, fechafinal) {
    //Filtro por fecha y registro activo
    setCargando(true);
    setAVisible(false);
    var recibaFromAPI = [];
    try {
      let filter = {
        and: [
          {
            activo: {
              eq: true,
            },
          },
          {
            piezasAEmbarcar: {
              gt: 0,
            },
          },
          /*{
            serialRecibaBTI: {
              eq: 'BTI-B4-19864',
            },
          },*/
          {
            fechaDeReciba: {
              ge: fechainicial,
            },
          },
          {
            fechaDeReciba: {
              le: fechafinal,
            },
          },
          {
            cliente: {
              le: "Gobar Systems Inc",
            },
          },
        ],
      };

      setMensajeAlert("Sin datos");
      const apiData = await GetRecibaSeriales(filter);
      setMensajeAlert("Datos");
      var afectados = 0;
      recibaFromAPI = apiData.sort((a, b) =>
        a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0
      );
      setMensajeAlert(
        "Datos a afectar descargados: " + JSON.stringify(recibaFromAPI)
      );
      var cambioUbicacionAux = [];
      await Promise.all(
        recibaFromAPI.map(async (recibam) => {
          if (recibam.piezasAEmbarcar > 0) {
            setMensajeAlert(
              "Empezando cambios: " + afectados + " " + JSON.stringify(recibam)
            );
            var auxUltimaUbicacion = [];
            const loacionAnterior = "Calidad";
            const ubicacionAnterior = "Producción";
            const loacionPiezas = "Embarcado";
            const ubicacionPiezas = "Embarques";
            const cantidadPiezas = recibam.piezasAEmbarcar;

            //Se actualizan los datos en reciba Seriales
            //Piezas pintadas.
            //Piezas embarcadas no recuperadas.
            recibam.PiezasENRecuperadas =
              parseInt(
                recibam.PiezasENRecuperadas ? recibam.PiezasENRecuperadas : 0
              ) +
              parseInt(
                recibam.piezasNRecuperadas ? recibam.piezasNRecuperadas : 0
              );

            //Piezas embarcadas pintadas.
            recibam.PiezasEPintadas =
              parseInt(recibam.PiezasEPintadas ? recibam.PiezasEPintadas : 0) +
              parseInt(recibam.piezasPintadas);

            //Piezas Embarcadas que se guardan en recibaSeriales
            recibam.piezasEmbarcadas =
              parseInt(
                recibam.piezasEmbarcadas ? recibam.piezasEmbarcadas : 0
              ) +
              parseInt(recibam.piezasAEmbarcar ? recibam.piezasAEmbarcar : 0);

            if (recibam.fechaDeReciba > "2022-08-15") {
              auxUltimaUbicacion = await await cambioUbicacionSeriales(
                recibam,
                ubicacionAnterior,
                loacionAnterior,
                ubicacionPiezas,
                loacionPiezas,
                cantidadPiezas);
            } else {
              auxUltimaUbicacion.push({
                ubicacion: "Embarques",
                locacion: "Embarcado",
                cantidad: recibam.piezasEmbarcadas,
                espacio: 0,
              });
            }
            if (cambioUbicacionAux.mensaje !== "") {
              return
            } else {
              setMensajeAlert(
                "Después del cambio de ubicación: " +
                afectados +
                " " +
                JSON.stringify(recibam)
              );
              auxUltimaUbicacion = cambioUbicacionAux.sUltimaU;

              //Piezas a embarcar que se guardan en recibaSeriales
              delete recibam.createdAt;
              delete recibam.updatedAt;
              delete recibam.__typename;
              recibam.piezasAEmbarcar = 0;
              if (recibam.piezasEmbarcadas >= recibam.cantidadRecibida) {
                recibam.piezasEnPlanta = false;
              }
              recibam.ultimaUbicacion = auxUltimaUbicacion;
              recibam.Reg_Mod_Usuario = userName;
              setMensajeAlert(
                "Antes del guardado: " + afectados + " " + JSON.stringify(recibam)
              );
              let upRecibaS = await API.graphql({
                query: updateRecibaSeriales,
                variables: { input: recibam },
              });
              if (recibam.recibaSerialMPID) {
                //Se actualizan los datos en la tabla de serialesMP o se eliminan segpun corresponda.
                if (cantidadPiezas === recibam.cantidadRecibida) {
                  setMensajeAlert("No se pudo eliminar de la tabla temporal; ");
                  await API.graphql({ query: deleteRecibaSerialesMP, variables: { input: { id: recibam.recibaSerialMPID, } } });
                } else {
                  //Se actualizan los datos en recibaSerialesMP
                  const recibaSerialMPID = recibam.recibaSerialMPID;
                  delete recibam.recibaSerialMPID;
                  setMensajeAlert("Operación errónea; Problemas al guardar los datos del serial" + JSON.stringify(recibam));
                  await API.graphql({ query: updateRecibaSerialesMP, variables: { input: { ...recibam, id: recibaSerialMPID, rsUpdatedAt: upRecibaS.data.updateRecibaSeriales.updatedAt } }, });

                }
              }
              setMensajeAlert(
                "Después del guardado: " +
                afectados +
                " " +
                JSON.stringify(recibam)
              );
              afectados++;
            }
          }
        })
      );
      window.scrollTo(0, 0);
      setMensajeAlert(
        "Operación exitosa, se marcaron " +
        afectados +
        " de " +
        recibaFromAPI.length +
        " registros como embarcados: " + JSON.stringify(recibaFromAPI[0].serialRecibaBTI)
        /*" registros como embarcados, correspondientes a la fecha del: " +
        fechainicial +
        " al: " +
        fechafinal*/
      );
      setColor("primary");
      setAVisible(true);
      setCargando(false);
    } catch (e) {
      window.scrollTo(0, 0);
      //setMensajeAlert("No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar, si el problema persiste, favor de comunicarte a sistemas");
      setColor("warning");
      setAVisible(true);
      setCargando(false);
    }
    return (
      <CSVDownload
        data={recibaFromAPI}
        filename={
          "A embarcar del:  " + fechainicial + " al: " + fechafinal + ".csv"
        }
      />
    );
  }
  //Procedimiento especial para marcar el material fuera de planta
  async function marcarFueradePlanta(recibas) {
    setCargando1(true);
    setAVisibler(false);
    window.scrollTo(0, 0);
    try {
      //Se obtienen los datos de la reciba por ID        
      const mfp = await marcarMaterialFueradePlanta(recibas, userName);
      setMensajeAlertr(mfp.mensaje);
      setColorr(mfp.color);
      setAVisibler(true);
      setCargando1(false);
      fetchReciba(comCAS, true, buscarporFecha, searchByReciba, searchReciba);
    } catch (e) {
      window.scrollTo(0, 0);
      setMensajeAlertr(e.message);
      setColorr("warning");
      setAVisibler(true);
      setCargando1(false);
    }
  }
  //Obtiene los datos guardados de Reciba
  async function fetchReciba(agregarCAS, guardandoSerial, bporfecha, rsearchByReciba, rsearchReciba) {
    setEmbarcando({});
    setCargando1(true);
    if (!guardandoSerial) { setAVisibler(false); }
    var pag = 1;
    var bandera = 1;
    var num = 0;
    //searchByReciba === "fecha de reciba"
    let filter = agregarCAS === false ? bporfecha === true ?
      {
        and: [
          {
            activo: {
              eq: true,
            },
          },
          {
            clienteID: {
              eq: clienteID
            }
          },
          {
            fechaDeReciba: {
              ge: rfechainiag,
            },
          },
          {
            fechaDeReciba: {
              le: rfechafinag,
            },
          },
          {
            or: [
              {
                piezasAEmbarcar: {
                  gt: 0,
                },
              },
              {
                piezasCtnaNAEmbarcar: {
                  gt: 0,
                },
              },
            ],
          },
        ],
      } :
      {
        and: [
          {
            activo: {
              eq: true,
            },
          },
          {
            clienteID: {
              eq: clienteID
            }
          },
          {
            or: [
              {
                piezasAEmbarcar: {
                  gt: 0,
                },
              },
              {
                piezasCtnaNAEmbarcar: {
                  gt: 0,
                },
              },
            ],
          },
        ],
      } : bporfecha === true ?
      {
        and: [
          {
            activo: {
              eq: true,
            },
          },
          {
            clienteID: {
              eq: "66ef5748-ff06-436e-a566-6b9b0d2a8d9d"
            }
          },
          {
            fechaDeReciba: {
              ge: rfechainiag,
            },
          },
          {
            fechaDeReciba: {
              le: rfechafinag,
            },
          },
          {
            or: [
              {
                piezasAEmbarcar: {
                  gt: 0,
                },
              },
              {
                piezasCtnaNAEmbarcar: {
                  gt: 0,
                },
              },
            ],
          },
        ],
      } :
      {
        and: [
          {
            activo: {
              eq: true,
            },
          },
          {
            clienteID: {
              eq: "66ef5748-ff06-436e-a566-6b9b0d2a8d9d"
            }
          },
          {
            or: [
              {
                piezasAEmbarcar: {
                  gt: 0,
                },
              },
              {
                piezasCtnaNAEmbarcar: {
                  gt: 0,
                },
              },
            ],
          },
        ],
      };

    //Se obtienen los datos de los seriales.
    var apiData = await GetRecibaSerialesMP(filter);
    //Se ordenan los datos
    const recibaFromAPI = apiData.sort((a, b) =>
      a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0
    );

    await Promise.all(
      recibaFromAPI.map(async (reciba) => {
        reciba.piezasPintadas = reciba.piezasPintadas ? reciba.piezasPintadas -
          ((reciba.PiezasEPintadas ? reciba.PiezasEPintadas : 0) +
            ((reciba.piezasNRecuperadas ? reciba.piezasNRecuperadas : 0) === 0 ?
              (reciba.PiezasENRecuperadas ? reciba.PiezasENRecuperadas : 0) :
              (reciba.piezasNRecuperadas ? reciba.piezasNRecuperadas : 0) >=
                (reciba.PiezasENRecuperadas ? reciba.PiezasENRecuperadas : 0) ? 0 :
                ((reciba.PiezasENRecuperadas ? reciba.PiezasENRecuperadas : 0) -
                  (reciba.piezasNRecuperadas ? reciba.piezasNRecuperadas : 0))))
          : 0;
        reciba.piezasPintadasPC = reciba.piezasPintadasPC ? reciba.piezasPintadasPC -
          ((reciba.PiezasEPintadasPC ? reciba.PiezasEPintadasPC : 0) +
            ((reciba.piezasNRecuperadasPC ? reciba.piezasNRecuperadasPC : 0) === 0 ?
              (reciba.PiezasENRecuperadasPC ? reciba.PiezasENRecuperadasPC : 0) :
              (reciba.piezasNRecuperadasPC ? reciba.piezasNRecuperadasPC : 0) >=
                (reciba.PiezasENRecuperadasPC ? reciba.PiezasENRecuperadasPC : 0) ? 0 :
                ((reciba.PiezasENRecuperadasPC ? reciba.PiezasENRecuperadasPC : 0) -
                  (reciba.piezasNRecuperadasPC ? reciba.piezasNRecuperadasPC : 0))))
          : 0;
        reciba.piezasPintadasDisponibles = reciba.Pcoat === true ? reciba.piezasPintadasPC : reciba.piezasPintadas;

        /*reciba.piezasNRecuperadas = reciba.piezasNRecuperadas
          ? reciba.piezasNRecuperadas -
          (reciba.PiezasENRecuperadas ? reciba.PiezasENRecuperadas : 0)
          : 0;*/

        reciba.PiezasNRecuperadasDisponibles = (reciba.piezasCtnaPintadasPC ? reciba.piezasCtnaPintadasPC : 0) +
          (reciba.piezasCtnaPintadas ? reciba.piezasCtnaPintadas : 0);

        reciba.indexpag = pag;
        reciba.registro = num;
        num++;
        bandera++;
        if (bandera > recordPerPage) {
          bandera = 1;
          pag++;
        }

        return reciba;
      })
    );
    setRecibaSinFiltro(recibaFromAPI);
    if (agregarCAS === false) {
      setBusquedaxClientes(clienteID);
      busqueda(
        recibaFromAPI,
        clienteID,
        rsearchByReciba,
        rsearchReciba,
        currentPage,
        currentPageNPintado,
        aMRecuperado
      );
    } else {
      setBusquedaxClientes("66ef5748-ff06-436e-a566-6b9b0d2a8d9d");
      busqueda(
        recibaFromAPI,
        "66ef5748-ff06-436e-a566-6b9b0d2a8d9d",
        rsearchByReciba,
        rsearchReciba,
        currentPage,
        currentPageNPintado,
        aMRecuperado
      );
    }
    setCargando1(false);
    //return recibaFromAPI;
  }

  //Obtiene los datos guardados de embarquesSeriales por el id de embarque
  async function fetchEmbarqueSerial(embarquesID) {
    setAVisible(false);
    setCargando(true);
    let filter = {
      and: [
        {
          embarqueID: {
            eq: embarquesID,
          },
        },
        {
          activo: {
            eq: true,
          },
        },
      ],
    };
    var EmbarquesFromAPI = [];
    var listSerialesEditar = [];
    var listSerialesOriginal = [];
    //Se obtienen los datos del embarque
    var Embarque = await GetEmbarquesID(embarquesID);
    if (Embarque.serialesEID) {
      var apiData = await ObtenerSerialesEmbarques(Embarque.serialesEID);
      /*} else {
        var apiData = await GetEmbarquesSeriales(filter);
      }*/
      //Se ordenan los datos del embarque
      EmbarquesFromAPI = apiData.sort((a, b) =>
        a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0
      );

      await Promise.all(
        EmbarquesFromAPI.map(async (fembarque) => {
          if (!fembarque.clienteEntregaID) {
            fembarque.clienteEntregaID = embarques.clienteID;
            fembarque.clienteEntrega = embarques.cliente;
          }
          const datosDesgloce = (Embarque.desgloceVer ? Embarque.desgloceVer : false) === true ?
            fembarque.desgloceInsercion ? await decodificarTextoJSON(fembarque.desgloceInsercion) : [] : [];
          //fembarque.desgloceDetalles = datosDesgloce;
          if (datosDesgloce.length > 0) {
            await Promise.all(
              datosDesgloce.map(async (dembarque) => {
                if ((dembarque.activo ? dembarque.activo : "true") === "true") {
                  //Se agregan datos para validar los daros originales.
                  dembarque.piezasEmbarcadas =
                    (parseInt(dembarque.piezasPintadas ? dembarque.piezasPintadas : 0) +
                      parseInt(dembarque.piezasNRecuperadas ? dembarque.piezasNRecuperadas : 0) +
                      parseInt(dembarque.piezasPintadasExtra ? dembarque.piezasPintadasExtra : 0));
                  dembarque.pPintadasAnterior = dembarque.piezasPintadas;
                  dembarque.piezasPintadasExtra = dembarque.piezasPintadasExtra;
                  dembarque.pPintadasAnteriorExtra = dembarque.piezasPintadasExtra;
                  dembarque.pNRecuperadasAnterior = dembarque.piezasNRecuperadas;
                  dembarque.pNoPintadasOriginal = dembarque.piezasNoPintadas;
                  dembarque.pNRecuperadasOriginal = dembarque.piezasNRecuperadas;
                  dembarque.pPintadasOriginal = dembarque.piezasPintadas;
                  dembarque.modificado = false;
                  dembarque.activo = true;
                  listSerialesEditar.push({ ...fembarque, ...dembarque });
                  listSerialesOriginal.push({ ...fembarque, ...dembarque });
                }
                return dembarque;
              })
            );

          } else {
            fembarque.pPintadasAnterior = fembarque.piezasPintadas;
            fembarque.pPintadasAnteriorExtra = fembarque.piezasPintadasExtra
            fembarque.pNRecuperadasAnterior = fembarque.piezasNRecuperadas;
            fembarque.pNoPintadasOriginal = fembarque.piezasNoPintadas;
            fembarque.modificado = false;
            fembarque.activo = true;
            listSerialesEditar.push({ ...fembarque });
            listSerialesOriginal.push({ ...fembarque });
          }
          return fembarque;
        })
      );
    }
    setEmbarqueSerialEditar(listSerialesEditar);
    setAVisible(false);
    setCargando(false);
    return listSerialesOriginal;
  }

  async function fetchEmbarqueSerialImprimir(EmbarquesFromAPI, desgloceVer) {
    //Se ordenan los datos del embarque
    EmbarquesFromAPI = EmbarquesFromAPI.sort((a, b) =>
      a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0
    );
    var listSerialesInput = [];
    await Promise.all(
      EmbarquesFromAPI.map(async (fembarque) => {
        if (!fembarque.clienteEntregaID) {
          fembarque.clienteEntregaID = embarques.clienteID;
          fembarque.clienteEntrega = embarques.cliente;
        }
        fembarque.modificado = false;
        /*const datosDesgloce = (desgloceVer ? desgloceVer : false) === true ?
          fembarque.desgloceInsercion ? await decodificarTextoJSON(fembarque.desgloceInsercion) : [] : [];
        fembarque.desgloceDetalles = datosDesgloce;
         if (datosDesgloce.length > 0) {
           await Promise.all(
             datosDesgloce.map(async (dembarque) => {
               //Se agregan datos para validar los daros originales.
               dembarque.piezasPintadas = 1000;// parseInt(dembarque.piezasPintadas) + parseInt(dembarque.piezasPintadasExtra ? dembarque.piezasPintadasExtra : 0);
               dembarque.pPintadasAnterior = dembarque.piezasPintadas;
               dembarque.piezasPintadasExtra = dembarque.piezasPintadasExtra;
               dembarque.pPintadasAnteriorExtra = dembarque.piezasPintadasExtra
               dembarque.pNRecuperadasAnterior = dembarque.piezasNRecuperadas;
               dembarque.pNoPintadasOriginal = dembarque.piezasNoPintadas;
               dembarque.pNRecuperadasOriginal = dembarque.piezasNRecuperadas;
               dembarque.pPintadasOriginal = dembarque.piezasPintadas;
               listSerialesInput.push({ ...fembarque, ...dembarque });
               return dembarque;
             })
           );
 
         } else {*/
        fembarque.piezasPintadas = parseInt(fembarque.piezasPintadas) +
          parseInt(fembarque.piezasPintadasExtra ? fembarque.piezasPintadasExtra : 0);
        fembarque.pPintadasAnterior = fembarque.piezasPintadas;
        fembarque.pPintadasAnteriorExtra = fembarque.piezasPintadasExtra
        fembarque.pNRecuperadasAnterior = fembarque.piezasNRecuperadas;
        fembarque.pNoPintadasOriginal = fembarque.piezasNoPintadas;
        listSerialesInput.push({ ...fembarque });
        //}
        return fembarque;
      })
    );
    return listSerialesInput;
  }

  function buscarpor(e) {
    setAVisible(false);
    setSearchBy(e.target.value);
    if (search && e.target.value !== "fecha")
      busquedaEmbarques(
        embarquesSinFiltro,
        e.target.value,
        search,
        currentPageEmbarques
      );
  }
  function onSearch(e) {
    setAVisible(false);
    busquedaEmbarques(
      embarquesSinFiltro,
      searchBy,
      search,
      currentPageEmbarques
    );
  }

  function onSearchFecha(e) {
    setAVisible(false);
    setSearch(e.target.value);
    busquedaEmbarques(
      embarquesSinFiltro,
      searchBy,
      e.target.value,
      currentPageEmbarques
    );
  }
  function onSearchReciba(e) {
    setAVisible(false);
    setSearchReciba(e.target.value);
    busqueda(
      recibaSinFiltro,
      busquedaxClientes,
      searchByReciba,
      e.target.value,
      currentPage,
      currentPageNPintado,
      aMRecuperado
    );
  }
  function buscarporReciba(e) {
    setAVisible(false);
    setSearchByReciba(e.target.value);
    busqueda(recibaSinFiltro, busquedaxClientes, e.target.value, searchReciba, currentPage, aMRecuperado);
  }
  function handleRemoveClickServicios(index, list) {
    //Se elimina el registro de      
    list.splice(index, 1);
    return list;
  }

  function handleRemoveClick(index, list) {
    /*Se resta la cantidad embarcada */
    busqueda(
      recibaSinFiltro,
      busquedaxClientes,
      searchByReciba,
      searchReciba,
      currentPage,
      currentPageNPintado,
      aMRecuperado
    );

    //Se elimina el registro de
    if (!editar || !list[index].id) {
      list.splice(index, 1);
    }
    else {
      list[index].activo = false;
      list[index].modificado = cambio(index, list);
    }

    revisarDatosActivos(list);
    return list;
  }
  function cancelarEmbarques() {
    fetchEmbarques(rfechaini, rfechafin);
    setEmbarqueParticular(false);
    setInputList([]);
    setInputListServicios([]);
    setServicios(false);
    setEmbarqueSerialEditar([]);
    setEditar(false);
    toggle1("1");
    setTituloTab(pembarques ? "Nuevo embarque" : "Detalle de embarque");
    setFechaDeEmbarque("");
    setAtencionA("");
    setAMRecuperado(false);
    setOrdenDeCompra("");
    setClienteID("");
    setRCliente("");
    setClienteEntregaID("");
    setRClienteEntrega("");
    setRClienteFacturarA("");
  }
  function revisarDatosActivos(list) {
    var disabled = true;
    list.map((embarques, i) => {
      if (embarques.activo) {
        disabled = false;
      }
    });
    setisDisabled(disabled);
  }
  //Revisa cambios en los inputs
  function onChangesEmbarcando(e) {
    e.persist();
    const { name, value } = e.target;
    const re = /^[0-9\.]+$/;
    if (
      name === "piezasPintadas" ||
      name === "piezasNRecuperadas" ||
      name === "materialEnCantidad"
    ) {
      if (e.target.value === "" || re.test(e.target.value)) {
        setEmbarcando(() => ({ ...embarcando, [e.target.name]: e.target.value }));
      }
    } else {
      setEmbarcando(() => ({ ...embarcando, [e.target.name]: e.target.value }));
    }
  }
  //Revisa si hay cambios en los datos
  function cambio(index, list) {
    setisDisabled(true);
    var modificado = false;
    if (((list[index].serialNRecuperado ? list[index].serialNRecuperado : "") !=
      (embarqueSerialEditar[index].serialNRecuperado ? embarqueSerialEditar[index].serialNRecuperado : "")) ||
      (list[index].piezasPintadas != embarqueSerialEditar[index].piezasPintadas) ||
      (list[index].piezasPintadasExtra != embarqueSerialEditar[index].piezasPintadasExtra) ||
      (list[index].piezasNoPintadas != embarqueSerialEditar[index].piezasNoPintadas) ||
      (list[index].materialEn != embarqueSerialEditar[index].materialEn) ||
      (list[index].materialEnCantidad != embarqueSerialEditar[index].materialEnCantidad) ||
      (list[index].comentarios != embarqueSerialEditar[index].comentarios) ||
      (list[index].activo != embarqueSerialEditar[index].activo) ||
      (list[index].piezasNRecuperadas != embarqueSerialEditar[index].piezasNRecuperadas)) {
      modificado = true;
      setisDisabled(false);
    }
    if (editar === true) {
      if (fechaDeEmbarque != embarqueEditando.fechaDeEmbarque ||
        atencionA != embarqueEditando.atencionA ||
        ordenDeCompra != embarqueEditando.ordenDeCompra ||
        clienteID != embarqueEditando.clienteID ||
        rCliente != embarqueEditando.cliente ||
        clienteEntregaID != embarqueEditando.clienteEntregaID ||
        rClienteEntrega != embarqueEditando.clienteEntrega ||
        rClienteFacturarA != embarqueEditando.facturarA ||
        iTotalNParte != embarqueEditando.totalNumerodeParte ||
        sinTotalScrap != embarqueEditando.sinTotalScrap ||
        sinTotalScrapFactura != embarqueEditando.sinTotalScrapFactura ||
        desgloceVer != embarqueEditando.desgloceVer) {
        setisDisabled(false);
      }
    }

    return modificado;
  }
  function cambioDatosEmbarque(e) {
    //Si es una modificación de los datos
    if (editar === true) {
      setisDisabled(true);
      setCambiosCheck(false);
      //Si hay cambios en alguno de los datos de embarques
      if ((e.target.name === "fechaDeEmbarque" ? e.target.value : fechaDeEmbarque) != embarqueEditando.fechaDeEmbarque ||
        (e.target.name === "atencionA" ? e.target.value : atencionA) != embarqueEditando.atencionA ||
        (e.target.name === "ordenDeCompra" ? e.target.value : ordenDeCompra) != embarqueEditando.ordenDeCompra ||
        (e.target.name === "clienteID" ? e.target.value : clienteID) != embarqueEditando.clienteID ||
        (e.target.name === "rCliente" ? e.target.value : rCliente) != embarqueEditando.cliente ||
        (e.target.name === "clienteEntregaID" ? e.target.value : clienteEntregaID) != embarqueEditando.clienteEntregaID ||
        (e.target.name === "rClienteEntrega" ? e.target.value : rClienteEntrega) != embarqueEditando.clienteEntrega ||
        (e.target.name === "rClienteFacturarA" ? e.target.value : rClienteFacturarA) != embarqueEditando.facturarA) {
        //Se marcan como modificados todos los registros del serial.
        inputList.map((seriales) => {
          seriales.modificado = true;
        });
        //También se habilita el botón de guardar
        setisDisabled(false);
      } else {
        if ((e.target.name === "iTotalNParte" ? e.target.checked : iTotalNParte) != embarqueEditando.totalNumerodeParte ||
          (e.target.name === "sinTotalScrap" ? e.target.checked : sinTotalScrap) != embarqueEditando.sinTotalScrap ||
          (e.target.name === "sinTotalScrapFactura" ? e.target.checked : sinTotalScrapFactura) != embarqueEditando.sinTotalScrapFactura ||
          (e.target.name === "desgloceVer" ? e.target.checked : desgloceVer) != embarqueEditando.desgloceVer) {
          setCambiosCheck(true);
          setisDisabled(false);
        }
      }
    } else {
      const cambiosIL = inputList.filter(embarqueS => embarqueS.modificado === true);
      if (cambiosIL[0]) {
        setisDisabled(false);
      }
    }
  }
  // handle input change
  function handleInputChange(e, index, list) {
    const { name, value } = e.target;
    const re = /^[0-9\.]+$/;
    if (
      name === "piezasPintadas" ||
      name === "piezasNRecuperadas" ||
      name === "materialEnCantidad"
    ) {
      if (e.target.value === "" || re.test(e.target.value)) {
        list[index][name] = value;//isNumber(value) (e.target.value !== "" && e.target.value !== "." && e.target.value !== "0.") ? parseFloat(value) : 
      }
    } else {
      list[index][name] = value;
    }
    list[index].modificado = cambio(index, list);
    return list;
  }
  // handle input change
  function handleInputChangeServicios(e, index, list) {
    const { name, value } = e.target;
    const re = /^[0-9\.]+$/;
    if (
      name === "piezasPintadas" || name === "materialEnCantidad"
    ) {
      if (e.target.value === "" || re.test(e.target.value)) {
        list[index][name] = value;
        list[index].updatedAt = new Date();
        list[index].Reg_Mod_Usuario = userName;
      }
    } else {
      list[index][name] = value;
      list[index].updatedAt = new Date();
      list[index].Reg_Mod_Usuario = userName;
    }
    return list;
  }

  function handleInputChangeEmbarque(e, list) {
    const { name, value } = e.target;
    list.map((embarque, i) => {
      list[i][name] = value;
    });
    return list;
  }
  function handleInputChangeMaterialEn(e, index, list) {
    const { name, value } = e.target;
    inputList.map((seriales) => {
      if (seriales.packingindex === list[index].packingindex) {
        seriales.packing = value;
      }
    });
    list[index][name] = value;
    return list;
  }
  function clicEliminar(embarque) {
    setEmbarqueEliminar(embarque);
    setModal(!modal);
  }
  //Embarque particular
  async function clicEmbarqueParticular(recibamp, MaterialPintado) {
    setAVisibler(false);
    setDRegresarAE(false);
    setEmbarqueParticular(true);
    var lista = {};
    //const piezasPintadas = recibap.piezasPintadas > 0 ? parseInt(recibap.piezasPintadas) - parseInt(recibap.PiezasEPintadas ? recibap.PiezasEPintadas : 0) : 0;
    /*const piezasNRecuperadas = aMRecuperado
      ? parseInt(recibap.piezasNRecuperadas) -
      parseInt(recibap.PiezasENRecuperadas ? recibap.PiezasENRecuperadas : 0)
      : 0;*/
    const recibap = await GetRecibaSerialesID(recibamp.recibaSerialID);

    recibap.piezasPintadas = recibap.piezasPintadas ? recibap.piezasPintadas -
      ((recibap.PiezasEPintadas ? recibap.PiezasEPintadas : 0) +
        ((recibap.piezasNRecuperadas ? recibap.piezasNRecuperadas : 0) === 0 ?
          (recibap.PiezasENRecuperadas ? recibap.PiezasENRecuperadas : 0) :
          (recibap.piezasNRecuperadas ? recibap.piezasNRecuperadas : 0) >=
            (recibap.PiezasENRecuperadas ? recibap.PiezasENRecuperadas : 0) ? 0 :
            ((recibap.PiezasENRecuperadas ? recibap.PiezasENRecuperadas : 0) -
              (recibap.piezasNRecuperadas ? recibap.piezasNRecuperadas : 0))))
      : 0;
    recibap.piezasPintadasPC = recibap.piezasPintadasPC ? recibap.piezasPintadasPC -
      ((recibap.PiezasEPintadasPC ? recibap.PiezasEPintadasPC : 0) +
        ((recibap.piezasNRecuperadasPC ? recibap.piezasNRecuperadasPC : 0) === 0 ?
          (recibap.PiezasENRecuperadasPC ? recibap.PiezasENRecuperadasPC : 0) :
          (recibap.piezasNRecuperadasPC ? recibap.piezasNRecuperadasPC : 0) >=
            (recibap.PiezasENRecuperadasPC ? recibap.PiezasENRecuperadasPC : 0) ? 0 :
            ((recibap.PiezasENRecuperadasPC ? recibap.PiezasENRecuperadasPC : 0) -
              (recibap.piezasNRecuperadasPC ? recibap.piezasNRecuperadasPC : 0))))
      : 0;
    recibap.piezasPintadasDisponibles = recibap.Pcoat === true ? recibap.piezasPintadasPC : recibap.piezasPintadas;

    recibap.piezasNRecuperadas = recibap.piezasNRecuperadas ? recibap.piezasNRecuperadas -
      (recibap.PiezasENRecuperadas ? recibap.PiezasENRecuperadas : 0) : 0;
    recibap.PiezasNRecuperadasDisponibles = recibap.piezasNRecuperadas
      ? recibap.piezasNRecuperadas - (recibap.PiezasENRecuperadas ? recibap.PiezasENRecuperadas : 0) : 0;


    var numerodeParteO = {};
    if ((!recibap.numerodeParteSalida ? "" : recibap.numerodeParteSalida) === "" ||
      (!recibap.poEmbarques ? "" : recibap.poEmbarques) === "") {
      numerodeParteO = await GetProductosID(recibap.productoID);
    }
    lista = {
      fechaDeEmbarque: "",
      numero: 0,
      recibaSerialID: recibap.id,
      clienteID: recibap.clienteID,
      productoID: recibap.productoID,
      cliente: recibap.cliente,
      numerodeParte: recibap.numerodeParte,
      numerodeParteSalida: numerodeParteO.numerodeParteSalida ? numerodeParteO.numerodeParteSalida : recibap.numerodeParteSalida,
      poEmbarques: numerodeParteO.poEmbarques ? numerodeParteO.poEmbarques : recibap.poEmbarques,
      fechaDeReciba: recibap.fechaDeReciba,
      MFGFecha: recibap.MFGFecha,
      descripcion: recibap.descripcion,
      serial: recibap.serial,
      serialRecibaBTI: recibap.serialRecibaBTI,
      lote: recibap.lote,
      packing: recibap.packing,
      po: recibap.po,
      piezasPintadas: MaterialPintado === true ? recibap.Pcoat === true ? recibap.piezasPintadasPC : recibap.piezasPintadas : 0,
      piezasNRecuperadasE: aMRecuperado,
      piezasNRecuperadas: aMRecuperado ? parseInt(recibap.piezasCtnaPintadasPC ? recibap.piezasCtnaPintadasPC : 0) + parseInt(recibap.piezasCtnaPintadas ? recibap.piezasCtnaPintadas : 0) : 0,
      pPintadasOriginal: MaterialPintado === true ? recibap.Pcoat === true ? recibap.piezasPintadasPC : recibap.piezasPintadas : 0,
      pNRecuperadasOriginal: aMRecuperado ? parseInt(recibap.piezasCtnaPintadasPC ? recibap.piezasCtnaPintadasPC : 0) + parseInt(recibap.piezasCtnaPintadas ? recibap.piezasCtnaPintadas : 0) : 0,
      materialEn: recibap.materialEn,
      materialEnCantidad: recibap.materialEnCantidad,
      activo: true,
      comentarios: "",
      atencionA: "",
      ordenDeCompra: "",
      registro: recibamp.registro,
      piezasNoPintadas: MaterialPintado === false ? recibap.piezasCtnaNAEmbarcar ? recibap.piezasCtnaNAEmbarcar : 0 : 0,
      pNoPintadasOriginal: MaterialPintado === false ? recibap.piezasCtnaNAEmbarcar ? recibap.piezasCtnaNAEmbarcar : 0 : 0,
      piezasCtnaNRecuperadas: recibap.piezasCtnaNRecuperadas ? recibap.piezasCtnaNRecuperadas : 0,
      updatedAt: recibap.updatedAt,
      MaterialPintado: MaterialPintado,
      piezasCtnaPintadasPC: recibap.piezasCtnaPintadasPC,
      piezasCtnaPintadas: recibap.piezasCtnaPintadas
    };

    if (MaterialPintado === true) {
      recibaSinFiltro[recibamp.registro].piezasAEmbarcar = 0;
      recibaSinFiltro[recibamp.registro].piezasEmbarcadas =
        parseInt(recibap.piezasPintadas ? recibap.piezasPintadas : 0) +
        recibap.piezasNRecuperadas;
    }
    if (MaterialPintado === false) {
      recibaSinFiltro[recibamp.registro].piezasCtnaNAEmbarcar = 0;
      recibaSinFiltro[recibamp.registro].piezasCtnaEmbarcadas =
        parseInt(
          recibap.piezasCtnaNAEmbarcar ? recibap.piezasCtnaNAEmbarcar : 0
        ) + recibaSinFiltro[recibamp.registro].piezasCtnaEmbarcadas;
    }
    recibaSinFiltro[recibamp.registro].Reg_Mod_Usuario = userName;
    recibaSinFiltro[recibamp.registro].modificado = true;
    const recibasf = recibaSinFiltro;
    busqueda(
      recibasf,
      busquedaxClientes,
      searchByReciba,
      searchReciba,
      currentPage,
      currentPageNPintado,
      aMRecuperado
    );
    if (recibap.cliente === "Olson Internacional") {
      if (!ordenDeCompra.toLowerCase().includes(recibap.lote.toLowerCase())) {
        setOrdenDeCompra(ordenDeCompra === "" ? recibap.lote : ordenDeCompra + ", " + recibap.lote);
      }
    }
    setEmbarcando(lista);
    //toggle1('3');
  }
  function clicCHAMNRecuperado() {
    //async function busqueda(recibasinf,busquedaxClientesb,searchb,search,currentPage,currentPageNPintado)
    busqueda(
      recibaSinFiltro,
      busquedaxClientes,
      searchByReciba,
      searchReciba,
      currentPage,
      currentPageNPintado,
      !aMRecuperado,
    );
    setAMRecuperado(!aMRecuperado);
  }
  async function clicBusquedaporFecha(e) {

    setBuscarporFecha(e.target.checked);
    await fetchReciba(comCAS, false, e.target.checked, buscarporFecha, searchByReciba, searchReciba);
  }
  //Revisa cambios en los inputs
  async function clicAgregarMaterial(serial) {
    setReciba([]);
    setRecibaDevolucion([]);
    setSearchByReciba("serial");
    setEmbarqueParticular(false);
    setSearchReciba(serial);
    setComCAS(false);
    //setisDisabled(true);
    setAVisibler(false);
    setModal2(!modal2);
    await fetchReciba(false, false, buscarporFecha, "serial", serial);
  }
  //Agrega un servicio al input
  async function AgregarServicios() {
    setServicios(true);
    setInputListServicios([...inputListServicios, { ...serviciosIniciales, orden: inputListServicios.length, createdAt: new Date() }])
  }
  async function clicEditar(embarquei) {
    setAVisible(false);
    setCargando(true);
    setisDisabled(true);
    if (embarquei) {
      //Se obtienen los datos actualizados del embarque
      const embarque = await GetEmbarquesID(embarquei.id);
      if (!embarque.clienteEntregaID) {
        embarque.clienteEntregaID = embarques.clienteID;
        embarque.clienteEntrega = embarques.cliente;
      }
      //embarque.cantidadDisponible = 20000;

      setEmbarqueEditando(embarque);
      setEmbarcando({});

      const listas = (!embarque.servicioExtraEmbarques || (embarque.servicioExtraEmbarques && embarque.servicioExtraEmbarques.length <= 0)) ?
        embarque.serialesEID ? await fetchEmbarqueSerial(embarque.id) : [] : [];
      setInputList(listas);
      const listaServicios = embarque.servicioExtraEmbarques ? embarque.servicioExtraEmbarques.length > 0 ?
        await ObtenerServiciosEmbarques(embarque.servicioExtraEmbarques) : [] : [];
      setInputListServicios(listaServicios.servicios ? listaServicios.servicios : []);
      setServicios(listaServicios.servicios ? true : false);
      setClienteID(embarque.clienteID);
      setRCliente(embarque.cliente);
      setClienteEntregaID(embarque.clienteEntregaID);
      setRClienteEntrega(embarque.clienteEntrega);
      setRClienteFacturarA(
        embarque.facturarA ? embarque.facturarA : embarque.clienteEntrega
      );
      setFechaDeEmbarque(embarque.fechaDeEmbarque);
      setAtencionA(embarque.atencionA);
      setOrdenDeCompra(embarque.ordenDeCompra);
      setNumeroP(embarque.numero);
      setITotalNParte(embarque.totalNumerodeParte ? embarque.totalNumerodeParte : false);
      setSinTotalScrapt(embarque.sinTotalScrap ? embarque.sinTotalScrap : false);
      setSinTotalScraptFactura(embarque.sinTotalScrapFactura ? embarque.sinTotalScrapFactura : false);
      setDesgloceVer(embarque.desgloceVer ? embarque.desgloceVer : false);
    }
    setEditar(true);
    setTituloTab("Editar embarque");
    setCargando(false);
    toggle1("2");
  }
  async function clicMostrar(embarque) {
    setAVisible(false);
    setCargando(false);
    const listas = (!embarque.servicioExtraEmbarques || (embarque.servicioExtraEmbarques && embarque.servicioExtraEmbarques.length <= 0)) ?
      embarque.serialesEID ? await fetchEmbarqueSerial(embarque.id) : [] : [];
    setInputList(listas);
    const listaServicios = embarque.servicioExtraEmbarques ? embarque.servicioExtraEmbarques.length > 0 ?
      await ObtenerServiciosEmbarques(embarque.servicioExtraEmbarques) : [] : [];
    setInputListServicios(listaServicios.servicios ? listaServicios.servicios : []);
    setClienteID(embarque.clienteID);
    setRCliente(embarque.cliente);
    setClienteEntregaID(embarque.clienteEntregaID);
    setRClienteEntrega(embarque.clienteEntrega);
    setRClienteFacturarA(
      embarque.facturarA ? embarque.facturarA : embarque.clienteEntrega
    );
    setFechaDeEmbarque(embarque.fechaDeEmbarque);
    setAtencionA(embarque.atencionA);
    setOrdenDeCompra(embarque.ordenDeCompra);
    setNumeroP(embarque.numero);
    setEditar(true);
    setTituloTab("Detalle de embarque");
    toggle1("2");
  }
  /*async function clicMostrarDatosSerial(embarque) {
    setAVisible(false);
    setCargando(false);
  
    setEditar(true);
    setModal2(true);
  }*/
  async function clicImprimir(embarque) {
    setAVisible(false);
    setCargando(false);
    const listas = (!embarque.servicioExtraEmbarques || (embarque.servicioExtraEmbarques && embarque.servicioExtraEmbarques.length <= 0)) ?
      embarque.serialesEID ? await fetchEmbarqueSerial(embarque.id) : [] : [];
    const listaServicios = embarque.servicioExtraEmbarques ? embarque.servicioExtraEmbarques.length > 0 ?
      await ObtenerServiciosEmbarques(embarque.servicioExtraEmbarques) : [] : [];
    const comentariosLista = listas.filter(embarqueS => (embarqueS.comentarios ? embarqueS.comentarios : "") != "");
    const comentariosservicios = listaServicios.servicios ? listaServicios.servicios.filter(embarqueS => (embarqueS.comentarios ? embarqueS.comentarios : "") != "") : "";
    setImprimirComentario((comentariosLista.length > 0 || comentariosservicios.length > 0) ? true : false);
    setClienteID(embarque.clienteID);
    setRCliente(embarque.cliente);
    setClienteEntregaID(embarque.clienteEntregaID);
    setRClienteEntrega(embarque.clienteEntrega);
    setRClienteFacturarA(
      embarque.facturarA ? embarque.facturarA : embarque.clienteEntrega
    );
    setFechaDeEmbarque(embarque.fechaDeEmbarque);
    setAtencionA(embarque.atencionA);
    setOrdenDeCompra(embarque.ordenDeCompra);
    setNumeroP(embarque.numero);
    setAMRecuperado(
      embarque.piezasNRecuperadas
        ? embarque.piezasNRecuperadas > 0
          ? true
          : false
        : false
    );
    var totalCaja = 0;
    var totalTarima = 0;
    var totalContenedores = 0;
    //Orden por número de parte
    const listapNP = listas.sort((a, b) =>
      a.numerodeParte > b.numerodeParte
        ? 1
        : a.numerodeParte < b.numerodeParte
          ? -1
          : 0
    );
    //Total por número de parte
    var totNParte = [];
    var numeroParte = "";
    var totnP = 0;
    var totCNP = 1;
    var totEmbarcadas = 0;
    await Promise.all(
      listapNP.map(async (embarque, j) => {
        if (listapNP.length > j + 1) {
          if (numeroParte === embarque.numerodeParte) {
            totnP += embarque.piezasEmbarcadas;
            totCNP++;
            if (numeroParte != listapNP[j + 1].numerodeParte) {
              totNParte.push({ ...embarque, totalNumeroParte: totnP, totalCantidad: totCNP })
            }
          } else {
            numeroParte = embarque.numerodeParte;
            totnP = embarque.piezasEmbarcadas;
            totCNP = 1;
            if (numeroParte != listapNP[j + 1].numerodeParte) {
              totNParte.push({ ...embarque, totalNumeroParte: totnP, totalCantidad: totCNP })
            }
          }
        } else {
          if (numeroParte === embarque.numerodeParte) {
            totnP += embarque.piezasEmbarcadas;
            totCNP++;
            totNParte.push({ ...embarque, totalNumeroParte: totnP, totalCantidad: totCNP })
          } else {
            numeroParte = embarque.numerodeParte;
            totnP = embarque.piezasEmbarcadas;
            totCNP = 1;
            totNParte.push({ ...embarque, totalNumeroParte: totnP, totalCantidad: totCNP })

          }
        }
        totEmbarcadas = totEmbarcadas + parseInt(embarque.piezasEmbarcadas);
        //Se obtiene el total de cajas, contenedores y tarimas.
        if (embarque.materialEn === "Caja") {
          totalCaja = parseFloat(totalCaja) + parseFloat(embarque.materialEnCantidad);
        }
        if (embarque.materialEn === "Contenedor") {
          totalContenedores = parseFloat(totalContenedores) + parseFloat(embarque.materialEnCantidad);
        }
        if (embarque.materialEn === "Tarima") {
          totalTarima = parseFloat(totalTarima) + parseFloat(embarque.materialEnCantidad);
        }
        return embarque;
      })
    );
    //}
    //setSumPiezas(totEmbarcadas);
    //setSumPiezas(parseInt(embarque.piezasEmbarcadas) - parseInt(sinTotalScrap === true ? (embarque.piezasNRecuperadas ? embarque.piezasNRecuperadas : 0) : 0));
    //Se revisa si se tiene que desglosar los detalles de los seriales
    const detallesSeriales = await fetchEmbarqueSerialImprimir(listapNP, embarque.desgloceVer);
    setInputList(detallesSeriales);
    setSumPiezas(listaServicios.servicios ? listaServicios.totalEmbarcadas : totEmbarcadas);
    setSumCajas(listaServicios.servicios ? listaServicios.totalCaja : totalCaja);
    setSumTarimas(listaServicios.servicios ? listaServicios.totalTarima : totalTarima);
    setSumContenedores(listaServicios.servicios ? listaServicios.totalContenedores : totalContenedores);
    setITotalNParte(embarque.totalNumerodeParte ? embarque.totalNumerodeParte : false);
    setSinTotalScrapt(embarque.sinTotalScrap ? embarque.sinTotalScrap : false);
    setTotalNumeroParte(totNParte);
    setInputListServicios(listaServicios.servicios ? listaServicios.servicios : []);
    handlePrint();
  }
  async function clicImprimirEtiqueta(embarque) {
    handlePrint();
  }
  function clicNuevaEmbarque() {
    setEmbarqueEditando({});
    setEmbarcando({});
    setFechaDeEmbarque("");
    setAtencionA("");
    setAMRecuperado(false);
    setClienteID("");
    setRCliente("");
    setClienteEntregaID("");
    setRClienteEntrega("");
    setRClienteFacturarA("");
    setOrdenDeCompra("");
    setInputList([]);
    setInputListServicios([]);
    setServicios(false);
    setEmbarqueSerialEditar([]);
    setEditar(false);
    setComCAS(false);
    setITotalNParte(false);
    setImprimirComentario(false);
    setSinTotalScrapt(false);
    setSinTotalScraptFactura(true);
    setDesgloceVer(false);
    toggle1("2");
  }
  function concatenarPackings(list) {
    const listPackings = list.sort((a, b) =>
      a.packing < b.packing ? 1 : a.packing > b.packing ? -1 : 0
    );
    var vpacking = "";
    var packings = "";
    listPackings.map((packing, i) => {
      if (packing.activo === true && vpacking !== packing.packing) {
        if (i === 0) packings = packing.packing;
        else packings = packings + ", " + packing.packing;
        vpacking = packing.packing;
      }
    });
    return packings;
  }
  function concatenarLotes(list) {
    const serialesreciba = list.sort((a, b) =>
      a.lote < b.lote ? 1 : a.lote > b.lote ? -1 : 0
    );
    var lote = "";
    var lotes = "";
    serialesreciba.map((serial, i) => {
      if (serial.activo === true) {
        if (lote !== serial.lote) {
          if (i === 0) lotes = serial.lote;
          else lotes = lotes + ", " + serial.lote;
          lote = serial.lote;
        }
      }
    });
    return lotes;
  }
  function concatenarNumerosdeParte(list) {
    const serialesreciba = list.sort((a, b) =>
      a.numerodeParte < b.numerodeParte
        ? 1
        : a.numerodeParte > b.numerodeParte
          ? -1
          : 0
    );
    var numerodeParte = "";
    var numerosdeParte = "";
    serialesreciba.map((serial, i) => {
      if (serial.activo === true) {
        if (numerodeParte !== serial.numerodeParte) {
          if (i === 0) numerosdeParte = serial.numerodeParte;
          else numerosdeParte = numerosdeParte + ", " + serial.numerodeParte;
          numerodeParte = serial.numerodeParte;
        }
      }
    });
    return numerosdeParte;
  }
  function sumarCantidadesServicios(list) {
    const totales = { totalPiezas: 0, totalContenedores: 0, seriales: "", numerosdeParte: "", totalPiezasExtra: 0, };
    const seriales = [];//{serial:""}  
    const numerosdeParte = [];// {numerodeParte:""}
    list.map((serial, i) => {
      totales.totalPiezas = totales.totalPiezas + parseInt(serial.piezasPintadas) + parseInt(serial.piezasPintadasExtra ? serial.piezasPintadasExtra : 0);
      totales.totalPiezas = totales.totalPiezas + parseInt(serial.piezasPintadasExtra ? serial.piezasPintadasExtra : 0);
      totales.totalContenedores = totales.totalContenedores + parseInt(serial.materialEnCantidad);
      const serialRepetido = seriales.filter(serials => serials.serial === serial.serial);
      if (serialRepetido.length <= 0) {
        seriales.push({ serial: serial.serial });
        totales.seriales = totales.seriales + (totales.seriales ? ", " : "") + serial.serial;
      }
      const numerodePRepetido = numerosdeParte.filter(numerosps => numerosps.numerodeParte === serial.numerodeParte);
      if (numerodePRepetido.length <= 0) {
        numerosdeParte.push({ numerodeParte: serial.numerodeParte });
        totales.numerosdeParte = totales.numerosdeParte + (totales.numerosdeParte ? ", " : "") + serial.numerodeParte;
      }
    });
    return totales;
  }
  function concatenarSeriales(list) {
    const serialesreciba = list.sort((a, b) =>
      a.serial < b.serial ? 1 : a.serial > b.serial ? -1 : 0
    );
    var cseriale = "";
    var seriales = "";
    serialesreciba.map((serial, i) => {
      if (serial.activo === true) {
        if (cseriale !== serial.serial) {
          if (i === 0) seriales = serial.serial;
          else seriales = seriales + ", " + serial.serial;
          cseriale = serial.serial;
        }
      }
    });
    return seriales;
  }
  function concatenarDatosDesgloceSeriales(list) {
    const serialesreciba = list.sort((a, b) =>
      a.id < b.id ? 1 : a.id > b.id ? -1 : 0);
    //serialNRecuperado=, piezasPintadas=, piezasNRecuperadas=20, piezasNoPintadas=, materialEn=Contenedor, materialEnCantidad=1, comentarios=

    var listSerialesInput = [];
    var desgloceInsercion = [];

    var serialNRecuperado = 0;
    var piezasPintadasExtra = 0;
    var piezasPintadas = 0;
    var piezasNRecuperadas = 0;
    var piezasNoPintadas = 0;
    var materialEn = "";
    var materialEnCantidad = 0;
    var comentarios = "";
    var pPintadasOriginal = 0;
    var pNoPintadasOriginal = 0;
    var pNRecuperadasOriginal = 0;
    var pPintadasAnterior = 0;
    var pPintadasAnteriorExtra = 0;

    serialesreciba.map((embarques, i) => {
      if (embarques.desgloceInsercion) {
        if (embarques.activo === true) {
          serialNRecuperado += parseInt(embarques.serialNRecuperado ? embarques.serialNRecuperado : 0);
          piezasPintadasExtra += parseInt(embarques.piezasPintadasExtra ? embarques.piezasPintadasExtra : 0);
          piezasPintadas += parseInt(embarques.piezasPintadas ? embarques.piezasPintadas : 0);
          piezasNRecuperadas += parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0);
          piezasNoPintadas += parseInt(embarques.piezasNoPintadas ? embarques.piezasNoPintadas : 0);
          materialEn = embarques.materialEn ? embarques.materialEn : materialEn;
          materialEnCantidad += parseInt(embarques.materialEnCantidad ? embarques.materialEnCantidad : 0);
          comentarios = comentarios ? comentarios + (embarques.comentarios ? ("," + embarques.comentarios) : "") :
            (embarques.comentarios ? embarques.comentarios : "");

          pPintadasOriginal += parseInt(embarques.pPintadasOriginal ? embarques.pPintadasOriginal : 0);
          pNoPintadasOriginal += parseInt(embarques.pNoPintadasOriginal ? embarques.pNoPintadasOriginal : 0);
          pNRecuperadasOriginal += parseInt(embarques.pNRecuperadasOriginal ? embarques.pNRecuperadasOriginal : 0);
        }
        pPintadasAnterior += parseInt(embarques.pPintadasAnterior ? embarques.pPintadasAnterior : 0);
        pPintadasAnteriorExtra += parseInt(embarques.pPintadasAnteriorExtra ? embarques.pPintadasAnteriorExtra : 0);

        const desgloceInsercionEmbs = {
          serialNRecuperado: embarques.serialNRecuperado ? embarques.serialNRecuperado : "", piezasPintadasExtra: embarques.piezasPintadasExtra ? embarques.piezasPintadasExtra : "",
          piezasPintadas: embarques.piezasPintadas ? embarques.piezasPintadas : "", piezasNRecuperadas: embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : "",
          piezasNoPintadas: embarques.piezasNoPintadas ? embarques.piezasNoPintadas : "", materialEn: embarques.materialEn ? embarques.materialEn : "",
          materialEnCantidad: embarques.materialEnCantidad ? embarques.materialEnCantidad : "", comentarios: embarques.comentarios ? embarques.comentarios : "",
          Reg_Ins_Usuario: embarques.Reg_Ins_Usuario ? embarques.Reg_Ins_Usuario : "", Reg_Ins_Fecha: embarques.Reg_Ins_Fecha ? embarques.Reg_Ins_Fecha : "",
          activo: embarques.activo
        };
        if (!embarques.desgloceInsercion) {
          desgloceInsercion = (desgloceInsercionEmbs);
        } else {
          desgloceInsercion.push(desgloceInsercionEmbs);
        }

        if (serialesreciba[i + 1]) {
          if (embarques.id != serialesreciba[i + 1].id) {
            const Serialactivo = serialesreciba.filter(serialact => serialact.id === embarques.id && serialact.activo === true);
            const activo = Serialactivo.length > 0 ? true : false;
            const modificado = serialesreciba.filter(serialact => serialact.id === embarques.id && serialact.modificado === true).length > 0 ? true : false;
            listSerialesInput.push({
              ...embarques, serialNRecuperado: serialNRecuperado, piezasPintadas: piezasPintadas,
              piezasPintadasExtra: piezasPintadasExtra,
              piezasNRecuperadas: piezasNRecuperadas, piezasNoPintadas: piezasNoPintadas, materialEn: materialEn,
              materialEnCantidad: materialEnCantidad, comentarios: comentarios,
              modificado: activo === false ? true : modificado, pPintadasAnterior: pPintadasAnterior,
              pPintadasAnteriorExtra: pPintadasAnteriorExtra,
              pPintadasOriginal: pPintadasOriginal, pNoPintadasOriginal: pNoPintadasOriginal,
              pNRecuperadasOriginal: pNRecuperadasOriginal, desgloceInsercion: desgloceInsercion,
              activo: activo
            });

            serialNRecuperado = 0;
            piezasPintadasExtra = 0;
            piezasPintadas = 0;
            piezasNRecuperadas = 0;
            piezasNoPintadas = 0;
            materialEn = "";
            materialEnCantidad = 0;
            comentarios = "";
            pPintadasOriginal = 0;
            pPintadasAnterior = 0;
            pPintadasAnteriorExtra = 0;
            pNoPintadasOriginal = 0;
            pNRecuperadasOriginal = 0;
            desgloceInsercion = [];
          }
        } else {
          const Serialactivo = serialesreciba.filter(serialact => serialact.id === embarques.id && serialact.activo === true);
          const activo = Serialactivo.length > 0 ? true : false;
          const regModificado = serialesreciba.filter(serialact => serialact.id === embarques.id && serialact.modificado === true);
          const modificado = regModificado.length > 0 ? true : false;
          listSerialesInput.push({
            ...embarques, serialNRecuperado: serialNRecuperado, piezasPintadas: piezasPintadas,
            piezasPintadasExtra: piezasPintadasExtra,
            piezasNRecuperadas: piezasNRecuperadas, piezasNoPintadas: piezasNoPintadas, materialEn: materialEn,
            materialEnCantidad: materialEnCantidad, comentarios: comentarios,
            modificado: activo === false ? true : modificado, pPintadasAnterior: pPintadasAnterior,
            pPintadasAnteriorExtra: pPintadasAnteriorExtra,
            pPintadasOriginal: pPintadasOriginal, pNoPintadasOriginal: pNoPintadasOriginal,
            pNRecuperadasOriginal: pNRecuperadasOriginal, desgloceInsercion: desgloceInsercion,
            activo: activo
          });
          serialNRecuperado = 0;
          piezasPintadasExtra = 0;
          piezasPintadas = 0;
          piezasNRecuperadas = 0;
          piezasNoPintadas = 0;
          materialEn = "";
          materialEnCantidad = 0;
          comentarios = "";
          pPintadasOriginal = 0;
          pPintadasAnterior = 0;
          pPintadasAnteriorExtra = 0;
          pNoPintadasOriginal = 0;
          pNRecuperadasOriginal = 0;
          desgloceInsercion = [];

        }
      } else {
        listSerialesInput.push(embarques);
      }
    });
    return listSerialesInput;
  }
  function sumarPiezasP(list) {
    var piezas = 0;
    list.map((serial, i) => {
      if (serial.activo === true && serial.piezasPintadas > 0) {
        piezas += parseInt(serial.piezasPintadas);
      }
    });
    return piezas;
  }
  function sumarPiezasNP(list) {
    var piezas = 0;
    list.map((serial, i) => {
      if (serial.activo === true && serial.piezasNoPintadas > 0) {
        piezas += parseInt(serial.piezasNoPintadas);
      }
    });
    return piezas;
  }
  function sumarPiezasNR(list) {
    var piezas = 0;
    list.map((serial, i) => {
      if (serial.activo === true && serial.piezasNRecuperadas > 0) {
        piezas += parseInt(serial.piezasNRecuperadas);
      }
    });
    return piezas;
  }
  function sumarPiezasExtra(list) {
    var piezas = 0;
    list.map((serial, i) => {
      if (serial.activo === true && (serial.piezasPintadasExtra ? serial.piezasPintadasExtra : 0) > 0) {
        piezas += parseInt(serial.piezasPintadasExtra);
      }
    });
    return piezas;
  }
  async function aceptarEliminar() {
    setModal(!modal);
    try {
      var pConcurrencia = false;
      //Se obtienen los datos del embarque por número para revisar la concurrencia
      let cfilter = {
        numero: {
          eq: embarqueEliminar.numero,
        },
      };
      //const apiData = await API.graphql({ query: listEmbarques, variables: { filter: cfilter, limit: 100000000 } });
      const EmbarquesFromAPI = await GetEmbarques(cfilter);
      if (EmbarquesFromAPI.length < 1) {
        pConcurrencia = true;
      }
      await Promise.all(
        EmbarquesFromAPI.map(async (embarque) => {
          if (embarque.updatedAt !== embarqueEliminar.updatedAt)
            pConcurrencia = true;
        })
      );
      //Si no existe concurrencia, se actualizan los datos en RecibaSeriales y se marca activo igual a falso  en Embarque y EmbarqueSeriales,
      //Además se cambia la ubicación del material a Calidad.
      if (pConcurrencia === false) {
        //Se obtienen los registros de EmbarqueSeriales.
        const EmbarquesSFromAPI = await GetEmbarquesSeriales(cfilter);

        await Promise.all(
          EmbarquesSFromAPI.map(async (embarquess, i) => {
            //Se obtienen los datos de reciba seriales por id
            const recibaFromAPI = await GetRecibaSerialesID(
              embarquess.recibaSerialID
            );
            if (recibaFromAPI.id) {
              const piezasEmbarcardasInicial =
                (await recibaFromAPI.piezasEmbarcadas)
                  ? recibaFromAPI.piezasEmbarcadas
                  : 0;
              recibaFromAPI.PiezasEPintadas =
                (await recibaFromAPI.PiezasEPintadas)
                  ? parseInt(recibaFromAPI.PiezasEPintadas) -
                  parseInt(
                    embarquess.piezasPintadas ? embarquess.piezasPintadas : 0
                  )
                  : 0;
              recibaFromAPI.piezasPintadasExtra =
                (await recibaFromAPI.piezasPintadasExtra)
                  ? parseInt(recibaFromAPI.piezasPintadasExtra) -
                  parseInt(
                    embarquess.piezasPintadasExtra ? embarquess.piezasPintadasExtra : 0
                  )
                  : 0;
              recibaFromAPI.PiezasENRecuperadas =
                (await recibaFromAPI.PiezasENRecuperadas)
                  ? parseInt(recibaFromAPI.PiezasENRecuperadas) -
                  parseInt(
                    embarquess.piezasNRecuperadas
                      ? embarquess.piezasNRecuperadas
                      : 0
                  )
                  : 0;
              recibaFromAPI.piezasEmbarcadas =
                (await recibaFromAPI.piezasEmbarcadas)
                  ? parseInt(recibaFromAPI.piezasEmbarcadas) -
                  parseInt(
                    embarquess.piezasEmbarcadas
                      ? embarquess.piezasEmbarcadas
                      : 0
                  )
                  : 0;
              recibaFromAPI.piezasAEmbarcar =
                (await recibaFromAPI.piezasAEmbarcar)
                  ? parseInt(recibaFromAPI.piezasAEmbarcar) +
                  parseInt(
                    embarquess.piezasEmbarcadas
                      ? embarquess.piezasEmbarcadas
                      : 0
                  )
                  : 0;
              /**-----------------------------------------------------------------------------------------------------------*/
              const piezasEmbarcadasFinal =
                (await recibaFromAPI.piezasEmbarcadas)
                  ? recibaFromAPI.piezasEmbarcadas
                  : 0;
              if (piezasEmbarcardasInicial != piezasEmbarcadasFinal) {
                //Si hubo cambios en la cantidad de piezas embarcadas.
                //Se cambia la ubicación del material de Producción Calidad a Embarques Embarcado o a al reves, si así corresponde.
                const loacionPiezas =
                  (await piezasEmbarcardasInicial) > piezasEmbarcadasFinal
                    ? "Calidad"
                    : "Embarcado";
                const ubicacionPiezas =
                  (await loacionPiezas) === "Calidad"
                    ? "Producción"
                    : "Embarques";
                const ubicacionAnterior =
                  (await ubicacionPiezas) === "Producción"
                    ? "Embarques"
                    : "Producción";
                const loacionAnterior =
                  (await ubicacionAnterior) === "Producción"
                    ? "Calidad"
                    : "Embarcado";
                const cantidadPiezas =
                  (await piezasEmbarcardasInicial) > piezasEmbarcadasFinal
                    ? piezasEmbarcardasInicial - piezasEmbarcadasFinal
                    : piezasEmbarcadasFinal - piezasEmbarcardasInicial;
                let ufilter = {
                  and: [
                    {
                      activo: {
                        eq: true,
                      },
                    },
                    {
                      RecibaSerialesID: {
                        eq: recibaFromAPI.id,
                      },
                    },
                  ],
                };
                //Se obtienen los datos de ubicación del material que se cambiará de ubicación.
                var ubicacionSinfiltro = await GetUbicacion(ufilter);
                //Si no se obtienen datos de ubicación, se termina el proceso.
                if (!ubicacionSinfiltro[0]) {
                  setMensajeAlert(
                    "Operación errónea, no existen ubicaciones del registro actual para cambiar la ubicación del material."
                  );
                  //setMensajeAlert( "Datos: " + JSON.stringify(ubicacionSinfiltro));
                  setColor("warning");
                  setCargando(false);
                  setAVisible(true);
                  return;
                }
                const ubicacionFromAPI = ubicacionSinfiltro
                  .filter(
                    (ubicacion) =>
                      !ubicacion.fechaSalida &&
                      ubicacion.ubicacion === ubicacionAnterior &&
                      ubicacion.locacion === loacionAnterior
                  )
                  .sort((a, b) =>
                    a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0
                  );
                var ultimoAnterior = 0;
                var orden = ubicacionSinfiltro.length + 1;
                if (!ubicacionFromAPI[0]) {
                  setMensajeAlert(
                    "Operación errónea, no existen ubicaciones del registro actual en " +
                    loacionAnterior +
                    " sin fecha de salida registrada, para cambiar la ubicación del material."
                  );
                  setColor("warning");
                  setCargando(false);
                  setAVisible(true);
                  return;
                }
                //Se obtiene la última ubicación del material que no está en loacionAnterior y que no tiene fecha de salida
                var ultimaUbicacion = [];
                const ultimaUbicacionFromAPI = ubicacionSinfiltro
                  .filter(
                    (ubicacion) =>
                      !ubicacion.fechaSalida &&
                      ubicacion.locacion !== loacionAnterior
                  )
                  .sort((a, b) =>
                    a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0
                  );
                await Promise.all(
                  ultimaUbicacionFromAPI.map(async (ubicacionb) => {
                    ultimaUbicacion.push({
                      ubicacion: ubicacionb.ubicacion,
                      locacion: ubicacionb.locacion,
                      cantidad: ubicacionb.cantidad,
                      espacio: ubicacionb.espacioOcupado,
                    });
                  })
                );
                //Datos requeridos para registrar la operación
                const fechaSalida = Moment(new Date()).format("YYYY-MM-DD");
                const horaSalida = Moment(new Date()).format("HH:mm");

                var PiezasUbicacion = cantidadPiezas;
                //setMensajeAlert("Obteniebdo datos");
                var ubicacionesm = [];
                await Promise.all(
                  ubicacionFromAPI.map(async (ubicacion, i) => {
                    if (PiezasUbicacion > 0) {
                      ubicacionesm.push(ubicacion);
                      if (ubicacion.cantidad > PiezasUbicacion) {
                        PiezasUbicacion = 0;
                      } else {
                        PiezasUbicacion = PiezasUbicacion - ubicacion.cantidad;
                      }
                    } else {
                      ultimaUbicacion.push({
                        ubicacion: ubicacion.ubicacion,
                        locacion: ubicacion.locacion,
                        cantidad: ubicacion.cantidad,
                        espacio: ubicacion.espacioOcupado,
                      });
                    }
                  })
                );
                PiezasUbicacion = cantidadPiezas;
                await Promise.all(
                  ubicacionesm.map(async (ubicacion, i) => {
                    //Se indica fecha y hora de salida al registro en Inspección que corresonde en Producción.
                    const cantidadOriginal = ubicacion.cantidad;
                    delete ubicacion.createdAt;
                    delete ubicacion.updatedAt;
                    delete ubicacion.__typename;
                    ubicacion.fechaSalida = fechaSalida;
                    ubicacion.horaSalida = horaSalida;
                    ubicacion.Reg_Mod_Usuario = userName;
                    ubicacion.ultimo = false;
                    ubicacion.cantidad =
                      cantidadOriginal > PiezasUbicacion
                        ? PiezasUbicacion
                        : cantidadOriginal;
                    //setMensajeAlert("Operación errónea; No se pudo guardar la fecha y hora de salida. Cantidad original: " + cantidadOriginal + " PiezasUbicación: " + PiezasUbicacion);//+ JSON.stringify(ubicacion)
                    await API.graphql({
                      query: updateUbicacion,
                      variables: { input: ubicacion },
                    });
                    //Si la cantidad es menor a la cantidad que de piezas en pintado,
                    //Se agrega un registro en el sistema con la cantidad que corresponde que debería quedar en Inspección.
                    if (cantidadOriginal > PiezasUbicacion) {
                      //Se agrega un nuevo registro de ubicación en la ubicación anterior.
                      if (ubicacionSinfiltro.length > 1 || ultimoAnterior > 0)
                        ultimoAnterior++;
                      delete ubicacion.id;
                      ubicacion.ultimo = false;
                      ubicacion.Reg_Ins_Usuario = userName;
                      ubicacion.ultimoAnterior = ultimoAnterior;
                      ubicacion.orden = orden;
                      //ubicacion.espacio = 0;
                      ubicacion.cantidad = cantidadOriginal - PiezasUbicacion;
                      delete ubicacion.fechaSalida;
                      delete ubicacion.horaSalida;
                      delete ubicacion.Reg_Mod_Usuario;
                      setMensajeAlert(
                        "Operación errónea; Problemas al guardar el registro de ubicación de la cantidad restante."
                      );
                      await API.graphql({
                        query: createUbicacion,
                        variables: { input: ubicacion },
                      });
                      ultimaUbicacion.push({
                        ubicacion: ubicacion.ubicacion,
                        locacion: ubicacion.locacion,
                        cantidad: ubicacion.cantidad,
                        espacio: ubicacion.espacioOcupado,
                      });
                      orden++;
                      PiezasUbicacion = 0;
                    } else {
                      PiezasUbicacion = PiezasUbicacion - cantidadOriginal;
                    }
                    orden++;
                  })
                );

                //Se agrega un nuevo registro de ubicación en la ubicación que corresponde.
                const ubicacion = ubicacionesm[0];
                if (ubicacionSinfiltro.length > 1 || ultimoAnterior > 0)
                  ultimoAnterior++;
                delete ubicacion.id;
                ubicacion.fechaIngreso = fechaSalida;
                ubicacion.horaIngreso = horaSalida;
                ubicacion.ubicacion = ubicacionPiezas;
                ubicacion.locacion = loacionPiezas;
                ubicacion.ubicaciondeReciba = false;
                ubicacion.ultimo = true;
                ubicacion.Reg_Ins_Usuario = userName;
                ubicacion.ultimoAnterior = ultimoAnterior;
                ubicacion.orden = orden;
                ubicacion.espacioOcupado = 0;
                //ubicacion.comentarios = pInspeccion.comentariosInspeccion;
                ubicacion.cantidad = cantidadPiezas;
                delete ubicacion.fechaSalida;
                delete ubicacion.horaSalida;
                delete ubicacion.Reg_Mod_Usuario;
                /*setMensajeAlert(
                  "Operación errónea; Problemas al guardar la nueva ubicación"
                );*/ //+ JSON.stringify(ubicacion)
                await API.graphql({
                  query: createUbicacion,
                  variables: { input: ubicacion },
                });
                ultimaUbicacion.push({
                  ubicacion: ubicacion.ubicacion,
                  locacion: ubicacion.locacion,
                  cantidad: ubicacion.cantidad,
                  espacio: ubicacion.espacioOcupado,
                });

                //Se agrupan las ubicaciones de última ubicación
                const sUltimaU = ultimaUbicacion.sort((a, b) =>
                  a.ubicacion + (a.locacion ? a.locacion : "") >
                    b.ubicacion + (b.locacion ? b.locacion : "")
                    ? 1
                    : a.ubicacion + (a.locacion ? a.locacion : "") <
                      b.ubicacion + (b.locacion ? b.locacion : "")
                      ? -1
                      : 0
                );
                var auxUltimaUbicacion = [];
                var ubicacionLocacionanterior =
                  (sUltimaU[0].ubicacion ? sUltimaU[0].ubicacion : "") +
                  (sUltimaU[0].locacion ? sUltimaU[0].locacion : "");
                var cantidadTotal = 0;
                var espacio = 0;
                await Promise.all(
                  sUltimaU.map(async (ubicacion, i) => {
                    const ubicacionLocacion =
                      (ubicacion.ubicacion ? ubicacion.ubicacion : "") +
                      (ubicacion.locacion ? ubicacion.locacion : "");
                    if (ubicacionLocacion !== ubicacionLocacionanterior) {
                      auxUltimaUbicacion.push({
                        ubicacion: sUltimaU[i - 1].ubicacion,
                        locacion: sUltimaU[i - 1].locacion,
                        cantidad: cantidadTotal,
                        espacio: espacio,
                      });
                      ubicacionLocacionanterior = ubicacionLocacion;
                      cantidadTotal = 0;
                      espacio = 0;
                    }
                    cantidadTotal = cantidadTotal + ubicacion.cantidad;
                    espacio = espacio + ubicacion.espacio;

                    if (i === sUltimaU.length - 1) {
                      auxUltimaUbicacion.push({
                        ubicacion: ubicacion.ubicacion,
                        locacion: ubicacion.locacion,
                        cantidad: cantidadTotal,
                        espacio: espacio,
                      });
                    }
                  })
                );
              }

              /*------------------------------------------------------------------------------------------------------------*/
              recibaFromAPI.ultimaUbicacion = auxUltimaUbicacion;
              delete recibaFromAPI.createdAt;
              delete recibaFromAPI.updatedAt;
              delete recibaFromAPI.__typename;
              if ((recibaFromAPI.piezasEmbarcadas < recibaFromAPI.cantidadRecibida) && recibaFromAPI.piezasEmbarcadas > 0) {
                recibaFromAPI.piezasEnPlanta = true;
              }
              await API.graphql({
                query: updateRecibaSeriales,
                variables: { input: recibaFromAPI },
              });
            }

            delete embarquess.createdAt;
            delete embarquess.updatedAt;
            delete embarquess.__typename;
            embarquess.Reg_Mod_Usuario = userName;
            embarquess.activo = false;
            await API.graphql({
              query: updateEmbarqueSeriales,
              variables: { input: embarquess },
            });
          })
        );
        await Promise.all(
          EmbarquesFromAPI.map(async (embarque) => {
            delete embarque.createdAt;
            delete embarque.updatedAt;
            delete embarque.__typename;
            embarque.Reg_Mod_Usuario = userName;
            embarque.activo = false;
            await API.graphql({
              query: updateEmbarque,
              variables: { input: embarque },
            });
          })
        );

        window.scrollTo(0, 0);
        setMensajeAlert("Operación exitosa");
        setColor("primary");
        setAVisible(true);
        setCargando(false);
        fetchEmbarques(rfechaini, rfechafin);
        setInputList([]);
        setInputListServicios([]);
        setServicios(false);
        setEmbarqueSerialEditar([]);
        toggle1("1");
      } else {
        //Si  hay concurrencia se tienen que actualizar los datos
        window.scrollTo(0, 0);
        setMensajeAlert(
          "No fue posible realizar la operación: existe concurrencia, se requiere refrescar la página y " +
          " volver a intentarlo"
        );
        setColor("warning");
        setCargando(false);
        setAVisible(true);
        fetchEmbarques(rfechaini, rfechafin);
      }
    } catch (e) {
      window.scrollTo(0, 0);
      setMensajeAlert(
        "No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar, si el error persiste, favor de comunicarse a sistemas"
      );
      setColor("warning");
      setAVisible(true);
      setCargando(false);
    }
  }
  function revisarCantidadValida(list) {
    var cantidadValida = true;
    list.map((embarques, i) => {
      if (
        (parseInt(embarques.pPintadasOriginal ? embarques.pPintadasOriginal : 0) +
          parseInt(embarques.pNoPintadasOriginal ? embarques.pNoPintadasOriginal : 0) +
          parseInt(embarques.pNRecuperadasOriginal ? embarques.pNRecuperadasOriginal : 0)) !=
        (parseInt(embarques.piezasPintadas ? embarques.piezasPintadas : 0) +
          parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0) +
          parseInt(embarques.piezasNoPintadas ? embarques.piezasNoPintadas : 0)) ||
        (parseInt(embarques.piezasPintadas ? embarques.piezasPintadas : 0) === 0 &&
          parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0) === 0 &&
          parseInt(embarques.piezasNoPintadas ? embarques.piezasNoPintadas : 0) === 0)

      ) {
        cantidadValida = false;
      }
    });
    return cantidadValida;
  }
  function revisarDatosCompletos(list) {
    var datosCompletos = true;
    list.map((embarques, i) => {
      if (
        (!embarques.piezasPintadas ||
          (parseInt(embarques.piezasPintadas) === 0 &&
            (!embarques.piezasNRecuperadas ||
              parseInt(embarques.piezasNRecuperadas)))) === 0 ||
        !embarques.materialEnCantidad ||
        embarques.materialEnCantidad === ""
      ) {
        datosCompletos = false;
      }
    });
    return datosCompletos;
  }
  function revisarDatosCompletosServicios(list) {
    var datosCompletos = true;
    list.map((embarques, i) => {
      if (!embarques.numerodeParte || parseInt(embarques.materialEnCantidad) === 0 ||
        parseInt(embarques.piezasPintadas) === 0 || !embarques.serial || !embarques.materialEn
      ) {
        datosCompletos = false;
      }
    });
    return datosCompletos;
  }
  async function cambioUbicacion(recibaid, ubicacionAnterior, loacionAnterior, ubicacionDestino, locacionDestino, cantidadPiezas, particular) {
    let ufilter = {
      and: [
        {
          activo: {
            eq: true,
          },
        },
        {
          RecibaSerialesID: {
            eq: recibaid,
          },
        },
      ],
    };
    //Se obtienen los datos de ubicación del material que se cambiará de ubicación.
    var ubicacionSinfiltro = await GetUbicacion(ufilter);
    //Si no se obtuvieron ubicaciones, se termina el proceso
    if (!ubicacionSinfiltro[0]) {
      if (particular === true) {
        setMensajeAlertr("Operación errónea, no existen ubicaciones del registro actual para cambiar la ubicación del material.");
        setColorr("warning");
        setCargando1(false);
      } else {
        setMensajeAlert("Operación errónea, no existen ubicaciones del registro actual para cambiar la ubicación del material.");
        setColor("warning");
        setCargando(false);
        setAVisible(true);
      }
      return;
    }
    const ubicacionFromAPI = ubicacionSinfiltro
      .filter(
        (ubicacion) =>
          !ubicacion.fechaSalida &&
          ubicacion.ubicacion === ubicacionAnterior &&
          ubicacion.locacion === loacionAnterior
      )
      .sort((a, b) => (a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0));
    var ultimoAnterior = 0;
    var orden = (ubicacionSinfiltro.length ? ubicacionSinfiltro.length : 0) + 1;
    if (!ubicacionFromAPI[0]) {
      if (particular === true) {
        setMensajeAlertr("Operación errónea, no existen ubicaciones del registro actual en " +
          loacionAnterior +
          " sin fecha de salida registrada, para cambiar la ubicación del material."
        );
        setColorr("warning");
        setCargando1(false);
      } else {
        setMensajeAlert("Operación errónea, no existen ubicaciones del registro actual en " +
          loacionAnterior +
          " sin fecha de salida registrada, para cambiar la ubicación del material."
        );
        setColor("warning");
        setCargando(false);
        setAVisible(true);
      }
      return;
    }
    //Se obtiene la última ubicación del material que no está en loacionAnterior y que no tiene fecha de salida
    var ultimaUbicacion = [];
    const ultimaUbicacionFromAPI = ubicacionSinfiltro
      .filter(
        (ubicacion) =>
          !ubicacion.fechaSalida && ubicacion.locacion !== loacionAnterior
      )
      .sort((a, b) => (a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0));
    await Promise.all(
      ultimaUbicacionFromAPI.map(async (ubicacionb) => {
        ultimaUbicacion.push({
          ubicacion: ubicacionb.ubicacion,
          locacion: ubicacionb.locacion,
          cantidad: ubicacionb.cantidad,
          espacio: ubicacionb.espacioOcupado,
        });
      })
    );
    //Datos requeridos para registrar la operación
    const fechaSalida = Moment(new Date()).format("YYYY-MM-DD");
    const horaSalida = Moment(new Date()).format("HH:mm");

    var PiezasUbicacion = cantidadPiezas;
    //setMensajeAlert("Obteniebdo datos");
    var ubicacionesm = [];
    await Promise.all(
      ubicacionFromAPI.map(async (ubicacion, i) => {
        if (PiezasUbicacion > 0) {
          ubicacionesm.push(ubicacion);
          if (ubicacion.cantidad > PiezasUbicacion) {
            PiezasUbicacion = 0;
          } else {
            PiezasUbicacion = PiezasUbicacion - ubicacion.cantidad;
          }
        } else {
          ultimaUbicacion.push({
            ubicacion: ubicacion.ubicacion,
            locacion: ubicacion.locacion,
            cantidad: ubicacion.cantidad,
            espacio: ubicacion.espacioOcupado,
          });
        }
      })
    );
    PiezasUbicacion = cantidadPiezas;
    await Promise.all(
      ubicacionesm.map(async (ubicacion, i) => {
        //Se indica fecha y hora de salida al registro en Inspección que corresonde en Producción.
        const cantidadOriginal = ubicacion.cantidad;
        delete ubicacion.createdAt;
        delete ubicacion.updatedAt;
        delete ubicacion.__typename;
        ubicacion.fechaSalida = fechaSalida;
        ubicacion.horaSalida = horaSalida;
        ubicacion.Reg_Mod_Usuario = userName;
        ubicacion.ultimo = false;
        ubicacion.cantidad =
          cantidadOriginal > PiezasUbicacion
            ? PiezasUbicacion
            : cantidadOriginal;
        //setMensajeAlert("Operación errónea; No se pudo guardar la fecha y hora de salida. Cantidad original: " + cantidadOriginal + " PiezasUbicación: " + PiezasUbicacion);//+ JSON.stringify(ubicacion)
        await API.graphql({
          query: updateUbicacion,
          variables: { input: ubicacion },
        });
        //Si la cantidad es menor a la cantidad que de piezas en pintado,
        //Se agrega un registro en el sistema con la cantidad que corresponde que debería quedar en Inspección.
        if (cantidadOriginal > PiezasUbicacion) {
          //Se agrega un nuevo registro de ubicación en la ubicación anterior.
          if ((ubicacionSinfiltro.length ? ubicacionSinfiltro.length : 0) > 1 || ultimoAnterior > 0)
            ultimoAnterior++;
          delete ubicacion.id;
          ubicacion.ultimo = false;
          ubicacion.Reg_Ins_Usuario = userName;
          ubicacion.ultimoAnterior = ultimoAnterior;
          ubicacion.orden = orden;
          //ubicacion.espacio = 0;
          ubicacion.cantidad = cantidadOriginal - PiezasUbicacion;
          delete ubicacion.fechaSalida;
          delete ubicacion.horaSalida;
          delete ubicacion.Reg_Mod_Usuario;
          /*setMensajeAlert(
            "Operación errónea; Problemas al guardar el registro de ubicación de la cantidad restante."
          );*/
          await API.graphql({
            query: createUbicacion,
            variables: { input: ubicacion },
          });
          ultimaUbicacion.push({
            ubicacion: ubicacion.ubicacion,
            locacion: ubicacion.locacion,
            cantidad: ubicacion.cantidad,
            espacio: ubicacion.espacioOcupado,
          });
          orden++;
          PiezasUbicacion = 0;
        } else {
          PiezasUbicacion = PiezasUbicacion - cantidadOriginal;
        }
        orden++;
      })
    );

    //Se agrega un nuevo registro de ubicación en la ubicación que corresponde.
    const ubicacion = ubicacionesm[0];
    if ((ubicacionSinfiltro.length ? ubicacionSinfiltro.length : 0) > 1 || ultimoAnterior > 0) ultimoAnterior++;
    delete ubicacion.id;
    ubicacion.fechaIngreso = fechaSalida;
    ubicacion.horaIngreso = horaSalida;
    ubicacion.ubicacion = ubicacionDestino;
    ubicacion.locacion = locacionDestino;
    ubicacion.ubicaciondeReciba = false;
    ubicacion.ultimo = true;
    ubicacion.Reg_Ins_Usuario = userName;
    ubicacion.ultimoAnterior = ultimoAnterior;
    ubicacion.orden = orden;
    ubicacion.espacioOcupado = 0;
    //ubicacion.comentarios = pInspeccion.comentariosInspeccion;
    ubicacion.cantidad = cantidadPiezas;
    delete ubicacion.fechaSalida;
    delete ubicacion.horaSalida;
    delete ubicacion.Reg_Mod_Usuario;
    /*setMensajeAlert(
      "Operación errónea; Problemas al guardar la nueva ubicación"
    ); *///+ JSON.stringify(ubicacion)
    await API.graphql({
      query: createUbicacion,
      variables: { input: ubicacion },
    });
    ultimaUbicacion.push({
      ubicacion: ubicacion.ubicacion,
      locacion: ubicacion.locacion,
      cantidad: ubicacion.cantidad,
      espacio: ubicacion.espacioOcupado,
    });

    //Se agrupan las ubicaciones de última ubicación
    const sUltimaU = ultimaUbicacion.sort((a, b) =>
      a.ubicacion + (a.locacion ? a.locacion : "") >
        b.ubicacion + (b.locacion ? b.locacion : "")
        ? 1
        : a.ubicacion + (a.locacion ? a.locacion : "") <
          b.ubicacion + (b.locacion ? b.locacion : "")
          ? -1
          : 0
    );

    var auxUltimaUbicacion = [];
    var ubicacionLocacionanterior =
      (sUltimaU[0].ubicacion ? sUltimaU[0].ubicacion : "") +
      (sUltimaU[0].locacion ? sUltimaU[0].locacion : "");
    var cantidadTotal = 0;
    var espacio = 0;
    await Promise.all(
      sUltimaU.map(async (ubicacion, i) => {
        const ubicacionLocacion =
          (ubicacion.ubicacion ? ubicacion.ubicacion : "") +
          (ubicacion.locacion ? ubicacion.locacion : "");
        if (ubicacionLocacion !== ubicacionLocacionanterior) {
          auxUltimaUbicacion.push({
            ubicacion: sUltimaU[i - 1].ubicacion,
            locacion: sUltimaU[i - 1].locacion,
            cantidad: cantidadTotal,
            espacio: espacio,
          });
          ubicacionLocacionanterior = ubicacionLocacion;
          cantidadTotal = 0;
          espacio = 0;
        }
        cantidadTotal = cantidadTotal + ubicacion.cantidad;
        espacio = espacio + ubicacion.espacio;

        if (i === sUltimaU.length - 1) {
          auxUltimaUbicacion.push({
            ubicacion: ubicacion.ubicacion,
            locacion: ubicacion.locacion,
            cantidad: cantidadTotal,
            espacio: espacio,
          });
        }
      })
    );
    return auxUltimaUbicacion;
  }
  async function crearEmbarque() {
    setAVisible(false);
    setCargando(true);
    //setisDisabled(true);
    /*const datosCompletos = await revisarDatosCompletos(inputList);
    const cantidadValida = await revisarCantidadValida(inputList);*/
    try {
      var mensaje = "";
      if (!fechaDeEmbarque || !atencionA || !ordenDeCompra || !clienteID || !rCliente || !clienteEntregaID /*||datosCompletos === false*/) {
        mensaje = "Faltan datos; los campos marcados con un asterísco son obligatorios.1 "; // + datosCompletos;
      }
      /*if (cantidadValida === false)
        mensaje = mensaje +
          "\n Datos no válidos; la suma de las cantidades a embarcar, no debe ser mayor a la cantidad disponible," +
          " la cantidad no puede ser cero, se marca en rojo la cantidad errónea";*/

      if (mensaje !== "") {
        setMensajeAlert(mensaje);
        setColor("warning");
        setAVisible(true);
        setisDisabled(true);
        setCargando(false);
        window.scrollTo(0, 0);
      } else {
        const datosGuardar = inputList.filter(
          (embarqueSeriales) => !embarqueSeriales.id
        );
        var numeroUP = 1;
        var numeroUPRS = 1;
        var numeroSerial = datosGuardar.length;
        var PnumeroSerial = 0;
        var pConcurrencia = false;
        var embarqueid = embarqueEditando.id;
        //setMensajeAlert("Inicial " + editar);
        if (!editar /*|| numeroSerial > 0*/) {
          //setMensajeAlert("No editar");
          //Se obtienen los datos de los últimos números registrados en embarques
          const apiData = await API.graphql({
            query: listEmbarqueUltimoNumeros,
            variables: { limit: 100000000 },
          });
          const ultimapFromAPI = apiData.data.listEmbarqueUltimoNumeros.items;
          if (!ultimapFromAPI.length) {
            //setMensajeAlert("Error al guardar número de embarque ");
            await API.graphql({
              query: createEmbarqueUltimoNumero,
              variables: {
                input: {
                  numero: rCliente !== "Robertshaw Controls Nuevo Laredo" ? numeroUP : 0,
                  numeroRobetS: rCliente === "Robertshaw Controls Nuevo Laredo" ? numeroUP : 0,
                  UltimoNumeroSerial: numeroSerial,
                  activo: true,
                  Reg_Ins_Usuario: userName,
                },
              },
            });
          } else {
            //Se obtiene el último número serial registrado en embarques
            PnumeroSerial = ultimapFromAPI[0].UltimoNumeroSerial;
            //setMensajeAlert("Obtuve datos");
            await Promise.all(
              ultimapFromAPI.map(async (ultimaEmbarque) => {
                if (!editar) {
                  //Se determina el último número dependiendo el cliente
                  numeroUP = rCliente !== "Robertshaw Controls Nuevo Laredo" ?
                    ((ultimaEmbarque.numero ? ultimaEmbarque.numero : 0) + 1) :
                    (ultimaEmbarque.numero ? ultimaEmbarque.numero : 0);
                  numeroUPRS = rCliente === "Robertshaw Controls Nuevo Laredo" ?
                    ((ultimaEmbarque.numeroRobetS ? ultimaEmbarque.numeroRobetS : 0) + 1) :
                    (ultimaEmbarque.numeroRobetS ? ultimaEmbarque.numeroRobetS : 0);

                  ultimaEmbarque.numeroRobetS = numeroUPRS;
                  ultimaEmbarque.numero = numeroUP;
                }
                ultimaEmbarque.UltimoNumeroSerial =
                  ultimaEmbarque.UltimoNumeroSerial + numeroSerial;
                delete ultimaEmbarque.createdAt;
                delete ultimaEmbarque.updatedAt;
                delete ultimaEmbarque.__typename;
                ultimaEmbarque.Reg_Mod_Usuario = userName;
                //setMensajeAlert("Error al acualizar número de embarque ");
                await API.graphql({
                  query: updateEmbarqueUltimoNumero,
                  variables: { input: ultimaEmbarque },
                });

                return ultimaEmbarque;
              })
            );
          }
          var numeroUPE = numeroUP;
          if (rCliente === "Robertshaw Controls Nuevo Laredo") {
            numeroUPE =
              numeroUPRS < 10
                ? "RS000" + numeroUPRS.toString()
                : numeroUPRS < 100
                  ? "RS00" + numeroUPRS.toString()
                  : numeroUPRS < 1000
                    ? "RS0" + numeroUPRS.toString()
                    : "RS" + numeroUPRS.toString();
          }
          if (!editar) {
            //Guarda los datos del embarque
            var formData = {};
            formData.fechaDeEmbarque = fechaDeEmbarque;
            formData.numero = numeroUPE;
            formData.atencionA = atencionA;
            formData.ordenDeCompra = ordenDeCompra;
            formData.clienteID = clienteID;
            formData.cliente = rCliente;
            formData.clienteEntregaID = clienteEntregaID;
            formData.clienteEntrega = rClienteEntrega;
            formData.facturarA = rClienteFacturarA;
            formData.fechaDeReciba = "";//inputList[0].fechaDeReciba;
            formData.MFGFecha = "";// inputList[0].MFGFecha;
            formData.piezasPintadas = 0;// sumarPiezasP(inputList); //inputList[0].piezasNRecuperadas;
            formData.piezasNRecuperadas = 0;// sumarPiezasNR(inputList); //inputList[0].piezasNRecuperadas;
            formData.piezasNoPintadas = 0;//sumarPiezasNP(inputList);
            formData.activo = true;
            formData.Reg_Ins_Usuario = userName;
            formData.totalNumerodeParte = iTotalNParte;
            formData.sinTotalScrap = sinTotalScrap;
            formData.sinTotalScrapFactura = sinTotalScrapFactura;
            formData.desgloceVer = desgloceVer;
            formData.piezasEmbarcadas = 0;/*
              parseInt(formData.piezasPintadas) +
              parseInt(formData.piezasNRecuperadas) +
              parseInt(formData.piezasNoPintadas);*/
            formData.packings = "";//concatenarPackings(inputList);
            formData.numerosdeParte = ""; // concatenarNumerosdeParte(inputList);
            formData.lotes = "";// concatenarLotes(inputList);
            formData.seriales = "";// concatenarSeriales(inputList);
            //setMensajeAlert("Error al guardar embarque ");
            let resultado = await API.graphql({
              query: createEmbarqueMutation,
              variables: { input: formData },
            });

            //Obtiene el ID del embarque recien creado, tomando como base el número.
            //setMensajeAlert("Error obtener nuevo embarque");            
            const embarqueCreado = resultado.data.createEmbarque;
            //setMensajeAlert("Obtuve el embarque creado1");
            embarqueid = embarqueCreado.id;
            setEmbarqueEditando(embarqueCreado);
            //setMensajeAlert("Obtuve el embarque creado2 " + embarqueid);
            //Se obtienen los usuarios a los que se les enviará la notificación
            const usuariosNot = await GetUsuarios({ and: [{ activo: { eq: true } }, { Notificaciones: { eq: true } }, { Facturacion: { eq: true } }, { usuario: { ne: formData.Reg_Ins_Usuario } }] });
            const nombres = usuariosNot.map(u => u.usuario).join(',');
            //Se crea una notificación de la creación del nuevo número de parte
            const notificaciones = {
              modulo: "Embarques",
              Accion: "Nuevos packings creados",
              notificacion: "Se ha creado el packing número " + embarqueCreado.numero + " del cliente " + embarqueCreado.cliente + ", con fecha de emabrque del " + embarqueCreado.fechaDeEmbarque,
              fecha: Moment(new Date()).format("YYYY-MM-DD"),
              hora: Moment(new Date()).format("HH:mm"),
              leido: false,
              usuarioDe: embarqueCreado.Reg_Ins_Usuario,
              usuarioPara: "," + nombres + ",",
              paraSoporte: false,
              activo: true,
              Reg_Ins_Usuario: embarqueCreado.Reg_Ins_Usuario
            };
            //Se guardan los datos de la notificación.
            let resultnot = await API.graphql({ query: createNotificaciones, variables: { input: notificaciones } });
            //Se crea un registro en la tabla de NotificacionesNuevas para cada uno de los usuarios de soporte
            notificaciones.NotificacionID = resultnot.data.createNotificaciones.id;
            await Promise.all(
              usuariosNot.map(async (not, i) => {
                const notific = { ...notificaciones, usuarioPara: not.usuario };
                //Se establece para qué usuario es la notificación                    
                await API.graphql({ query: createNotificacionesNuevas, variables: { input: notific } });
              })
            );
          }
        } else if (editar) {
          //Si no hay concurrencia, se obtienen los datos del embarque correspondiente
          if (embarqueid != "") {
            //setMensajeAlert("Error al intentar obtener datos del embarque para editar");
            //const dataembarque = await API.graphql({ query: listEmbarques, variables: { filter: { numero: { eq: numeroP } }, limit: 100000000 } });
            const editarEmbarque = await GetEmbarquesID(embarqueid);
            var formData = editarEmbarque;
            formData.fechaDeEmbarque = fechaDeEmbarque;
            formData.atencionA = atencionA;
            formData.ordenDeCompra = ordenDeCompra;
            formData.clienteID = clienteID;
            formData.cliente = rCliente;
            formData.clienteEntregaID = clienteEntregaID;
            formData.clienteEntrega = rClienteEntrega;
            formData.facturarA = rClienteFacturarA;
            formData.fechaDeReciba = inputList[0] ? inputList[0].fechaDeReciba : "";
            formData.MFGFecha = inputList[0] ? inputList[0].MFGFecha : "";
            formData.piezasPintadas = inputList[0] ? sumarPiezasP(inputList) : 0; //inputList[0].piezasNRecuperadas;
            formData.piezasNRecuperadas = inputList[0] ? sumarPiezasNR(inputList) : 0; //inputList[0].piezasNRecuperadas;
            formData.piezasNoPintadas = inputList[0] ? sumarPiezasNP(inputList) : 0;
            formData.activo = true;
            formData.Reg_Ins_Usuario = userName;
            formData.piezasEmbarcadas = inputList[0] ?
              (parseInt(formData.piezasPintadas) +
                parseInt(formData.piezasNRecuperadas) +
                (inputList[0] ? sumarPiezasExtra(inputList) : 0) /*+
                parseInt(formData.piezasNoPintadas)*/) : 0;
            formData.packings = inputList[0] ? concatenarPackings(inputList) : "";
            formData.numerosdeParte = inputList[0] ? concatenarNumerosdeParte(inputList) : "";
            formData.lotes = inputList[0] ? concatenarLotes(inputList) : "";
            formData.seriales = inputList[0] ? concatenarSeriales(inputList) : "";
            formData.totalNumerodeParte = iTotalNParte;
            formData.sinTotalScrap = sinTotalScrap;
            formData.sinTotalScrapFactura = sinTotalScrapFactura;
            formData.desgloceVer = desgloceVer;
            delete formData.createdAt;
            delete formData.updatedAt;
            delete formData.__typename;
            //setMensajeAlert("Error al intentar guardar los datos del embarque " + JSON.stringify(formData));
            let resultado = await API.graphql({
              query: updateEmbarque,
              variables: { input: formData },
            });
            const embarqueActualizado = resultado.data.updateEmbarque;
            setEmbarqueEditando(embarqueActualizado);
          }
        }
        setMensajeAlert("Operación exitosa; " + (!editar ? ("Se creó el packing  " + numeroUPE) : (" Se actualizó el packing " + embarqueEditando.numero)));
        setisDisabled(true);
        setEditar(true);
        setColor("primary");
        setAVisible(true);
        setCargando(true);
        setCargando(false);

      }
    } catch (e) {
      window.scrollTo(0, 0);
      setMensajeAlert(e.message);
      setColor("warning");
      setAVisible(true);
      fetchEmbarques(rfechaini, rfechafin);
      setCargando(false);
      setisDisabled(true);
    }
  }
  async function guardarEmbarqueSerial() {
    setAVisibler(false);
    setCargando1(true);
    setDRegresarAE(true);
    //setisDisabled(true);
    const datosCompletos = ((!embarcando.materialEnCantidad || embarcando.materialEnCantidad === "") ||
      (!embarcando.materialEnCantidad || embarcando.materialEnCantidad === "") ||
      (parseInt(embarcando.piezasPintadas ? embarcando.piezasPintadas : 0) <= 0 &&
        parseInt(embarcando.piezasNRecuperadas ? embarcando.piezasNRecuperadas : 0) <= 0 &&
        parseInt(embarcando.piezasNoPintadas ? embarcando.piezasNoPintadas : 0) <= 0)) ? false : true;

    const cantidadValida = ((parseInt(embarcando.pPintadasOriginal ? embarcando.pPintadasOriginal : 0) +
      parseInt(embarcando.pNoPintadasOriginal ? embarcando.pNoPintadasOriginal : 0) +
      parseInt(embarcando.pNRecuperadasOriginal ? embarcando.pNRecuperadasOriginal : 0)) <
      (parseInt(embarcando.piezasPintadas ? embarcando.piezasPintadas : 0) +
        parseInt(embarcando.piezasNRecuperadas ? embarcando.piezasNRecuperadas : 0) +
        parseInt(embarcando.piezasNoPintadas ? embarcando.piezasNoPintadas : 0))) ? false : true;
    try {
      var mensaje = "";
      if (datosCompletos === false)
        mensaje = "Faltan datos; los campos marcados con un asterísco son obligatorios. 2"; // + datosCompletos;
      if (cantidadValida === false)
        mensaje = mensaje +
          "\n Datos no válidos; la suma de las cantidades a embarcar, no debe ser mayor a la cantidad disponible," +
          " la cantidad no puede ser cero, se marca en rojo la cantidad errónea";

      if (mensaje !== "") {
        setMensajeAlertr(mensaje);
        setColorr("warning");
        setAVisibler(true);
        //setisDisabled(false);
        setCargando1(false);
        setDRegresarAE(false);
        window.scrollTo(0, 0);
      } else {
        var pConcurrencia = false;
        var embarqueid = embarqueEditando.id;
        var EmbarquesC = {};
        var recibaSerialE = {};
        if (embarqueEditando.id) {
          //Se obtienen los datos del embarque por id para revisa la concurrencia
          EmbarquesC = await GetEmbarquesID(embarqueid);
          if (!EmbarquesC.id) {
            pConcurrencia = true;
          } else {
            if (EmbarquesC.updatedAt !== embarqueEditando.updatedAt) {
              pConcurrencia = true;
              mensaje = "Operación denegada; concurrencia en los datos generales del embarque.";
            }
          }
          if (embarcando.recibaSerialID) {
            //Se obtienen los datos del embarque por id para revisa la concurrencia
            recibaSerialE = await GetRecibaSerialesID(embarcando.recibaSerialID);
            if (!recibaSerialE.id) {
              pConcurrencia = true;
            } else {
              if (recibaSerialE.updatedAt !== embarcando.updatedAt) {
                pConcurrencia = true;
                mensaje = mensaje + " Concurrencia en los datos del serial.";
              }
            }
          } else {
            mensaje = "Operación denegada; no se encontraro datos del serial, favor de comunicarse a sistemas";
          }
        } else {
          mensaje = "Operación denegada; no se encontraron datos del embarque relacionado, favor de comunicarse a sistemas";
        }
        //Se revisa si hay mensaje de error, si es así, se termina la transacción.
        if (mensaje !== "") {
          setMensajeAlertr(mensaje);
          setColorr("warning");
          setAVisibler(true);
          //setisDisabled(false);
          setCargando1(false);
          setDRegresarAE(false);
          window.scrollTo(0, 0);
          return;
        }
        //Si no hay concurrencia, se actualizan los datos en el embarque y se intentan guardar los datos de ubicación.        
        if (pConcurrencia === false) {
          //setMensajeAlertr("Sin concurrencia"); 
          //Se obtienen los datos del último número de embarques  para obtener el útmimoNumeroSerial.
          const apiData = await API.graphql({
            query: listEmbarqueUltimoNumeros,
            variables: { limit: 100000000 },
          });
          const ultimapFromAPI = apiData.data.listEmbarqueUltimoNumeros.items;
          const PnumeroSerial = ultimapFromAPI[0] ? (ultimapFromAPI[0].UltimoNumeroSerial + 1) : 1;
          //Actualiza las piezasEmbarcadas en reciba seriales.
          const embarques = embarcando;
          var idAgregado = [];
          //setMensajeAlertr("Error obtener la reciba serial correspondiente");
          //Se obtiene el registro actualizado de los reciba seriales por id
          const recibam = recibaSerialE;
          setMensajeAlertr("Se obtuvieron los datos del serial correspondiente ");

          //Se determina las piezas a embarcar como aprobadas
          const piezasCalidad = parseInt(embarcando.pPintadasOriginal ? embarcando.pPintadasOriginal : 0) === 0 ? 0 :
            (parseInt(embarcando.pPintadasOriginal ? embarcando.pPintadasOriginal : 0) <=
              parseInt(embarcando.piezasPintadas ? embarcando.piezasPintadas : 0)) ?
              parseInt(embarcando.pPintadasOriginal ? embarcando.pPintadasOriginal : 0) :
              (parseInt(embarcando.pNRecuperadasOriginal ? embarcando.pNRecuperadasOriginal : 0) <
                parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0)) ?
                (parseInt(embarques.piezasPintadas ? embarques.piezasPintadas : 0) +
                  (parseInt(embarcando.piezasNRecuperadas ? embarcando.piezasNRecuperadas : 0) -
                    parseInt(embarcando.pNRecuperadasOriginal ? embarcando.pNRecuperadasOriginal : 0))) :
                parseInt(embarques.piezasPintadas ? embarques.piezasPintadas : 0);

          //Se determina las piezas a embarcar como no aprobadas
          const piezasNoAceptadas = parseInt(embarcando.pNRecuperadasOriginal ? embarcando.pNRecuperadasOriginal : 0) === 0 ? 0 :
            (parseInt(embarcando.pNRecuperadasOriginal ? embarcando.pNRecuperadasOriginal : 0) <=
              parseInt(embarcando.piezasNRecuperadas ? embarcando.piezasNRecuperadas : 0)) ?
              parseInt(embarcando.pNRecuperadasOriginal ? embarcando.pNRecuperadasOriginal : 0) :
              (parseInt(embarcando.pPintadasOriginal ? embarcando.pPintadasOriginal : 0) <
                parseInt(embarques.piezasPintadas ? embarques.piezasPintadas : 0)) ?
                (parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0) +
                  (parseInt(embarcando.piezasPintadas ? embarcando.piezasPintadas : 0) -
                    parseInt(embarcando.pPintadasOriginal ? embarcando.pPintadasOriginal : 0))) :
                parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0);

          if (recibam.id) {
            var auxUltimaUbicacion = [];
            delete recibam.updatedAt;
            delete recibam.__typename;
            delete recibam.createdAt;

            //Piezas no pintadas para devolución.
            //Piezas de cuarentena no pintadas, embarcadas para su devolución. piezasCtnaEmbarcadas
            recibam.piezasCtnaEmbarcadas = parseInt(recibam.piezasCtnaEmbarcadas ? recibam.piezasCtnaEmbarcadas : 0) +
              parseInt(embarques.piezasNoPintadas ? embarques.piezasNoPintadas : 0);

            //Se actualiza el número de piezas no pintadas a embarcar piezasCtnaNAEmbarcar
            recibam.piezasCtnaNAEmbarcar = parseInt(recibam.piezasCtnaNAEmbarcar ? recibam.piezasCtnaNAEmbarcar : 0) -
              (parseInt(embarques.piezasNoPintadas ? embarques.piezasNoPintadas : 0));
            setMensajeAlertr("No se pudo determinar las piezas en cuarentena");
            // Se actualiza el número de piezas en cuarentena piezasenCuarentena*****
            if (parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0) > 0) {
              //Se revisa si hay suficiente material en piezasCtnaPintadaspara descontar las   piezasNRecuperadas
              const piezasNRAD = (parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0) <=
                parseInt(recibam.piezasCtnaPintadas ? recibam.piezasCtnaPintadas : 0)) ?
                parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0) :
                parseInt(recibam.piezasCtnaPintadas ? recibam.piezasCtnaPintadas : 0);

              if (parseInt(recibam.piezasCtnaPintadas ? recibam.piezasCtnaPintadas : 0) > 0 &&
                piezasNRAD > 0) {
                recibam.piezasCtnaPintadas = parseInt(recibam.piezasCtnaPintadas ? recibam.piezasCtnaPintadas : 0) - piezasNRAD;
              }

              //Se revisa si hay suficiente material en piezasNRecuperadas para descontar de piezasCtnaPintadasPC
              const piezasNRPC = parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0) >
                piezasNRAD ? parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0) - piezasNRAD : 0;

              if (parseInt(recibam.piezasCtnaPintadasPC ? recibam.piezasCtnaPintadasPC : 0) > 0 && piezasNRPC > 0) {
                recibam.piezasCtnaPintadasPC = parseInt(recibam.piezasCtnaPintadasPC ? recibam.piezasCtnaPintadasPC : 0) - piezasNRPC;
              }


            }
            if (parseInt(embarques.piezasNoPintadas ? embarques.piezasNoPintadas : 0) > 0 ||
              parseInt(piezasNoAceptadas ? piezasNoAceptadas : 0) > 0) {
              recibam.piezasenCuarentena = parseInt(recibam.piezasenCuarentena ? recibam.piezasenCuarentena : 0) -
                (parseInt(embarques.piezasNoPintadas ? embarques.piezasNoPintadas : 0) +
                  (parseInt(piezasNoAceptadas ? piezasNoAceptadas : 0)));
            }

            //Piezas pintadas.
            //Piezas embarcadas no recuperadas.
            recibam.PiezasENRecuperadas = parseInt(recibam.PiezasENRecuperadas ? recibam.PiezasENRecuperadas : 0) +
              parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0);


            //Piezas embarcadas pintadas.
            recibam.PiezasEPintadas = parseInt(recibam.PiezasEPintadas ? recibam.PiezasEPintadas : 0) +
              parseInt(embarques.piezasPintadas ? embarques.piezasPintadas : 0);//(recibam.Pcoat ? recibam.Pcoat : false) === false ? 
            //Piezas embarcadas pintadas extra 
            recibam.piezasPintadasExtra = parseInt(recibam.piezasPintadasExtra ? recibam.piezasPintadasExtra : 0) +
              parseInt(embarques.piezasPintadasExtra ? embarques.piezasPintadasExtra : 0);

            recibam.PiezasEPintadasPC = parseInt(recibam.PiezasEPintadasPC ? recibam.PiezasEPintadasPC : 0) +
              (recibam.Pcoat === true ? parseInt(embarques.piezasPintadas ? embarques.piezasPintadas : 0) : 0);

            recibam.PiezasENRecuperadasPC = parseInt(recibam.PiezasENRecuperadasPC ? recibam.PiezasENRecuperadasPC : 0) +
              (recibam.Pcoat === true ? parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0) : 0);

            //Piezas Embarcadas que se guardan en recibaSeriales
            recibam.piezasEmbarcadas = parseInt(recibam.piezasEmbarcadas ? recibam.piezasEmbarcadas : 0) +
              parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0) +
              parseInt(embarques.piezasPintadas ? embarques.piezasPintadas : 0) /*+
              parseInt(embarques.piezasNoPintadas ? embarques.piezasNoPintadas : 0)*/;

            //Piezas a embarcar que se guardan en recibaSeriales
            recibam.piezasAEmbarcar = parseInt(recibam.piezasAEmbarcar ? recibam.piezasAEmbarcar : 0) -
              (parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0) +
                parseInt(embarques.piezasPintadas ? embarques.piezasPintadas : 0));

            //Se cambia la ubicación del material de Producción Calidad a Embarques Embarcado, si así corresponde.              
            //Piezas pintadas satisfactóriamente.
            //Si las piezas pintadas anteriormente son mayor que las actuales,
            //Se tienen que pasar las piezas que corresponden a Calidad de Producción
            var json = false;

            setMensajeAlertr("Intentando cambiar ubicación");
            if (piezasCalidad > 0) {
              const loacionPiezas = "Embarcado";
              const ubicacionPiezas = "Embarques";
              const loacionAnterior = "Calidad";
              const ubicacionAnterior = recibam.Pcoat === true ? "Producción-P" : "Producción";
              const cantidadPiezas = parseInt(piezasCalidad);
              auxUltimaUbicacion = await cambioUbicacionSeriales(
                recibam,
                ubicacionAnterior,
                loacionAnterior,
                ubicacionPiezas,
                loacionPiezas,
                cantidadPiezas
              );
              json = true;
              //setMensajeAlert("Despues de obtener los datos del cambio de ubicación" + JSON.stringify(auxUltimaUbicacion));
              if (auxUltimaUbicacion.mensaje != "") {
                setMensajeAlert(auxUltimaUbicacion.mensaje);
                setColor(auxUltimaUbicacion.color);
                setCargando(false);
                setAVisible(true);
                return;
              } else {
                recibam.ultimaUbicacion = auxUltimaUbicacion.sUltimaU;
                recibam.rubicaciones = auxUltimaUbicacion.sUbicaciones;
                //setMensajeAlert("Ubicaciones agrupadas (1)" + JSON.stringify(auxUltimaUbicacion));
              }
            }
            //Piezas Pintadas no recúperadas.
            //Si las piezas pintadas anteriormente son menores que las actuales,
            //Se tienen que pasar las piezas que corresponden a Embarcado de Embarques
            if (piezasNoAceptadas > 0) {
              const loacionPiezas = "Embarcado";
              const ubicacionPiezas = "Embarques";
              const loacionAnterior = "";
              const ubicacionAnterior = "Cuarentena";
              const cantidadPiezas = parseInt(piezasNoAceptadas);
              auxUltimaUbicacion = await cambioUbicacionSeriales(
                recibam,
                ubicacionAnterior,
                loacionAnterior,
                ubicacionPiezas,
                loacionPiezas,
                cantidadPiezas,
                json
              );
              json = true;
              setMensajeAlert("Despues de obtener los datos del cambio de ubicación" + JSON.stringify(auxUltimaUbicacion));
              if (auxUltimaUbicacion.mensaje != "") {
                setMensajeAlert(auxUltimaUbicacion.mensaje);
                setColor(auxUltimaUbicacion.color);
                setCargando(false);
                setAVisible(true);
                return;
              } else {
                recibam.ultimaUbicacion = auxUltimaUbicacion.sUltimaU;
                recibam.rubicaciones = auxUltimaUbicacion.sUbicaciones;
                //setMensajeAlert("Ubicaciones agrupadas (2)" + JSON.stringify(auxUltimaUbicacion));
              }
            }
            //Piezas no pintadas.
            if (parseInt(embarques.piezasNoPintadas ? embarques.piezasNoPintadas : 0) > 0) {
              //setMensajeAlertr("Hay diferencias, piezasNoPintadasAnterior1: ");
              //return;
              const loacionPiezas = "Embarcado";
              const ubicacionPiezas = "Embarques";
              const loacionAnterior = "";
              const ubicacionAnterior = "Cuarentena";
              const cantidadPiezas = parseInt(embarques.piezasNoPintadas);
              auxUltimaUbicacion = await cambioUbicacionSeriales(
                recibam,
                ubicacionAnterior,
                loacionAnterior,
                ubicacionPiezas,
                loacionPiezas,
                cantidadPiezas,
                json
              );
              //setMensajeAlert("Despues de obtener los datos del cambio de ubicación" + JSON.stringify(auxUltimaUbicacion));
              if (auxUltimaUbicacion.mensaje != "") {
                setMensajeAlert(auxUltimaUbicacion.mensaje);
                setColor(auxUltimaUbicacion.color);
                setCargando(false);
                setAVisible(true);
                return;
              } else {
                recibam.ultimaUbicacion = auxUltimaUbicacion.sUltimaU;
                recibam.rubicaciones = auxUltimaUbicacion.sUbicaciones;
                //setMensajeAlertr("Ubicaciones agrupadas (3)" + JSON.stringify(auxUltimaUbicacion));
              }
            }
            /*------------------------------------------------------------------------------------------------------------*/
            //Se actualizan los datos en reciba Seriales                           
            recibam.Reg_Mod_Usuario = userName;
            if (recibam.piezasEmbarcadas >= recibam.cantidadRecibida) {
              recibam.piezasEnPlanta = false;
            } else {
              recibam.piezasEnPlanta = true;
            }


            if (!recibam.piezasCtnaRecuperadas) { delete recibam.piezasCtnaRecuperadas };
            if (!recibam.piezasInspeccion) { delete recibam.piezasInspeccion };
            if (!recibam.piezasInspeccionPC) { delete recibam.piezasInspeccionPC };
            if (!recibam.piezasIRecuperacion) { delete recibam.piezasIRecuperacion };
            if (!recibam.piezasCRecuperacion) { delete recibam.piezasCRecuperacion };
            if (!recibam.PiezasCtnaRecuperacion) { delete recibam.PiezasCtnaRecuperacion };
            if (!recibam.piezasTRecuperacion) { delete recibam.piezasTRecuperacion };
            if (!recibam.piezasRecuperadas) { delete recibam.piezasRecuperadas };
            if (!recibam.piezasFacturadas) { delete recibam.piezasFacturadas; }
            if (!recibam.UltimaInspeccionCuarentena) { delete recibam.UltimaInspeccionCuarentena; }
            if (!recibam.piezasCtnaNRecuperadas) { delete recibam.piezasCtnaNRecuperadas; };

            setMensajeAlertr("Error al actualizar reciba seriales" + JSON.stringify(recibam)); // + JSON.stringify(recibam)
            let upRecibaS = await API.graphql({
              query: updateRecibaSeriales,
              variables: { input: recibam },
            });
            if (recibam.piezasEnPlanta === false) {
              setMensajeAlertr("No se pudo eliminar de la tabla temporal; ");
              await API.graphql({ query: deleteRecibaSerialesMP, variables: { input: { id: recibam.recibaSerialMPID, } } });
            } else {
              //Se actualizan los datos en recibaSerialesMP
              const recibaSerialMPID = recibam.recibaSerialMPID;
              if (recibam.recibaSerialMPID) {
                delete recibam.recibaSerialMPID;
                setMensajeAlertr("Operación errónea; Problemas al guardar los datos del serial" + JSON.stringify(recibam));
                await API.graphql({ query: updateRecibaSerialesMP, variables: { input: { ...recibam, id: recibaSerialMPID, rsUpdatedAt: upRecibaS.data.updateRecibaSeriales.updatedAt } }, });
              }
            }
          }
          //Se preparan los datos para actualizar los datos de los embarques seriales
          var listaSeriares = [...inputList];
          //Se revisa si se tiene que agregar o actualizar un serial reciba
          //Si el material que se quiere agregar ya se encuentra en la planeación, solo se suma la cantidad que corresponde.
          const datoRepetido = listaSeriares.filter((datosEmbarque) => datosEmbarque.recibaSerialID === embarques.recibaSerialID && datosEmbarque.activo === true)
          setMensajeAlertr("Filtrado");
          //Datos de los embarques.
          delete embarques.registro;
          delete embarques.pNoPintadasOriginal;
          delete embarques.updatedAt;
          delete embarques.__typename;
          //delete embarques.MaterialPintado;
          if (!datoRepetido[0]) {
            embarques.orden = listaSeriares.length ? listaSeriares.length + 1 : 1;
            embarques.clienteEntregaID = clienteEntregaID;
            embarques.clienteEntrega = rClienteEntrega;
            embarques.facturarA = rClienteFacturarA;

            embarques.embarqueID = embarqueid;
            embarques.numero = EmbarquesC.numero;
            embarques.fechaDeEmbarque = fechaDeEmbarque;
            embarques.atencionA = atencionA;
            embarques.ordenDeCompra = ordenDeCompra;
            embarques.numeroSerial = PnumeroSerial;
            embarques.piezasPintadas = parseInt(embarques.piezasPintadas ? embarques.piezasPintadas : 0);
            embarques.piezasNRecuperadas = parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0);
            embarques.piezasEmbarcadas =
              parseInt(embarques.piezasPintadas ? embarques.piezasPintadas : 0) +
              parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0) +
              parseInt(embarques.piezasPintadasExtra ? embarques.piezasPintadasExtra : 0);
            embarques.pPintadasOriginal = parseInt(piezasCalidad ? piezasCalidad : 0);
            embarques.pNRecuperadasOriginal = parseInt(piezasNoAceptadas ? piezasNoAceptadas : 0);

            /*+
            parseInt(embarques.piezasNoPintadas ? embarques.piezasNoPintadas : 0);*/
            embarques.Reg_Ins_Usuario = userName;
            const desgloceInsercionEmbs = {
              serialNRecuperado: embarques.serialNRecuperado ? embarques.serialNRecuperado : "", piezasPintadasExtra: embarques.piezasPintadasExtra ? embarques.piezasPintadasExtra : "",
              piezasPintadas: embarques.piezasPintadas ? embarques.piezasPintadas : "", piezasNRecuperadas: embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : "",
              piezasNoPintadas: embarques.piezasNoPintadas ? embarques.piezasNoPintadas : "", materialEn: embarques.materialEn ? embarques.materialEn : "",
              materialEnCantidad: embarques.materialEnCantidad ? embarques.materialEnCantidad : "", comentarios: embarques.comentarios ? embarques.comentarios : "",
              Reg_Ins_Usuario: userName, Reg_Ins_Fecha: Moment(new Date()).format("YYYY-MM-DD HH:mm"), activo: true
            };
            if (!embarques.desgloceInsercion) {
              embarques.desgloceInsercion = (desgloceInsercionEmbs);
            } else {
              embarques.desgloceInsercion.push(desgloceInsercionEmbs);
            }
            delete embarques.MaterialPintado;
            delete embarques.piezasCtnaPintadasPC;
            delete embarques.piezasCtnaPintadas;
            setMensajeAlertr("Error guardar el embarque por serial 1" + JSON.stringify(embarques));
            let resultado = await API.graphql({
              query: createEmbarqueSeriales,
              variables: { input: embarques },
            });
            //Se preparan los datos para actualizar los datos de los embarques
            const serialAgredado = resultado.data.createEmbarqueSeriales;
            idAgregado.push({ id: serialAgredado.id, nuevo: true, activo: true });
            listaSeriares.push({ ...serialAgredado, modificado: false });
            const serialModificado = [...inputList, { ...serialAgredado, modificado: false }];
            setEmbarqueSerialEditar(serialModificado);
          } else if (datoRepetido[0].id) {
            setMensajeAlertr("Dato repetido" + JSON.stringify(datoRepetido));
            const embarqueReg = await GetEmbarquesSerialesID(datoRepetido[0].id);
            setMensajeAlertr("Datos de embarque serial" + JSON.stringify(embarqueReg));
            if (embarques.MaterialPintado === true) {
              setMensajeAlertr("Datos de embarque serial - Material pintado");
              embarqueReg.piezasPintadas = parseInt(embarqueReg.piezasPintadas ? embarqueReg.piezasPintadas : 0) +
                parseInt(embarques.piezasPintadas ? embarques.piezasPintadas : 0);
              embarqueReg.piezasPintadasExtra = parseInt(embarqueReg.piezasPintadasExtra ? embarqueReg.piezasPintadasExtra : 0) +
                parseInt(embarques.piezasPintadasExtra ? embarques.piezasPintadasExtra : 0);
              embarqueReg.piezasNRecuperadasE = aMRecuperado;
              embarqueReg.piezasNRecuperadas = parseInt(embarqueReg.piezasNRecuperadas ? embarqueReg.piezasNRecuperadas : 0) +
                parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0);
              embarqueReg.pPintadasOriginal = parseInt(embarqueReg.pPintadasOriginal ? embarqueReg.pPintadasOriginal : 0) +
                parseInt(piezasCalidad ? piezasCalidad : 0);
              embarqueReg.pNRecuperadasOriginal = parseInt(embarqueReg.pNRecuperadasOriginal ? embarqueReg.pNRecuperadasOriginal : 0) +
                parseInt(piezasNoAceptadas ? piezasNoAceptadas : 0);
              embarqueReg.ambos = embarqueReg.MaterialPintado === false ? true : false;
              setMensajeAlertr("Datos de embarque serial - Material pintado" + JSON.stringify(embarqueReg));
            }
            if (embarques.MaterialPintado === false) {
              setMensajeAlertr("Datos de embarque serial - Material no pintado");
              embarqueReg.piezasNoPintadas = parseInt(embarqueReg.piezasNoPintadas ? embarqueReg.piezasNoPintadas : 0) +
                parseInt(embarques.piezasNoPintadas ? embarques.piezasNoPintadas : 0);
              /*embarqueReg.pNoPintadasOriginal = parseInt(embarqueReg.pNoPintadasOriginal ? embarqueReg.pNoPintadasOriginal : 0) +
                parseInt(embarques.pNoPintadasOriginal ? embarques.pNoPintadasOriginal : 0);*/
              embarqueReg.piezasCtnaNRecuperadas = parseInt(embarqueReg.piezasCtnaNRecuperadas ? embarqueReg.piezasCtnaNRecuperadas : 0) +
                parseInt(embarques.piezasCtnaNRecuperadas ? embarques.piezasCtnaNRecuperadas : 0);
              embarqueReg.ambos = embarqueReg.MaterialPintado === true ? true : false;
              setMensajeAlertr("Datos de embarque serial - Material no pintado" + JSON.stringify(embarqueReg));
            }

            embarqueReg.piezasEmbarcadas = parseInt(embarqueReg.piezasPintadas ? embarqueReg.piezasPintadas : 0) +
              parseInt(embarqueReg.piezasNRecuperadas ? embarqueReg.piezasNRecuperadas : 0) +
              parseInt(embarqueReg.piezasPintadasExtra ? embarqueReg.piezasPintadasExtra : 0);/* +
              parseInt(embarqueReg.piezasNoPintadas ? embarqueReg.piezasNoPintadas : 0)*/;

            embarqueReg.Reg_Mod_Usuario = userName;
            const desgloceInsercionEmbs = {
              serialNRecuperado: embarques.serialNRecuperado ? embarques.serialNRecuperado : "", piezasPintadasExtra: embarques.piezasPintadasExtra ? embarques.piezasPintadasExtra : "",
              piezasPintadas: embarques.piezasPintadas ? embarques.piezasPintadas : "", piezasNRecuperadas: embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : "",
              piezasNoPintadas: embarques.piezasNoPintadas ? embarques.piezasNoPintadas : "", materialEn: embarques.materialEn ? embarques.materialEn : "",
              materialEnCantidad: embarques.materialEnCantidad ? embarques.materialEnCantidad : "", comentarios: embarques.comentarios ? embarques.comentarios : "",
              Reg_Ins_Usuario: userName, Reg_Ins_Fecha: Moment(new Date()).format("YYYY-MM-DD HH:mm"), activo: true
            };
            if (!embarqueReg.desgloceInsercion) {
              embarqueReg.desgloceInsercion = (desgloceInsercionEmbs);
            } else {
              embarqueReg.desgloceInsercion.push(desgloceInsercionEmbs);
            }
            delete embarqueReg.createdAt;
            delete embarqueReg.updatedAt;
            delete embarqueReg.__typename;
            setMensajeAlertr("Error al intentar guardar los cambios en embarqueseriales: " + JSON.stringify(embarqueReg));
            let resultado = await API.graphql({
              query: updateEmbarqueSeriales,
              variables: { input: embarqueReg },
            });
            //Se preparan los datos para actualizar los datos de los embarques
            //idAgregado.push({ id: resultado.data.updateEmbarqueSeriales.id, nuevo: true, activo: true });
            const serialAgredado = await GetEmbarquesSeriales({ numero: { eq: resultado.data.updateEmbarqueSeriales.numero } });
            //listaSeriares = serialAgredado.sort((a, b) => a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0);
            //const serialAgredado = resultado.data.updateEmbarqueSeriales;
            //listaSeriares.splice((serialAgredado.orden - 1), 1);            
            //inputList.splice((serialAgredado.orden - 1), 1);
            const serialModificado = serialAgredado.map((sA) => ({ ...sA, modificado: false }));
            listaSeriares = serialAgredado.map((sA) => ({ ...sA, modificado: false }));;
            setEmbarqueSerialEditar(serialModificado.sort((a, b) => a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0));
          }
          //const embarquesSeriales = listaSeriares.sort((a, b) => a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0);
          //setInputList(listaSeriares.sort((a, b) => a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0));

          //Se actualizan los datos de embarques             
          var formData = await GetEmbarquesID(embarqueid);
          const nserialesEID = await combinarIDS(formData.serialesEID ? formData.serialesEID : [], idAgregado);
          formData.fechaDeEmbarque = fechaDeEmbarque;
          formData.atencionA = atencionA;
          formData.ordenDeCompra = ordenDeCompra;
          formData.clienteID = clienteID;
          formData.cliente = rCliente;
          formData.serialesEID = nserialesEID;
          formData.clienteEntregaID = clienteEntregaID;
          formData.clienteEntrega = rClienteEntrega;
          formData.facturarA = rClienteFacturarA;
          formData.fechaDeReciba = listaSeriares[0] ? listaSeriares[0].fechaDeReciba : "";
          formData.MFGFecha = listaSeriares[0] ? listaSeriares[0].MFGFecha : "";
          formData.piezasPintadas = listaSeriares[0] ? sumarPiezasP(listaSeriares) : 0;
          formData.piezasNRecuperadas = listaSeriares[0] ? sumarPiezasNR(listaSeriares) : 0;
          formData.piezasNoPintadas = listaSeriares[0] ? sumarPiezasNP(listaSeriares) : 0;
          formData.activo = true;
          formData.Reg_Ins_Usuario = userName;
          formData.piezasEmbarcadas = listaSeriares[0] ?
            (parseInt(formData.piezasPintadas) +
              parseInt(formData.piezasNRecuperadas) +
              (listaSeriares[0] ? sumarPiezasExtra(listaSeriares) : 0)
              /* +
              parseInt(formData.piezasNoPintadas)*/) : 0;
          formData.piezasPintadasExtra = listaSeriares[0] ?
            (listaSeriares[0] ? sumarPiezasExtra(listaSeriares) : 0) : 0;
          formData.packings = listaSeriares[0] ? concatenarPackings(listaSeriares) : "";
          formData.numerosdeParte = listaSeriares[0] ? concatenarNumerosdeParte(listaSeriares) : "";
          formData.lotes = listaSeriares[0] ? concatenarLotes(listaSeriares) : "";
          formData.seriales = listaSeriares[0] ? concatenarSeriales(listaSeriares) : "";
          formData.totalNumerodeParte = iTotalNParte;
          formData.sinTotalScrap = sinTotalScrap;
          formData.sinTotalScrapFactura = sinTotalScrapFactura;
          formData.desgloceVer = desgloceVer;
          delete formData.createdAt;
          delete formData.updatedAt;
          delete formData.__typename;
          setMensajeAlertr("Error al intentar guardar los datos del embarque 1");
          let resultadoE = await API.graphql({
            query: updateEmbarque,
            variables: { input: formData },
          });
          //Se preparan los datos para actualizar los datos de los embarques
          const embarqueActualizado = resultadoE.data.updateEmbarque;
          //Se preparan los datos para guardarlos en el resumen de operación
          //Se registran los datos en Resumen de operación
          embarcando.piezasEnPlanta = recibam.piezasEnPlanta;
          embarcando.precioUnitario = recibam.precioUnitario;
          embarcando.Ecoat = recibam.Ecoat;
          embarcando.Pcoat = recibam.Pcoat;
          embarcando.precioUnitarioPC = recibam.precioUnitarioPC;
          const rOperacion = await manageResumenOperacion(fechaDeEmbarque, embarcando, "Embarques", userName, embarqueid);
          clicEditar(embarqueActualizado);
          //setEmbarqueEditando(embarqueActualizado);
          setMensajeAlertr("Operación exitosa");
          //setisDisabled(false);
          setEmbarqueParticular(false);
          setColorr("primary");
          setAVisibler(true);
          setCargando1(false);
          setDRegresarAE(false);
          setSearchReciba("");
          fetchReciba(comCAS, true, buscarporFecha, searchByReciba, "");
          //setisDisabled(true);          
        } else {
          //Si la fecha es diferente significa que sí hay concurrencia y que se tienen que actualizar los datos
          window.scrollTo(0, 0);
          setMensajeAlertr(
            "No fue posible realizar la operación: existe concurrencia, se requiere cancelar la operación y " +
            " volver a intentarlo"
          );
          setColorr("warning");
          setCargando1(false);
          setAVisibler(true);
          //setisDisabled(false);
          //fetchEmbarques(rfechaini, rfechafin);
        }

      }
    } catch (e) {
      window.scrollTo(0, 0);
      //setMensajeAlert(e.message);
      //"No fue posible terminar la operación: revise si la operación se realizó parcialmente, revise su conexión a internet y vuelva a intentar, si el problema persiste, favor de comunicarte a sistemas"
      setColorr("warning");
      setAVisibler(true);
      setCargando1(false);
      setDRegresarAE(false);
      //setisDisabled(false);
    }
  }

  async function manageEmbarques() {
    setAVisible(false);
    setCargando(true);
    setisDisabled(true);
    try {
      setMensajeAlert("Revisando cambios");
      //Proceso para guardar Seriales
      if (servicios === false) {
        const piezasPintadasSum = sumarPiezasP(inputList); //inputList[0].piezasNRecuperadas;
        const piezasNRecuperadasSum = sumarPiezasNR(inputList); //inputList[0].piezasNRecuperadas;
        const piezasNoPintadasSum = sumarPiezasNP(inputList);
        const inputListDesgloce = desgloceVer === true ? concatenarDatosDesgloceSeriales(inputList) : [];
        const ILCambios = desgloceVer === true ? inputListDesgloce.filter(embarques => embarques.modificado === true) :
          inputList.filter(embarques => embarques.modificado === true);
        // const ILCambios = inputList.filter(embarques => embarques.modificado === true);
        /*setMensajeAlert("Cambios revisados" + JSON.stringify(ILCambios));
        setAVisible(true);
        setCargando(false);
        return;*/
        if (ILCambios[0]) {
          setMensajeAlert("Sí hay cambios");
          const datosCompletos = await revisarDatosCompletos(ILCambios);
          const cantidadValida = await revisarCantidadValida(ILCambios);
          setMensajeAlert("Datos revisados");
          var mensaje = "";
          if (!fechaDeEmbarque || !atencionA || !ordenDeCompra || !clienteID || !rCliente || datosCompletos === false) {
            mensaje = "Faltan datos; los campos marcados con un asterísco son obligatorios. 3" + JSON.stringify(ILCambios);
            setMensajeAlert(mensaje);
          }
          if (cantidadValida === false) {
            mensaje =
              mensaje +
              "\n Datos no válidos; la suma de las cantidades a embarcar no debe ser mayor o menor a la cantidad original disponible," +
              " tampoco puede ser cero, se marca en rojo la cantidad errónea. Si tiene que hacer algún cambio en la suma de las cantidades," +
              "debe eliminar y volver agregar el registro con las cantidades correctas.";
            setMensajeAlert(mensaje);
          }
          setMensajeAlert("Revisando mensajes");
          if (mensaje !== "") {
            setMensajeAlert(mensaje);
            setColor("warning");
            setAVisible(true);
            setisDisabled(false);
            setCargando(false);
            window.scrollTo(0, 0);
            return
          } else {
            setMensajeAlert("Sin mensaje");
            var pConcurrencia = false;
            var embarqueid = embarqueEditando.id;
            var EmbarquesC = {};
            var recibaSerialE = {};
            setMensajeAlert("Antes de editar");
            if (embarqueEditando.id) {
              setMensajeAlert("Editando");
              //Se obtienen los datos del embarque por id para revisa la concurrencia
              EmbarquesC = await GetEmbarquesID(embarqueid);
              setMensajeAlert("Datos de embarque; " + JSON.stringify(EmbarquesC));
              if (!EmbarquesC.id) {
                pConcurrencia = true;
              } else {
                if (EmbarquesC.updatedAt !== embarqueEditando.updatedAt) {
                  pConcurrencia = true;
                  mensaje = "Operación denegada; concurrencia en los datos generales del embarque.";
                }
              }
              await Promise.all(
                ILCambios.map(async (embarques) => {
                  if (embarques.id) {
                    setMensajeAlert(
                      "Error al obtener los embarques por serial para revisar la concurrencia"
                    );
                    //Se obtienen los datos de embarques seriales por id
                    const EmbarquesS = await GetEmbarquesSerialesID(embarques.id);
                    if (!EmbarquesS.id) {
                      pConcurrencia = true;
                    } else {
                      if (embarques.updatedAt !== EmbarquesS.updatedAt)
                        pConcurrencia = true;
                    }
                    embarqueid = embarques.embarqueID;
                  }
                }));
            } else {
              mensaje = "Operación denegada; no se encontraron datos del embarque relacionado, favor de comunicarse a sistemas";
              setMensajeAlert(mensaje);
            }
            setMensajeAlert("Sin mensaje 2; " + mensaje);
            //Se revisa si hay mensaje de error, si es así, se termina la transacción.
            if (mensaje !== "") {
              setMensajeAlert(mensaje);
              setColor("warning");
              setAVisible(true);
              setisDisabled(false);
              setCargando(false);
              window.scrollTo(0, 0);
              return;
            }
            if (pConcurrencia === false) {
              //setMensajeAlert("Sin concurrencia");
              var i = 1;
              var idAgregado = [];
              //Se obtienen los datos del último número de embarques  para obtener el útmimoNumeroSerial.
              setMensajeAlert("Sin concurrencia");
              const apiData = await API.graphql({
                query: listEmbarqueUltimoNumeros,
                variables: { limit: 100000000 },
              });
              const ultimapFromAPI = apiData.data.listEmbarqueUltimoNumeros.items;
              const PnumeroSerial = ultimapFromAPI[0] ? (ultimapFromAPI[0].UltimoNumeroSerial + 1) : 1;
              await Promise.all(
                ILCambios.map(async (embarques) => {
                  //Actualiza las piezasEmbarcadas en reciba seriales si hubo cambios en la cantidad de piezas embarcadas

                  //setMensajeAlert("Error obtener la reciba serial correspondiente");
                  //Se obtiene el registro actualizado de los reciba seriales por id
                  const recibam = await GetRecibaSerialesID(embarques.recibaSerialID);
                  setMensajeAlert("Se obtuvieron los datos del serial correspondiente ");
                  const enPlantaOriginal = recibam.piezasEnPlanta;
                  if (recibam.id) {
                    var auxUltimaUbicacion = [];
                    //Diferencia entre las piezas  pintadas
                    const diferenciaPiezas = parseInt(embarques.pPintadasAnterior ? embarques.pPintadasAnterior : 0) +
                      parseInt(embarques.pNRecuperadasAnterior ? embarques.pNRecuperadasAnterior : 0) -
                      (parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0) +
                        parseInt(embarques.piezasPintadas ? embarques.piezasPintadas : 0));
                    const diferenciaPiezasExtra = parseInt(embarques.pPintadasAnteriorExtra ? embarques.pPintadasAnteriorExtra : 0) -
                      (parseInt(embarques.piezasPintadasExtra ? embarques.piezasPintadasExtra : 0));


                    //Diferencia entre las piezas no pintadas
                    const diferenciaPiezasNP = parseInt(embarques.pNoPintadasOriginal ? embarques.pNoPintadasOriginal : 0) -
                      parseInt(embarques.piezasNoPintadas ? embarques.piezasNoPintadas : 0);

                    //Diferencia entre las piezas  en cuarentena
                    const diferenciaPiezasCtna = parseInt(embarques.pNoPintadasOriginal ? embarques.pNoPintadasOriginal : 0) +
                      parseInt(embarques.pNRecuperadasAnterior ? embarques.pNRecuperadasAnterior : 0) -
                      (parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0) +
                        parseInt(embarques.piezasNoPintadas ? embarques.piezasNoPintadas : 0));

                    setMensajeAlert(
                      "Se obtuvieron los datos del serial correspondiente, diferencia: " +
                      diferenciaPiezasNP
                    );
                    const piezasEmbarcardasInicial = recibam.piezasEmbarcadas ? recibam.piezasEmbarcadas : 0;
                    const piezasNPEmbarcardasInicial = recibam.piezasCtnaEmbarcadas ? recibam.piezasCtnaEmbarcadas : 0;

                    delete recibam.updatedAt;
                    delete recibam.__typename;
                    delete recibam.createdAt;
                    //Piezas no pintadas para devolución.
                    //Piezas de cuarentena no pintadas, embarcadas para su devolución. piezasCtnaEmbarcadas
                    recibam.piezasCtnaEmbarcadas = !editar ? parseInt(recibam.piezasCtnaEmbarcadas ? recibam.piezasCtnaEmbarcadas : 0) +
                      parseInt(embarques.piezasNoPintadas ? embarques.piezasNoPintadas : 0) :
                      embarques.activo === false ? parseInt(recibam.piezasCtnaEmbarcadas ? recibam.piezasCtnaEmbarcadas : 0) -
                        parseInt(embarques.piezasNoPintadas ? embarques.piezasNoPintadas : 0) :
                        !embarques.embarqueID ? parseInt(recibam.piezasCtnaEmbarcadas ? recibam.piezasCtnaEmbarcadas : 0) +
                          parseInt(embarques.piezasNoPintadas ? embarques.piezasNoPintadas : 0) : diferenciaPiezasNP < 0 ?
                          parseInt(recibam.piezasCtnaEmbarcadas ? recibam.piezasCtnaEmbarcadas : 0) + diferenciaPiezasNP * -1 :
                          parseInt(recibam.piezasCtnaEmbarcadas ? recibam.piezasCtnaEmbarcadas : 0) - diferenciaPiezasNP;

                    //Se actualiza el número de piezas no pintadas a embarcar piezasCtnaNAEmbarcar
                    recibam.piezasCtnaNAEmbarcar = !editar ? parseInt(recibam.piezasCtnaNAEmbarcar ? recibam.piezasCtnaNAEmbarcar : 0) -
                      parseInt(embarques.piezasNoPintadas ? embarques.piezasNoPintadas : 0) : embarques.activo === false ?
                      parseInt(recibam.piezasCtnaNAEmbarcar ? recibam.piezasCtnaNAEmbarcar : 0) +
                      parseInt(embarques.piezasNoPintadas ? embarques.piezasNoPintadas : 0) :
                      !embarques.embarqueID ? parseInt(recibam.piezasCtnaNAEmbarcar ? recibam.piezasCtnaNAEmbarcar : 0) -
                        parseInt(embarques.piezasNoPintadas ? embarques.piezasNoPintadas : 0) : diferenciaPiezasNP < 0 ?
                        parseInt(recibam.piezasCtnaNAEmbarcar ? recibam.piezasCtnaNAEmbarcar : 0) -
                        diferenciaPiezasNP * -1 : parseInt(recibam.piezasCtnaNAEmbarcar ? recibam.piezasCtnaNAEmbarcar : 0) + diferenciaPiezasNP;

                    // Se actualiza el número de piezas en cuarentena piezasenCuarentena*****
                    if (embarques.activo === false) {
                      recibam.piezasenCuarentena = !editar ? parseInt(recibam.piezasenCuarentena ? recibam.piezasenCuarentena : 0) -
                        (parseInt(embarques.piezasNoPintadas ? embarques.piezasNoPintadas : 0) +
                          parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0)) :
                        embarques.activo === false ? parseInt(recibam.piezasenCuarentena ? recibam.piezasenCuarentena : 0) +
                          (parseInt(embarques.piezasNoPintadas ? embarques.piezasNoPintadas : 0) +
                            parseInt(embarques.pNRecuperadasOriginal ? embarques.pNRecuperadasOriginal : 0)) :
                          !embarques.embarqueID ? parseInt(recibam.piezasenCuarentena ? recibam.piezasenCuarentena : 0) -
                            (parseInt(embarques.piezasNoPintadas ? embarques.piezasNoPintadas : 0) +
                              parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0)) :
                            diferenciaPiezasCtna < 0 ? parseInt(recibam.piezasenCuarentena ? recibam.piezasenCuarentena : 0) -
                              diferenciaPiezasCtna * -1 : parseInt(recibam.piezasenCuarentena ? recibam.piezasenCuarentena : 0) +
                            diferenciaPiezasCtna;

                      const piezasNRAD = parseInt(embarques.piezasNoAceptadas ? embarques.piezasNoAceptadas : 0) > 0 ?
                        (parseInt(embarques.piezasNoAceptadas ? embarques.piezasNoAceptadas : 0) >=
                          parseInt(recibam.pNRecuperadasOriginal ? recibam.pNRecuperadasOriginal : 0)) ?
                          parseInt(embarques.pNRecuperadasOriginal ? embarques.pNRecuperadasOriginal : 0) :
                          parseInt(recibam.piezasNoAceptadas ? recibam.piezasNoAceptadas : 0) : 0;

                      recibam.piezasCtnaPintadas = !editar ? parseInt(recibam.piezasCtnaPintadas ? recibam.piezasCtnaPintadas : 0) -
                        parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0) :
                        embarques.activo === false ? parseInt(recibam.piezasCtnaPintadas ? recibam.piezasCtnaPintadas : 0) +
                          piezasNRAD : //parseInt(embarques.pNRecuperadasOriginal ? embarques.pNRecuperadasOriginal : 0)
                          !embarques.embarqueID ? parseInt(recibam.piezasCtnaPintadas ? recibam.piezasCtnaPintadas : 0) -
                            parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0) :
                            diferenciaPiezasCtna < 0 ? parseInt(recibam.piezasCtnaPintadas ? recibam.piezasCtnaPintadas : 0) -
                              diferenciaPiezasCtna * -1 : parseInt(recibam.piezasCtnaPintadas ? recibam.piezasCtnaPintadas : 0) +
                            diferenciaPiezasCtna;

                      if (parseInt(recibam.piezasNoAceptadasPC ? recibam.piezasNoAceptadasPC : 0) > 0) {
                        //Se revisa si hay suficiente material en piezasNoAceptadasPC para descontar de pNRecuperadasOriginal
                        const piezasNRPC = parseInt(embarques.pNRecuperadasOriginal ? embarques.pNRecuperadasOriginal : 0) >=
                          piezasNRAD ? parseInt(embarques.pNRecuperadasOriginal ? embarques.pNRecuperadasOriginal : 0) - piezasNRAD : 0;

                        if (piezasNRPC > 0) {
                          recibam.piezasCtnaPintadasPC = parseInt(recibam.piezasCtnaPintadasPC ? recibam.piezasCtnaPintadasPC : 0) + piezasNRPC;
                        }


                      }
                    }

                    //Piezas pintadas.
                    //Piezas embarcadas no recuperadas.
                    recibam.PiezasENRecuperadas = !editar ? parseInt(recibam.PiezasENRecuperadas ? recibam.PiezasENRecuperadas : 0) +
                      parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0) : embarques.activo === false ?
                      parseInt(recibam.PiezasENRecuperadas ? recibam.PiezasENRecuperadas : 0) -
                      parseInt(embarques.pNRecuperadasAnterior ? embarques.pNRecuperadasAnterior : 0) :
                      !embarques.embarqueID ? parseInt(recibam.PiezasENRecuperadas ? recibam.PiezasENRecuperadas : 0) +
                        parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0) :
                        parseInt(recibam.PiezasENRecuperadas ? recibam.PiezasENRecuperadas : 0) -
                        parseInt(embarques.pNRecuperadasAnterior ? embarques.pNRecuperadasAnterior : 0) +
                        parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0);

                    //Piezas embarcadas pintadas.
                    recibam.PiezasEPintadas = !editar ? parseInt(recibam.PiezasEPintadas ? recibam.PiezasEPintadas : 0) +
                      parseInt(embarques.piezasPintadas) : embarques.activo === false ?
                      parseInt(recibam.PiezasEPintadas ? recibam.PiezasEPintadas : 0) -
                      parseInt(embarques.pPintadasAnterior) : !embarques.embarqueID ?
                        parseInt(recibam.PiezasEPintadas ? recibam.PiezasEPintadas : 0) +
                        parseInt(embarques.piezasPintadas) : parseInt(recibam.PiezasEPintadas ? recibam.PiezasEPintadas : 0) -
                        parseInt(embarques.pPintadasAnterior ? embarques.pPintadasAnterior : 0) +
                        parseInt(embarques.piezasPintadas ? embarques.piezasPintadas : 0);

                    //Piezas embarcadas pintadas extra 
                    recibam.piezasPintadasExtra = !editar ? parseInt(recibam.piezasPintadasExtra ? recibam.piezasPintadasExtra : 0) +
                      parseInt(embarques.piezasPintadasExtra ? embarques.piezasPintadasExtra : 0) : embarques.activo === false ?
                      parseInt(recibam.piezasPintadasExtra ? recibam.piezasPintadasExtra : 0) -
                      (parseInt(embarques.pPintadasAnteriorExtra ? embarques.pPintadasAnteriorExtra : 0)) :
                      !embarques.embarqueID ? parseInt(recibam.piezasPintadasExtra ? recibam.piezasPintadasExtra : 0) +
                        (parseInt(embarques.piezasPintadasExtra ? embarques.piezasPintadasExtra : 0)) : diferenciaPiezasExtra < 0 ?
                        parseInt(recibam.piezasPintadasExtra ? recibam.piezasPintadasExtra : 0) + diferenciaPiezasExtra * -1 :
                        parseInt(recibam.piezasPintadasExtra ? recibam.piezasPintadasExtra : 0) - diferenciaPiezasExtra;

                    /*!editar ? parseInt(recibam.piezasPintadasExtra ? recibam.piezasPintadasExtra : 0) +
                  parseInt(embarques.piezasPintadasExtra) : embarques.activo === false ?
                  parseInt(recibam.piezasPintadasExtra ? recibam.piezasPintadasExtra : 0) -
                  parseInt(embarques.pPintadasAnteriorExtra) : !embarques.embarqueID ?
                    parseInt(recibam.piezasPintadasExtra ? recibam.piezasPintadasExtra : 0) +
                    parseInt(embarques.piezasPintadasExtra) : parseInt(recibam.piezasPintadasExtra ? recibam.piezasPintadasExtra : 0) -
                    parseInt(embarques.pPintadasAnteriorExtra ? embarques.pPintadasAnteriorExtra : 0) +
                    parseInt(embarques.piezasPintadasExtra ? embarques.piezasPintadasExtra : 0);*/

                    //Piezas embarcadas pintadas PC.
                    if (recibam.Pcoat === true) {
                      recibam.PiezasEPintadasPC = !editar ? parseInt(recibam.PiezasEPintadasPC ? recibam.PiezasEPintadasPC : 0) +
                        parseInt(embarques.piezasPintadas) : embarques.activo === false ?
                        parseInt(recibam.PiezasEPintadasPC ? recibam.PiezasEPintadasPC : 0) -
                        parseInt(embarques.pPintadasAnterior) : !embarques.embarqueID ?
                          parseInt(recibam.PiezasEPintadasPC ? recibam.PiezasEPintadasPC : 0) +
                          parseInt(embarques.piezasPintadas) : parseInt(recibam.PiezasEPintadasPC ? recibam.PiezasEPintadasPC : 0) -
                          parseInt(embarques.pPintadasAnterior ? embarques.pPintadasAnterior : 0) +
                          parseInt(embarques.piezasPintadas ? embarques.piezasPintadas : 0);

                      recibam.PiezasENRecuperadasPC = !editar ? parseInt(recibam.PiezasENRecuperadasPC ? recibam.PiezasENRecuperadasPC : 0) +
                        parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0) : embarques.activo === false ?
                        parseInt(recibam.PiezasENRecuperadasPC ? recibam.PiezasENRecuperadasPC : 0) -
                        parseInt(embarques.pNRecuperadasAnterior ? embarques.pNRecuperadasAnterior : 0) :
                        !embarques.embarqueID ? parseInt(recibam.PiezasENRecuperadasPC ? recibam.PiezasENRecuperadasPC : 0) +
                          parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0) :
                          parseInt(recibam.PiezasENRecuperadasPC ? recibam.PiezasENRecuperadasPC : 0) -
                          parseInt(embarques.pNRecuperadasAnterior ? embarques.pNRecuperadasAnterior : 0) +
                          parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0);
                    }



                    //Piezas Embarcadas que se guardan en recibaSeriales
                    recibam.piezasEmbarcadas = !editar ? parseInt(recibam.piezasEmbarcadas ? recibam.piezasEmbarcadas : 0) +
                      parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0) +
                      parseInt(embarques.piezasPintadas ? embarques.piezasPintadas : 0) : embarques.activo === false ?
                      parseInt(recibam.piezasEmbarcadas ? recibam.piezasEmbarcadas : 0) -
                      (parseInt(embarques.pPintadasOriginal ? embarques.pPintadasOriginal : 0) +
                        parseInt(embarques.pNRecuperadasOriginal ? embarques.pNRecuperadasOriginal : 0)) :
                      !embarques.embarqueID ? parseInt(recibam.piezasEmbarcadas ? recibam.piezasEmbarcadas : 0) +
                        (parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0) +
                          parseInt(embarques.piezasPintadas ? embarques.piezasPintadas : 0)) : diferenciaPiezas < 0 ?
                        parseInt(recibam.piezasEmbarcadas ? recibam.piezasEmbarcadas : 0) + diferenciaPiezas * -1 :
                        parseInt(recibam.piezasEmbarcadas ? recibam.piezasEmbarcadas : 0) - diferenciaPiezas;

                    //Piezas a embarcar que se guardan en recibaSeriales
                    recibam.piezasAEmbarcar = !editar ? parseInt(recibam.piezasAEmbarcar ? recibam.piezasAEmbarcar : 0) -
                      (parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0) +
                        parseInt(embarques.piezasPintadas ? embarques.piezasPintadas : 0)) : embarques.activo === false ?
                      parseInt(recibam.piezasAEmbarcar ? recibam.piezasAEmbarcar : 0) +
                      (parseInt(embarques.pPintadasOriginal ? embarques.pPintadasOriginal : 0) +
                        parseInt(embarques.pNRecuperadasOriginal ? embarques.pNRecuperadasOriginal : 0)) : !embarques.embarqueID ?
                        parseInt(recibam.piezasAEmbarcar ? recibam.piezasAEmbarcar : 0) -
                        (parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0) +
                          parseInt(embarques.piezasPintadas ? embarques.piezasPintadas : 0))
                        : diferenciaPiezas < 0 ? parseInt(recibam.piezasAEmbarcar ? recibam.piezasAEmbarcar : 0) -
                          diferenciaPiezas * -1 : parseInt(recibam.piezasAEmbarcar ? recibam.piezasAEmbarcar : 0) + diferenciaPiezas;

                    /** ----------------------------------------------------------
                     * -------------------------------------------------*/
                    const piezasEmbarcadasFinal = recibam.piezasEmbarcadas ? recibam.piezasEmbarcadas : 0;
                    const piezasNPEmbarcadasFinal = recibam.piezasCtnaEmbarcadas ? recibam.piezasCtnaEmbarcadas : 0;
                    var json = false;
                    //Si hubo cambios en la cantidad de piezas embarcadas.
                    if (piezasEmbarcardasInicial != piezasEmbarcadasFinal || piezasNPEmbarcardasInicial != piezasNPEmbarcadasFinal) {
                      //Se cambia la ubicación del material de Producción Calidad a Embarques Embarcado o a al reves, si así corresponde.
                      if (piezasEmbarcardasInicial != piezasEmbarcadasFinal) {
                        //Se revisa si hubo aumento o disminución de piezas
                        const piezasPintadasAnterior = embarques.activo === false ? parseInt(embarques.pPintadasOriginal ? embarques.pPintadasOriginal : 0) : parseInt(embarques.pPintadasAnterior ? embarques.pPintadasAnterior : 0);
                        const piezasPintadas = embarques.activo === false ? 0 : parseInt(embarques.piezasPintadas ? embarques.piezasPintadas : 0);
                        const PiezasPintadasNRAnterior = embarques.activo === false ? parseInt(embarques.pNRecuperadasOriginal ? embarques.pNRecuperadasOriginal : 0) : parseInt(embarques.pNRecuperadasAnterior ? embarques.pNRecuperadasAnterior : 0);
                        const piezasPintadasNR = embarques.activo === false ? 0 : parseInt(embarques.piezasNRecuperadas ? embarques.piezasNRecuperadas : 0);
                        //Piezas pintadas satisfactóriamente.
                        //Si las piezas pintadas anteriormente son mayor que las actuales,
                        //Se tienen que pasar las piezas que corresponden a Calidad de Producción
                        var difPPintadas = 0;
                        if (piezasPintadasAnterior > piezasPintadas) {
                          //Se obtiene el número menos de piezas.
                          difPPintadas = piezasPintadas - piezasPintadasAnterior;
                          const loacionPiezas = "Calidad";
                          const ubicacionPiezas = recibam.Pcoat === true ? "Producción-P" : "Producción";
                          const loacionAnterior = "Embarcado";
                          const ubicacionAnterior = "Embarques";
                          const cantidadPiezas =
                            piezasPintadasAnterior - piezasPintadas;
                          auxUltimaUbicacion = await cambioUbicacionSeriales(
                            recibam,
                            ubicacionAnterior,
                            loacionAnterior,
                            ubicacionPiezas,
                            loacionPiezas,
                            cantidadPiezas,
                            json
                          );
                          //setMensajeAlert("Despues de obtener los datos del cambio de ubicación" + JSON.stringify(auxUltimaUbicacion));
                          if (auxUltimaUbicacion.mensaje != "") {
                            setMensajeAlert(auxUltimaUbicacion.mensaje);
                            setColor(auxUltimaUbicacion.color);
                            setCargando(false);
                            setAVisible(true);
                            return;
                          } else {
                            recibam.ultimaUbicacion = auxUltimaUbicacion.sUltimaU;
                            recibam.rubicaciones = auxUltimaUbicacion.sUbicaciones;
                            json = true;
                            //setMensajeAlert("Ubicaciones agrupadas (3)" + JSON.stringify(auxUltimaUbicacion));
                          }
                        } //Si las piezas pintadas anteriormente son menores que las actuales,
                        //Se tienen que pasar las piezas que corresponden a Embarcado de Embarques
                        else if (piezasPintadasAnterior < piezasPintadas) {
                          const loacionPiezas = "Embarcado";
                          const ubicacionPiezas = "Embarques";
                          const loacionAnterior = "Calidad";
                          const ubicacionAnterior = "Producción";
                          const cantidadPiezas =
                            piezasPintadas - piezasPintadasAnterior;
                          difPPintadas = cantidadPiezas;
                          auxUltimaUbicacion = await cambioUbicacionSeriales(
                            recibam,
                            ubicacionAnterior,
                            loacionAnterior,
                            ubicacionPiezas,
                            loacionPiezas,
                            cantidadPiezas,
                            json
                          );
                          //setMensajeAlert("Despues de obtener los datos del cambio de ubicación" + JSON.stringify(auxUltimaUbicacion));
                          if (auxUltimaUbicacion.mensaje != "") {
                            setMensajeAlert(auxUltimaUbicacion.mensaje);
                            setColor(auxUltimaUbicacion.color);
                            setCargando(false);
                            setAVisible(true);
                            return;
                          } else {
                            recibam.ultimaUbicacion = auxUltimaUbicacion.sUltimaU;
                            recibam.rubicaciones = auxUltimaUbicacion.sUbicaciones;
                            json = true;
                            //setMensajeAlert("Ubicaciones agrupadas (3)" + JSON.stringify(auxUltimaUbicacion));
                          }
                        }
                        //Piezas Pintadas no recúperadas.
                        //Si las piezas pintadas No recuperadas anteriormente son mayor que las actuales,
                        //Se tienen que pasar las piezas que corresponden a Cuarentena.
                        var difPiezasNR = 0;
                        if (PiezasPintadasNRAnterior > piezasPintadasNR) {
                          difPiezasNR = piezasPintadasNR - PiezasPintadasNRAnterior;
                          const loacionPiezas = "";
                          const ubicacionPiezas = "Cuarentena";
                          const loacionAnterior = "Embarcado";
                          const ubicacionAnterior = "Embarques";
                          const cantidadPiezas =
                            PiezasPintadasNRAnterior - piezasPintadasNR;
                          auxUltimaUbicacion = await cambioUbicacionSeriales(
                            recibam,
                            ubicacionAnterior,
                            loacionAnterior,
                            ubicacionPiezas,
                            loacionPiezas,
                            cantidadPiezas,
                            json
                          );
                          //setMensajeAlert("Despues de obtener los datos del cambio de ubicación" + JSON.stringify(auxUltimaUbicacion));
                          if (auxUltimaUbicacion.mensaje != "") {
                            setMensajeAlert(auxUltimaUbicacion.mensaje);
                            setColor(auxUltimaUbicacion.color);
                            setCargando(false);
                            setAVisible(true);
                            return;
                          } else {
                            recibam.ultimaUbicacion = auxUltimaUbicacion.sUltimaU;
                            recibam.rubicaciones = auxUltimaUbicacion.sUbicaciones;
                            json = true;
                            //setMensajeAlert("Ubicaciones agrupadas (3)" + JSON.stringify(auxUltimaUbicacion));
                          }
                        } //Si las piezas pintadas anteriormente son menores que las actuales,
                        //Se tienen que pasar las piezas que corresponden a Embarcado de Embarques
                        else if (PiezasPintadasNRAnterior < piezasPintadasNR) {
                          const loacionPiezas = "Embarcado";
                          const ubicacionPiezas = "Embarques";
                          const loacionAnterior = "";
                          const ubicacionAnterior = "Cuarentena";
                          const cantidadPiezas =
                            piezasPintadasNR - PiezasPintadasNRAnterior;
                          difPiezasNR = cantidadPiezas;
                          auxUltimaUbicacion = await cambioUbicacionSeriales(
                            recibam,
                            ubicacionAnterior,
                            loacionAnterior,
                            ubicacionPiezas,
                            loacionPiezas,
                            cantidadPiezas,
                            json
                          );
                          //setMensajeAlert("Despues de obtener los datos del cambio de ubicación" + JSON.stringify(auxUltimaUbicacion));
                          if (auxUltimaUbicacion.mensaje != "") {
                            setMensajeAlert(auxUltimaUbicacion.mensaje);
                            setColor(auxUltimaUbicacion.color);
                            setCargando(false);
                            setAVisible(true);
                            return;
                          } else {
                            recibam.ultimaUbicacion = auxUltimaUbicacion.sUltimaU;
                            recibam.rubicaciones = auxUltimaUbicacion.sUbicaciones;
                            json = true;
                            //setMensajeAlert("Ubicaciones agrupadas (3)" + JSON.stringify(auxUltimaUbicacion));
                          }
                        }
                      }

                      //Se cambia la ubicación del material de Cuarentena a Embarques Embarcado o a al reves, si así corresponde.
                      if (piezasNPEmbarcardasInicial != piezasNPEmbarcadasFinal) {
                        //Se revisa si hubo aumento o disminución de piezas no pintadas
                        const piezasNoPintadasAnterior = parseInt(
                          embarques.pNoPintadasOriginal
                            ? embarques.pNoPintadasOriginal
                            : 0
                        );
                        const piezasNoPintadas = embarques.activo === false ? 0 : parseInt(
                          embarques.piezasNoPintadas
                            ? embarques.piezasNoPintadas
                            : 0
                        );
                        //Si las piezas nopintadas anteriormente son mayor que las actuales,
                        //Se tienen que pasar las piezas que corresponden a Calidad de Producción
                        var difPiezasNP = 0;
                        if (piezasNoPintadasAnterior > piezasNoPintadas) {
                          setMensajeAlert("Hay diferencias, piezasNoPintadasAnterior: " + piezasNoPintadasAnterior + ", piezasNoPintadas: " + piezasNoPintadas);
                          //return;
                          const loacionPiezas = "";
                          const ubicacionPiezas = "Cuarentena";
                          const loacionAnterior = "Embarcado";
                          const ubicacionAnterior = "Embarques";
                          const cantidadPiezas =
                            piezasNoPintadasAnterior - piezasNoPintadas;
                          difPiezasNP = piezasNoPintadas - piezasNoPintadasAnterior;
                          auxUltimaUbicacion = await cambioUbicacionSeriales(
                            recibam,
                            ubicacionAnterior,
                            loacionAnterior,
                            ubicacionPiezas,
                            loacionPiezas,
                            cantidadPiezas,
                            json
                          );
                          //setMensajeAlert("Despues de obtener los datos del cambio de ubicación" + JSON.stringify(auxUltimaUbicacion));
                          if (auxUltimaUbicacion.mensaje != "") {
                            setMensajeAlert(auxUltimaUbicacion.mensaje);
                            setColor(auxUltimaUbicacion.color);
                            setCargando(false);
                            setAVisible(true);
                            return;
                          } else {
                            recibam.ultimaUbicacion = auxUltimaUbicacion.sUltimaU;
                            recibam.rubicaciones = auxUltimaUbicacion.sUbicaciones;
                            json = true;
                            //setMensajeAlert("Ubicaciones agrupadas (3)" + JSON.stringify(auxUltimaUbicacion));
                          }
                        } //Si las piezas no pintadas anteriormente son menores que las actuales,
                        //Se tienen que pasar las piezas que corresponden a Embarcado de Embarques
                        else if (piezasNoPintadasAnterior < piezasNoPintadas) {
                          setMensajeAlert("Hay diferencias, piezasNoPintadasAnterior: " + piezasNoPintadasAnterior + ", piezasNoPintadas: " + piezasNoPintadas);
                          //return;
                          const loacionPiezas = "Embarcado";
                          const ubicacionPiezas = "Embarques";
                          const loacionAnterior = "";
                          const ubicacionAnterior = "Cuarentena";
                          const cantidadPiezas =
                            piezasNoPintadas - piezasNoPintadasAnterior;
                          difPiezasNP = cantidadPiezas;
                          auxUltimaUbicacion = await cambioUbicacionSeriales(
                            recibam,
                            ubicacionAnterior,
                            loacionAnterior,
                            ubicacionPiezas,
                            loacionPiezas,
                            cantidadPiezas,
                            json
                          );
                          //setMensajeAlert("Despues de obtener los datos del cambio de ubicación" + JSON.stringify(auxUltimaUbicacion));
                          if (auxUltimaUbicacion.mensaje != "") {
                            setMensajeAlert(auxUltimaUbicacion.mensaje);
                            setColor(auxUltimaUbicacion.color);
                            setCargando(false);
                            setAVisible(true);
                            return;
                          } else {
                            recibam.ultimaUbicacion = auxUltimaUbicacion.sUltimaU;
                            recibam.rubicaciones = auxUltimaUbicacion.sUbicaciones;
                            json = true;
                            //setMensajeAlert("Ubicaciones agrupadas (3)" + JSON.stringify(auxUltimaUbicacion));
                          }
                        }
                        setMensajeAlert("No hay diferencias, piezasNoPintadasAnterior: " + piezasNoPintadasAnterior + ", piezasNoPintadas: " + piezasNoPintadas);
                        //return;
                      }
                    }

                    /*------------------------------------------------------------------------------------------------------------*/
                    //Se actualizan los datos en reciba Seriales                                  
                    recibam.Reg_Mod_Usuario = userName;
                    if ((recibam.piezasEmbarcadas +
                      (recibam.piezasCtnaEmbarcadas ? recibam.piezasCtnaEmbarcadas : 0)) >=
                      recibam.cantidadRecibida) {
                      recibam.piezasEnPlanta = false;
                    } else {
                      recibam.piezasEnPlanta = true;
                    }
                    if (enPlantaOriginal === false && recibam.piezasEnPlanta === true) {
                      //Se crean los datos en recibaSerialesMP
                      const recibaSerialIDOR = recibam.id;
                      delete recibam.recibaSerialMPID;
                      delete recibam.id;
                      let serialesMP = await API.graphql({
                        query: createRecibaSerialesMP,
                        variables: { input: { ...recibam, recibaSerialID: recibaSerialIDOR } },
                      });
                      //Se obtienen los datos de recibaSerialesMP recién creados
                      var recibaMPCreada = serialesMP.data.createRecibaSerialesMP;
                      recibam.recibaSerialMPID = recibaMPCreada.id;
                      recibam.id = recibaSerialIDOR;
                    }

                    if (!recibam.piezasCtnaRecuperadas) { delete recibam.piezasCtnaRecuperadas };
                    if (!recibam.piezasInspeccion) { delete recibam.piezasInspeccion };
                    if (!recibam.piezasInspeccionPC) { delete recibam.piezasInspeccionPC };
                    if (!recibam.piezasIRecuperacion) { delete recibam.piezasIRecuperacion };
                    if (!recibam.piezasCRecuperacion) { delete recibam.piezasCRecuperacion };
                    if (!recibam.PiezasCtnaRecuperacion) { delete recibam.PiezasCtnaRecuperacion };
                    if (!recibam.piezasTRecuperacion) { delete recibam.piezasTRecuperacion };
                    if (!recibam.piezasRecuperadas) { delete recibam.piezasRecuperadas };
                    if (!recibam.piezasFacturadas) { delete recibam.piezasFacturadas; }
                    if (!recibam.UltimaInspeccionCuarentena) { delete recibam.UltimaInspeccionCuarentena; }
                    if (!recibam.piezasCtnaNRecuperadas) { delete recibam.piezasCtnaNRecuperadas; };

                    setMensajeAlert("Error al actualizar reciba seriales");//+ JSON.stringify(recibam)
                    let upRecibaS = await API.graphql({
                      query: updateRecibaSeriales,
                      variables: { input: recibam },
                    });
                    const recibaActualizada = upRecibaS.data.updateRecibaSeriales;
                    if (recibam.piezasEnPlanta === false) {
                      setMensajeAlert("No se pudo eliminar de la tabla temporal; ");
                      await API.graphql({ query: deleteRecibaSerialesMP, variables: { input: { id: recibam.recibaSerialMPID, } } });
                    } else {
                      //Se actualizan los datos en recibaSerialesMP
                      const recibaSerialMPID = recibam.recibaSerialMPID;
                      if (recibam.recibaSerialMPID) {
                        delete recibam.recibaSerialMPID;
                        setMensajeAlert("Operación errónea; Problemas al guardar los datos del serial" + JSON.stringify(recibam));
                        await API.graphql({ query: updateRecibaSerialesMP, variables: { input: { ...recibam, id: recibaSerialMPID, rsUpdatedAt: recibaActualizada.updatedAt, recibaSerialID: recibam.id } }, });
                      }
                    }
                  }

                  delete embarques.registro;
                  delete embarques.pNoPintadasOriginal;
                  //delete embarques.MaterialPintado;

                  if (embarques.activo) {
                    embarques.orden = i;
                    i++;
                  }
                  embarques.clienteEntregaID = clienteEntregaID;
                  embarques.clienteEntrega = rClienteEntrega;
                  embarques.facturarA = rClienteFacturarA;
                  if (!editar) {
                    PnumeroSerial = (await PnumeroSerial) + 1;
                    embarques.embarqueID = embarqueid;
                    embarques.numero = EmbarquesC.numero;
                    embarques.fechaDeEmbarque = fechaDeEmbarque;
                    embarques.atencionA = atencionA;
                    embarques.ordenDeCompra = ordenDeCompra;
                    embarques.numeroSerial = PnumeroSerial;
                    embarques.piezasEmbarcadas =
                      parseInt(embarques.piezasPintadas) +
                      parseInt(embarques.piezasNRecuperadas) +
                      parseInt(embarques.piezasPintadasExtra ? embarques.piezasPintadasExtra : 0);
                    embarques.Reg_Ins_Usuario = userName;
                    setMensajeAlert(
                      "Error guardar el embarque por serial 1" +
                      JSON.stringify(embarques)
                    );
                    let resultado = await API.graphql({
                      query: createEmbarqueSeriales,
                      variables: { input: embarques },
                    });
                    idAgregado.push({ id: resultado.data.createEmbarqueSeriales.id, nuevo: true, activo: true });
                  } else {
                    if (embarques.id) {
                      if (embarques.activo) {
                        embarques.fechaDeEmbarque = fechaDeEmbarque;
                        embarques.atencionA = atencionA;
                        embarques.ordenDeCompra = ordenDeCompra;
                        embarques.piezasEmbarcadas =
                          parseInt(embarques.piezasPintadas) +
                          parseInt(embarques.piezasNRecuperadas) +
                          parseInt(embarques.piezasPintadasExtra ? embarques.piezasPintadasExtra : 0);;
                      }
                      embarques.Reg_Mod_Usuario = userName;
                      delete embarques.createdAt;
                      delete embarques.updatedAt;
                      delete embarques.__typename;
                      delete embarques.pPintadasAnterior;
                      delete embarques.diferenciaPiezasExtra;
                      delete embarques.pNRecuperadasAnterior;
                      delete embarques.modificado;
                      delete embarques.desgloceDetalles;
                      delete embarques.Reg_Ins_Fecha;
                      delete embarques.pPintadasAnteriorExtra;
                      delete embarques.pNoPintadasOriginal;

                      setMensajeAlert(
                        "Error al intentar guardar los cambios en embarqueseriales: " +
                        JSON.stringify(embarques)
                      );
                      let resultado = await API.graphql({
                        query: updateEmbarqueSeriales,
                        variables: { input: embarques },
                      });
                      if (embarques.activo === false) {
                        idAgregado.push({ id: resultado.data.updateEmbarqueSeriales.id, nuevo: false, activo: false });
                      }
                    } else {
                      PnumeroSerial = (await PnumeroSerial) + 1;
                      embarques.embarqueID = embarqueid;
                      embarques.numero = EmbarquesC.numero;
                      embarques.fechaDeEmbarque = fechaDeEmbarque;
                      embarques.atencionA = atencionA;
                      embarques.ordenDeCompra = ordenDeCompra;
                      embarques.numeroSerial = PnumeroSerial;
                      embarques.piezasEmbarcadas =
                        parseInt(embarques.piezasPintadas) +
                        parseInt(embarques.piezasNRecuperadas) +
                        parseInt(embarques.piezasPintadasExtra ? embarques.piezasPintadasExtra : 0);;
                      embarques.Reg_Ins_Usuario = userName;
                      setMensajeAlert(
                        "Error guardar el embarque por serial 2" +
                        +JSON.stringify(embarques)
                      );
                      let resultado = await API.graphql({
                        query: createEmbarqueSeriales,
                        variables: { input: embarques },
                      });
                      idAgregado.push({ id: resultado.data.createEmbarqueSeriales.id, nuevo: true, activo: true });
                      return;
                    }
                  }
                  //Se preparan los datos para guardarlos en el resumen de operación
                  embarques.piezasPintadas = difPPintadas;
                  embarques.piezasNRecuperadas = difPiezasNR;
                  embarques.piezasNoPintadas = difPiezasNP;
                  embarques.precioUnitario = recibam.precioUnitario;
                  embarques.Ecoat = recibam.Ecoat;
                  embarques.Pcoat = recibam.Pcoat;
                  embarques.precioUnitarioPC = recibam.precioUnitarioPC
                  if (enPlantaOriginal != recibam.piezasEnPlanta) {
                    embarques.piezasEnPlanta = false;
                  }
                  //Se registran los datos en el resume de operación.
                  const rOperacion = await manageResumenOperacion(fechaDeEmbarque, embarques, "Embarques", userName, embarqueid);
                })
              );
              //Se actualizan los datosde embarques       
              setMensajeAlert("Error al intentar obtener datos del embarque para editar");
              var formData = await GetEmbarquesID(embarqueid);
              const nserialesEID = await combinarIDS(formData.serialesEID ? formData.serialesEID : [], idAgregado);
              formData.serialesEID = nserialesEID;
              formData.fechaDeEmbarque = fechaDeEmbarque;
              formData.atencionA = atencionA;
              formData.ordenDeCompra = ordenDeCompra;
              formData.clienteID = clienteID;
              formData.cliente = rCliente;
              formData.clienteEntregaID = clienteEntregaID;
              formData.clienteEntrega = rClienteEntrega;
              formData.facturarA = rClienteFacturarA;
              formData.fechaDeReciba = inputList[0].fechaDeReciba;
              formData.MFGFecha = inputList[0].MFGFecha;
              formData.piezasPintadas = piezasPintadasSum;//sumarPiezasP(inputList); //inputList[0].piezasNRecuperadas;
              formData.piezasNRecuperadas = piezasNRecuperadasSum;//sumarPiezasNR(inputList); //inputList[0].piezasNRecuperadas;
              formData.piezasNoPintadas = piezasNoPintadasSum;//sumarPiezasNP(inputList);
              formData.activo = true;
              formData.Reg_Ins_Usuario = userName;
              formData.piezasEmbarcadas =
                parseInt(piezasPintadasSum) +
                parseInt(piezasNRecuperadasSum) +
                (inputList[0] ? sumarPiezasExtra(inputList) : 0)/* +
              parseInt(formData.piezasNoPintadas)*/;
              formData.piezasPintadasExtra = inputList[0] ?
                (inputList[0] ? sumarPiezasExtra(inputList) : 0) : 0;
              formData.packings = concatenarPackings(inputList);
              formData.numerosdeParte = concatenarNumerosdeParte(inputList);
              formData.lotes = concatenarLotes(inputList);
              formData.seriales = concatenarSeriales(inputList);
              formData.totalNumerodeParte = iTotalNParte;
              formData.sinTotalScrap = sinTotalScrap;
              formData.sinTotalScrapFactura = sinTotalScrapFactura;
              formData.desgloceVer = desgloceVer;
              if (formData.servicioExtraEmbarques) {
                formData.servicioExtraEmbarques = [];
              }
              delete formData.createdAt;
              delete formData.updatedAt;
              delete formData.__typename;
              setMensajeAlert(
                "Error al intentar guardar los datos del embarque 2"
              );
              await API.graphql({
                query: updateEmbarque,
                variables: { input: formData },
              });


              setMensajeAlert("Operación exitosa ");
              setisDisabled(false);
              setColor("primary");
              setAVisible(true);
              setCargando(true);
              fetchEmbarques(rfechaini, rfechafin);
              setInputList([]);
              setInputListServicios([]);
              setServicios(false);
              setEmbarqueSerialEditar([]);
              toggle1("1");
              setFechaDeEmbarque("");
              setAtencionA("");
              setAMRecuperado(false);
              setClienteID("");
              setRCliente("");
              setClienteEntregaID("");
              setRClienteEntrega("");
              setRClienteFacturarA("");
              setOrdenDeCompra("");
              setCargando(false);
            } else {
              //Si la fecha es diferente significa que sí hay concurrencia y que se tienen que actualizar los datos
              window.scrollTo(0, 0);
              setMensajeAlert(
                "No fue posible realizar la operación: existe concurrencia, se requiere cancelar la operación y " +
                " volver a intentarlo"
              );
              setColor("warning");
              setCargando(false);
              setAVisible(true);
              setisDisabled(false);
              fetchEmbarques(rfechaini, rfechafin);
            }
          }
        } else {
          if (cambiosCheck === true) {
            //Se actualizan los datosde embarques       
            setMensajeAlert("Error al intentar obtener datos del embarque para editar");
            const formID = inputList.filter(emplarqueF => emplarqueF.embarqueID);
            if (formID[0].embarqueID) {
              var formData = await GetEmbarquesID(formID[0].embarqueID);
              formData.totalNumerodeParte = iTotalNParte;
              formData.sinTotalScrap = sinTotalScrap;
              formData.sinTotalScrapFactura = sinTotalScrapFactura;
              formData.desgloceVer = desgloceVer;
              delete formData.createdAt;
              delete formData.updatedAt;
              delete formData.__typename;
              setMensajeAlert(
                "Error al intentar guardar los datos del embarque 3"
              );
              await API.graphql({
                query: updateEmbarque,
                variables: { input: formData },
              });
              setMensajeAlert("Operación exitosa");
              setisDisabled(false);
              setColor("primary");
            } else {
              setMensajeAlert("Sin cambios que actualizar (1)");
              setisDisabled(false);
              setColor("primary");
            }

          } else {
            setMensajeAlert("Sin cambios que actualizar (2)");
            setisDisabled(false);
            setColor("primary");
          }
          setAVisible(true);
          setCargando(true);
          fetchEmbarques(rfechaini, rfechafin);
          setInputList([]);
          setInputListServicios([]);
          setServicios(false);
          setEmbarqueSerialEditar([]);
          toggle1("1");
          setFechaDeEmbarque("");
          setAtencionA("");
          setAMRecuperado(false);
          setClienteID("");
          setRCliente("");
          setClienteEntregaID("");
          setRClienteEntrega("");
          setRClienteFacturarA("");
          setOrdenDeCompra("");
          setCargando(false);

        }
      } else {//Proceso para guardar Servicios
        setMensajeAlert("Sí hay cambios");
        const datosCompletos = await revisarDatosCompletosServicios(inputListServicios);
        setMensajeAlert("Datos revisados Servicios");
        var mensaje = "";
        if (!fechaDeEmbarque || !atencionA || !ordenDeCompra || !clienteID || !rCliente || datosCompletos === false) {
          mensaje = "Faltan datos; los campos marcados con un asterísco son obligatorios. 4 "; // + datosCompletos;          
        }
        if (mensaje !== "") {
          setMensajeAlert(mensaje);
          setColor("warning");
          setAVisible(true);
          setisDisabled(false);
          setCargando(false);
          window.scrollTo(0, 0);
          return
        } else {
          setMensajeAlert("Sin mensaje");
          var pConcurrencia = false;
          var embarqueid = embarqueEditando.id;
          var EmbarquesC = {};
          setMensajeAlert("Antes de editar");
          if (embarqueEditando.id) {
            setMensajeAlert("Editando");
            //Se obtienen los datos del embarque por id para revisa la concurrencia
            EmbarquesC = await GetEmbarquesID(embarqueid);
            setMensajeAlert("Datos de embarque; " + JSON.stringify(EmbarquesC));
            if (!EmbarquesC.id) {
              pConcurrencia = true;
            } else {
              if (EmbarquesC.updatedAt !== embarqueEditando.updatedAt) {
                pConcurrencia = true;
                mensaje = "Operación denegada; concurrencia en los datos generales del embarque.";
              }
            }
          } else {
            mensaje = "Operación denegada; no se encontraron datos del embarque relacionado, favor de comunicarse a sistemas";
            setMensajeAlert(mensaje);
          }
          setMensajeAlert("Sin mensaje 2; " + mensaje);
          //Se revisa si hay mensaje de error, si es así, se termina la transacción.
          if (mensaje !== "") {
            setMensajeAlert(mensaje);
            setColor("warning");
            setAVisible(true);
            setisDisabled(false);
            setCargando(false);
            window.scrollTo(0, 0);
            return;
          }
          if (pConcurrencia === false) {
            //setMensajeAlert("Sin concurrencia");
            var i = 1;
            var idAgregado = [];
            const totales = sumarCantidadesServicios(inputListServicios);
            //Se actualizan los datosde embarques       
            setMensajeAlert("Error al intentar obtener datos del embarque para editar");
            var formData = await GetEmbarquesID(embarqueid);
            formData.fechaDeEmbarque = fechaDeEmbarque;
            formData.atencionA = atencionA;
            formData.ordenDeCompra = ordenDeCompra;
            formData.clienteID = clienteID;
            formData.cliente = rCliente;
            formData.clienteEntregaID = clienteEntregaID;
            formData.clienteEntrega = rClienteEntrega;
            formData.facturarA = rClienteFacturarA;
            formData.activo = true;
            formData.servicioExtraEmbarques = inputListServicios;
            formData.Reg_Ins_Usuario = userName;
            formData.piezasEmbarcadas = totales.totalPiezas;
            formData.piezasPintadasExtra = totales.totalPiezasExtra;
            formData.numerosdeParte = totales.numerosdeParte;
            formData.seriales = totales.seriales;
            formData.totalNumerodeParte = iTotalNParte;
            formData.sinTotalScrap = sinTotalScrap;
            formData.sinTotalScrapFactura = sinTotalScrapFactura;
            formData.desgloceVer = desgloceVer;
            delete formData.createdAt;
            delete formData.updatedAt;
            delete formData.__typename;
            setMensajeAlert(
              "Error al intentar guardar los datos del embarque 5"
            );
            await API.graphql({
              query: updateEmbarque,
              variables: { input: formData },
            });


            setMensajeAlert("Operación exitosa ");
            setisDisabled(false);
            setColor("primary");
            setAVisible(true);
            setCargando(true);
            fetchEmbarques(rfechaini, rfechafin);
            setInputList([]);
            setInputListServicios([]);
            setServicios(false);
            setEmbarqueSerialEditar([]);
            toggle1("1");
            setFechaDeEmbarque("");
            setAtencionA("");
            setAMRecuperado(false);
            setClienteID("");
            setRCliente("");
            setClienteEntregaID("");
            setRClienteEntrega("");
            setRClienteFacturarA("");
            setOrdenDeCompra("");
            setCargando(false);
          } else {
            //Si la fecha es diferente significa que sí hay concurrencia y que se tienen que actualizar los datos
            window.scrollTo(0, 0);
            setMensajeAlert(
              "No fue posible realizar la operación: existe concurrencia, se requiere cancelar la operación y " +
              " volver a intentarlo"
            );
            setColor("warning");
            setCargando(false);
            setAVisible(true);
            setisDisabled(false);
            fetchEmbarques(rfechaini, rfechafin);
          }
        }
      }
    } catch (e) {
      window.scrollTo(0, 0);
      //setMensajeAlert(e.message);
      //"No fue posible terminar la operación: revise si la operación se realizó parcialmente, revise su conexión a internet y vuelva a intentar, si el problema persiste, favor de comunicarte a sistemas"
      setColor("warning");
      setAVisible(true);
      fetchEmbarques(rfechaini, rfechafin);
      setInputList([]);
      setInputListServicios([]);
      setServicios(false);
      toggle1("1");
      setFechaDeEmbarque("");
      setAtencionA("");
      setAMRecuperado(false);
      setClienteID("");
      setRCliente("");
      setClienteEntregaID("");
      setRClienteEntrega("");
      setRClienteFacturarA("");
      setOrdenDeCompra("");
      setCargando(false);
      setisDisabled(false);
    }
  }
  //Revisa cambios en la fecha de búsqueda
  function onChangesRFechaini(e) {
    e.persist();
    var fechaini = rfechaini;
    var fechafin = rfechafin;
    if (e.target.name === "rFechaIni") {
      fechaini = e.target.value;
    } else {
      fechafin = e.target.value;
    }
    setRfechafin(fechafin);
    setRfechaini(fechaini);
    fetchEmbarques(fechaini, fechafin);
  }
  function onChangesRFechainiag(e) {
    e.persist();
    var fechaini = rfechainiag;
    var fechafin = rfechafinag;
    if (e.target.name === "rFechaIniag") {
      fechaini = e.target.value;
    } else {
      fechafin = e.target.value;
    }
    setRfechafinag(fechafin);
    setRfechainiag(fechaini);
    if (buscarporFecha === true) {
      fetchReciba(comCAS, false, buscarporFecha, searchByReciba, searchReciba);
    }
  }

  //Revisa cambios en el input de clientes
  function onChangesClientes(e) {
    e.persist();
    const ocClienteID = e.target.value;
    if (e.target.value != "") {
      const fClientes = clientes.filter(
        (fcliente) => fcliente.id === ocClienteID
      );
      setClienteID(fClientes[0].id);
      setRCliente(fClientes[0].cliente);
      setClienteEntregaID(fClientes[0].id);
      setRClienteEntrega(fClientes[0].cliente);
      setRClienteFacturarA(fClientes[0].cliente);
    } else {
      setClienteID("");
      setRCliente("");
      setClienteEntregaID("");
      setRClienteEntrega("");
      setRClienteFacturarA("");
    }
    setBusquedaxClientes(ocClienteID);
    cambioDatosEmbarque(e);
  }
  //Revisa cambios en el input de clientes
  function onChangesClientesEntrega(e) {
    e.persist();
    const fClientes = clientes.filter(
      (fcliente) => fcliente.id === e.target.value
    );
    setClienteEntregaID(fClientes[0].id);
    setRClienteEntrega(fClientes[0].cliente);
    setRClienteFacturarA(fClientes[0].cliente);
    cambioDatosEmbarque(e);
  }
  //Descarga de material para embarques
  async function clicDescargarDatos() {
    setCargando(true);
    setAVisible(false);
    //Declaración de variables
    var almacenEXP = [];
    const embarquesPD = await GetRecibaSeriales({ and: [{ activo: { eq: true, }, }, { piezasAEmbarcar: { gt: 0, }, },] });
    var recibaPD = embarquesPD;
    //Se ordenan los datos de la reciba por fecha de reciba
    recibaPD = recibaPD.sort((a, b) => a.fechaDeReciba > b.fechaDeReciba
      ? 1 : a.fechaDeReciba < b.fechaDeReciba ? -1 : 0
    );
    //Se obtienen los datos en el orden requerido
    await Promise.all(
      recibaPD.map((recibaf) => {

        //Se agregan los datos de la reciba
        almacenEXP.push({
          RECIBA: recibaf.numero,
          CLIENTE: recibaf.cliente,
          FECHA: Moment(recibaf.fechaDeReciba).format("DD-MM-YYYY"),
          //HORA: Moment(recibaf.fechayHoraDeReciba).format("HH:mm"),
          ESTATUS: recibaf.status,
          PACKING: recibaf.packing,
          "NÚMERO DE PARTE": recibaf.numerodeParte,
          LOTE: recibaf.lote,
          SERIAL: recibaf.serial,
          "SERIAL BTI": recibaf.serialRecibaBTI,
          DESCRIPCIÓN: recibaf.descripcion,
          "CANTIDAD RECIBIDA": recibaf.cantidadRecibida,
          "PIEZAS A EMBARCAR": recibaf.piezasAEmbarcar,
          "CONTENEDOR DE RECIBA": recibaf.materialEnCantidad + " " + (recibaf.materialEnCantidad > 1 ?
            recibaf.materialEn === "caja" ? "cajas" : "contenedores" : recibaf.materialEn),
          RECIBIÓ: recibaf.Reg_Ins_Usuario,
          COMENTARIOS: recibaf.comentariosdeinspeccion,
        });

        //


        //return reciba
      })
    );

    var worksheet = xlsx.utils.json_to_sheet(almacenEXP);
    var workbook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(workbook, worksheet, "Embarques");
    xlsx.writeFile(
      workbook,
      "Material para embarcar " + Moment(new Date()).format("DD-MM-YYYY") + "  " + Moment(new Date()).format("HH:mm") + ".xlsx"
    );
    setCargando(false);
  }
  //Revisa cambios en el input de clientes
  function onChangesDatosEmbarques(e) {
    if (e.target.name === "fechaDeEmbarque") {
      setFechaDeEmbarque(e.target.value);
    }
    if (e.target.name === "atencionA") {
      setAtencionA(e.target.value)
    }
    if (e.target.name === "ordenDeCompra") {
      setOrdenDeCompra(e.target.value)
    }
    if (e.target.name === "iTotalNParte") {
      setITotalNParte(e.target.checked)
    }
    if (e.target.name === "sinTotalScrap") {
      setSinTotalScrapt(e.target.checked)
    }
    if (e.target.name === "sinTotalScrapFactura") {
      setSinTotalScraptFactura(e.target.checked)
    }
    if (e.target.name === "desgloceVer") {
      setDesgloceVer(e.target.checked)
    }
    if (e.target.name === "rClienteFacturarA") {
      setRClienteFacturarA(e.target.value)
    }
    cambioDatosEmbarque(e);
  }
  //Descarga los datos de embarques
  async function clicDescargarDatosEmbarques() {

    setCargando(true);
    setAVisible(false);
    //Declaración de variables
    var almacenEXP = [];
    let filter = {
      and: [
        {
          activo: {
            eq: true,
          },
        },
        {
          fechaDeEmbarque: {
            ge: rfechaini,
          },
        },
        {
          fechaDeEmbarque: {
            le: rfechafin,
          },
        },
      ],
    };
    const embarquesPD = await GetEmbarquesSeriales(filter);
    var recibaPD = embarquesPD;
    //Se ordenan los datos de la reciba por fecha de reciba
    recibaPD = recibaPD.sort((a, b) => a.fechaDeEmbarque > b.fechaDeEmbarque
      ? 1 : a.fechaDeEmbarque < b.fechaDeEmbarque ? -1 : 0
    );
    //Se obtienen los datos en el orden requerido
    await Promise.all(
      recibaPD.map((recibaf) => {

        //Se agregan los datos de la reciba
        almacenEXP.push({
          "PACKING DE EMBARQUE": recibaf.numero,
          "FECHA DE EMBARQUE": Moment(recibaf.fechaDeEmbarque).format("DD-MM-YYYY"),
          CLIENTE: recibaf.cliente,
          "FECHA DE RECIBA": Moment(recibaf.fechaDeReciba).format("DD-MM-YYYY"),
          //HORA: Moment(recibaf.fechayHoraDeReciba).format("HH:mm"),          
          "PACKING DE RECIBA": recibaf.packing,
          "NÚMERO DE PARTE": recibaf.numerodeParte,
          LOTE: recibaf.lote,
          SERIAL: recibaf.serial,
          "SERIAL BTI": recibaf.serialRecibaBTI,
          DESCRIPCIÓN: recibaf.descripcion,
          "CANTIDAD EMBARCADA": recibaf.piezasEmbarcadas,
          "PIEZAS PINTADAS": recibaf.piezasPintadas,
          "PIEZAS NO PINTADAS": recibaf.piezasNoPintadas,
          "PIEZAS NO RECUPERADAS": recibaf.piezasNRecuperadas,
          "CONTENEDOR DE RECIBA": recibaf.materialEnCantidad + " " + (recibaf.materialEnCantidad > 1 ?
            recibaf.materialEn === "caja" ? "cajas" : "contenedores" : recibaf.materialEn),
          RECIBIÓ: recibaf.Reg_Ins_Usuario,
          COMENTARIOS: recibaf.comentarios,
        });

        //


        //return reciba
      })
    );

    var worksheet = xlsx.utils.json_to_sheet(almacenEXP);
    var workbook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(workbook, worksheet, "Embarques");
    xlsx.writeFile(
      workbook,
      "Material embarcado del " + Moment(rfechaini).format("DD-MM-YYYY") + " al" + Moment(rfechafin).format("DD-MM-YYYY") + ".xlsx"
    );
    setCargando(false);
  }
  //
  function agregarMaterialCAS(e) {
    setComCAS(e.target.checked);
    fetchReciba(e.target.checked, false, buscarporFecha, searchByReciba, searchReciba);
  }
  return (
    <>
      <Navbarh />
      {(pembarques === true || verEmbarques === true) && (
        <>
          <Row>
            <div className="headerp col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <IoIcons.IoIosBus
                className="iconoc floatleft"
                onClick={() => {
                  toggle1("1");
                }}
              />
              <h3>{formType}</h3>
            </div>
          </Row>
          <div className="conteiner2">
            <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
              {mensajeAlert}
            </Alert>
            {cargando === true && (
              <Row>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                  <img width="150px" src="assets/img/preloader.gif" />
                </div>
              </Row>
            )}

            <Fragment>
              <div>
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "1" })}
                      onClick={() => {
                        toggle1("1");
                      }}
                    >
                      Embarques
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "2" })}
                      onClick={() => {
                        toggle1("2");
                      }}
                    >
                      {tituloTab}
                    </NavLink>
                  </NavItem>
                  <NavItem style={{ display: "none" }}>
                    <NavLink
                      className={classnames({ active: activeTab === "3" })}
                      onClick={() => {
                        toggle1("3");
                      }}
                    >
                      Packings
                    </NavLink>
                  </NavItem>
                  <NavItem style={{ display: "none" }}>
                    {/*style={{ display: "none" }} */}
                    <NavLink
                      className={classnames({ active: activeTab === "4" })}
                      onClick={() => {
                        toggle1("4");
                      }}
                    >
                      Imprimir
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1">
                    <Row>
                      {pembarques && (
                        <div className="col-lg-4 col-md-3 col-sm-12 col-xs-12 text-left">
                          <button
                            class="cbutton btn-success margintop20px ml-3"
                            onClick={() => {
                              clicNuevaEmbarque();
                            }}
                          >
                            {" "}
                            <span class="fa fa-plus">
                              {" "}
                              Agregar embarque
                            </span>{" "}
                          </button>
                        </div>
                      )}
                      <div class="col-lg-2 col-xs-12 text-left ">
                        <FormGroup>
                          <Label>
                            <h5>Busqueda por: </h5>
                          </Label>
                          <select name="recibabusqueda" onChange={buscarpor}>
                            <option value="cliente" selected={searchBy === "cliente" ? true : false}>Cliente</option>
                            <option value="paking" selected={searchBy === "paking" ? true : false}>Packing/Line</option>
                            <option value="numero de parte" selected={searchBy === "numero de parte" ? true : false}>
                              Número de parte
                            </option>
                            <option value="lote" selected={searchBy === "lote" ? true : false}>Lote</option>
                            <option value="fecha" selected={searchBy === "fecha" ? true : false}>Fecha de embarque</option>
                            <option value="serial" selected={searchBy === "serial" ? true : false}>Serial</option>
                            <option value="id de embarques" selected={searchBy === "id de embarques" ? true : false}>Packing ID</option>
                          </select>
                          <Input
                            type={searchBy !== "fecha" ? "text" : "date"}
                            placeholder={"Búsqueda por " + searchBy}
                            onChange={
                              searchBy !== "fecha"
                                ? (e) => setSearch(e.target.value)
                                : onSearchFecha
                            }
                            onKeyUp={searchBy !== "fecha" ? onSearch : ""}
                            value={search}
                          />
                        </FormGroup>
                      </div>
                      <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12 margintop10px">
                        <div className=" form-group row col-lg-12 col-md-12 col-sm-12 col-xs-12  floatrightleft ml-1">
                          <div className="  col-lg-2 col-md-2 col-sm-12 col-xs-12  ml-3"></div>
                          <div className=" form-group row col-lg-5 col-md-5 col-sm-12 col-xs-12   margintop10px   ml-1 ">
                            <InputGroup>
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>Del:</InputGroupText>
                              </InputGroupAddon>
                              <Input
                                name="rFechaIni"
                                type="date"
                                value={Moment(rfechaini).format("YYYY-MM-DD")}
                                onChange={onChangesRFechaini}
                              />
                            </InputGroup>
                          </div>
                          <div className=" form-group row col-lg-5 col-md-5 col-sm-12 col-xs-12   margintop10px  floatrightleft ml-1 ">
                            <InputGroup className="floatrightleft ml-1">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>Al:</InputGroupText>
                              </InputGroupAddon>
                              <Input
                                name="rFechaFin"
                                type="date"
                                value={Moment(rfechafin).format("YYYY-MM-DD")}
                                onChange={onChangesRFechaini}
                              />
                            </InputGroup>
                          </div>
                        </div>
                      </div>
                    </Row>
                    <button
                      className="cbutton btn-dark floatright  mr-3 marginrightmobil3p "
                      title="Recargar página"
                      onClick={() => {
                        fetchEmbarques(rfechaini, rfechafin);
                      }}
                    >
                      <IoIcons.IoMdRefresh /> Recargar{" "}
                    </button>
                    {pembarquesinventario === true && (
                      <button
                        class="btn-warning cbutton floatrightleft mr-2"
                        title="Descargar material para embarcar a excel"
                        onClick={() => clicDescargarDatos()}
                      >
                        <IoIcons.IoIosDownload /> Descargar inventario
                      </button>
                    )}
                    {pembarquesinventario === true && (
                      <button
                        class="btn-warning cbutton floatrightleft mr-2"
                        title="Descargar material de embarques a excel"
                        onClick={() => clicDescargarDatosEmbarques()}
                      >
                        <IoIcons.IoIosDownload /> Descargar embarques
                      </button>
                    )}
                    {userName === "GLACIA.PALACIOS" && ( // && Moment(now).format("YYYY-MM-DD") === "2023-01-02 userName === "CHRISTIAN.HERNANDEZ"
                      <button
                        className="cbutton btn-danger floatright  mr-3 marginrightmobil3p "
                        title="Marcar material como embarcado"
                        onClick={() => {
                          marcarEmbarcado(rfechaini, rfechafin);
                        }}
                      >
                        <IoIcons.IoIosAnalytics /> Marcar embarcado{" "}
                      </button>
                    )}

                    <div>
                      <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                        <Table className="mb-2 scroll ">
                          <Thead class="thead-secondary">
                            <Tr>
                              <Th className="minwidth80px">Packing ID</Th>
                              <Th className="minwidth200px">Cliente</Th>
                              <Th className="minwidth200px">
                                Números de parte
                              </Th>
                              <Th>Seriales</Th>
                              <Th>Lotes</Th>
                              <Th>Packings/Lines</Th>
                              <Th className="minwidth80px">MFG Fecha</Th>
                              <Th className="minwidth80px">Fecha</Th>
                              <Th className="minwidth60px">
                                Piezas Embarcadas Pintadas
                              </Th>
                              <Th className="minwidth60px">
                                Piezas Embarcadas No pintadas
                              </Th>
                              {/*<Th className="minwidth60px">Piezas recuperadas</Th>*/}
                              <Th className="minwidth80px">Acciones</Th>
                            </Tr>
                          </Thead>
                          <Tbody>
                            {embarques.map((embarques, i) => (
                              <Tr className={i % 2 !== 0 ? "table-active" : ""}>
                                <Td>{embarques.numero}</Td>
                                <Td>{embarques.cliente}</Td>
                                <Td>{embarques.numerosdeParte}</Td>
                                <Td className={embarques.numerosdeParte ? "" : "margintopmobil20px"}>
                                  {embarques.seriales}</Td>
                                <Td className={embarques.seriales ? "" : "margintopmobil20px"}
                                >
                                  {embarques.lotes}
                                </Td>
                                <Td className={embarques.lotes ? "" : "margintopmobil20px"}>
                                  {embarques.packings}</Td>
                                <Td className={embarques.packings ? "" : "margintopmobil20px"}>
                                  {embarques.MFGFecha}</Td>
                                <Td className={embarques.MFGFecha ? "" : "margintopmobil20px"}>
                                  {embarques.fechaDeEmbarque}</Td>
                                <Td>{embarques.piezasEmbarcadas}</Td>
                                <Td className="margintopmobil20px" >{embarques.piezasNoPintadas}</Td>
                                <Td className="margintopmobil20px">
                                  <button
                                    class="btn-info cbutton mt-1 ml-1"
                                    onClick={() => clicMostrar(embarques)}
                                    title="Detalles del embarque"
                                  >
                                    {" "}
                                    <IoIcons.IoIosListBox />{" "}
                                  </button>
                                  {pembarques && (
                                    <>
                                      <button
                                        class="btn-primary cbutton mt-1 ml-1"
                                        onClick={() => clicEditar(embarques)}
                                        title="Editar"
                                      >
                                        {" "}
                                        <IoIcons.IoIosCreate />{" "}
                                      </button>
                                      <button
                                        class="btn-warning cbutton mt-1 ml-1"
                                        title="Imprimir packing"
                                        onMouseDown={() => setIndexImp(0)}
                                        onClick={() => clicImprimir(embarques)}
                                      >
                                        {" "}
                                        <IoIcons.IoIosPrint />{" "}
                                      </button>
                                      {/**<button class="btn-danger cbutton mt-1 ml-1" onClick={() => clicEliminar(embarques)} title="Eliminar"> <IoIcons.IoIosClose /> </button> */}
                                    </>
                                  )}
                                </Td>
                              </Tr>
                            ))}
                          </Tbody>
                        </Table>
                      </div>
                      <div class="col-lg-12 col-md-12 col-sm-12 mt-2 mb-1 "></div>
                    </div>
                    <Modal isOpen={modal} toggle={toggle}>
                      <ModalHeader toggle={toggle}>
                        Eliminar Embarque
                      </ModalHeader>
                      <ModalBody>
                        ¿Estás seguro que quieres eliminar el Embarque de la
                        fecha {Moment(fechaDeEmbarqueM).format("DD/MM/YYYY")}?
                      </ModalBody>
                      <ModalFooter>
                        <Button color="primary" onClick={aceptarEliminar}>
                          Aceptar
                        </Button>{" "}
                        <Button color="danger" onClick={toggle}>
                          Cancelar
                        </Button>
                      </ModalFooter>
                    </Modal>
                    <div class="col-lg-12 col-md-12 col-sm-12  ">
                      <div class="floatcenter">
                        <ul class="pagination">
                          <li
                            class={
                              currentPageEmbarques === 1
                                ? "page-item disabled"
                                : "page-item"
                            }
                          >
                            <a
                              class="page-link"
                              href="#"
                              aria-label="Go to first page"
                              onClick={() => handlePageChangeEmbarques(1)}
                            >
                              «
                            </a>
                          </li>
                          <li
                            class={
                              currentPageEmbarques === 1
                                ? "page-item disabled"
                                : "page-item"
                            }
                          >
                            <a
                              class="page-link"
                              href="#"
                              aria-label="Go to previous page"
                              onClick={() =>
                                handlePageChangeEmbarques(
                                  currentPageEmbarques - 1
                                )
                              }
                            >
                              ⟨
                            </a>
                          </li>
                          {paginas.map(
                            (pagina) =>
                              pagina.pagina <
                              currentPageEmbarques + pageRange &&
                              pagina.pagina >=
                              (paginas.length - (pageRange - 1) <
                                currentPageEmbarques + pageRange - pageRange
                                ? paginas.length - (pageRange - 1)
                                : currentPageEmbarques +
                                pageRange -
                                pageRange) && (
                                <li
                                  class={
                                    currentPageEmbarques === pagina.pagina
                                      ? "page-item active"
                                      : "page-item "
                                  }
                                >
                                  <a
                                    class="page-link "
                                    onClick={() =>
                                      handlePageChangeEmbarques(pagina.pagina)
                                    }
                                  >
                                    {pagina.pagina}
                                  </a>
                                </li>
                              )
                          )}
                          <li
                            class={
                              currentPageEmbarques === ultimoNumeroP
                                ? "page-item disabled"
                                : "page-item"
                            }
                          >
                            <a
                              class="page-link"
                              href="#"
                              aria-label="Go to next page"
                              onClick={() =>
                                handlePageChangeEmbarques(
                                  currentPageEmbarques + 1
                                )
                              }
                            >
                              ⟩
                            </a>
                          </li>
                          <li
                            class={
                              currentPageEmbarques === ultimoNumeroP
                                ? "page-item disabled"
                                : "page-item"
                            }
                          >
                            <a
                              class="page-link"
                              href="#"
                              aria-label="Go to last page"
                              onClick={() =>
                                handlePageChangeEmbarques(ultimoNumeroP)
                              }
                            >
                              »
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(embarques)}</div>*/}
                    {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left " style={{ marginTop: 20 }}>{JSON.stringify(embarquesSinFiltro)}</div>*/}
                  </TabPane>
                  <TabPane tabId="2">
                    {tituloTab != "Detalle de embarque" && (
                      <>
                        <Row>
                          <div class="col-lg-2 col-md-3 col-sm-12 col-xs-12   margintop20px ">
                            <Label className="floatleft">
                              Fecha*: {/*clienteID*/}{" "}
                            </Label>
                            <Input
                              name="fechaDeEmbarque"
                              type="date"
                              onChange={onChangesDatosEmbarques}
                              value={fechaDeEmbarque}
                            />
                          </div>
                          <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 margintop20px ">
                            <Label className="floatleft">
                              Cliente*:{/* rCliente*/}{" "}
                            </Label>
                            <select
                              name="clienteID"
                              className="floatleft custom-select"
                              onChange={onChangesClientes}
                              disabled={inputList.length > 0 ? true : false}
                            >
                              <option className="" value="">
                                Elige un cliente{" "}
                              </option>
                              {clientes.map((cliente) => (
                                <>
                                  {cliente.activo && (
                                    <option
                                      className=""
                                      value={cliente.id}
                                      selected={
                                        clienteID === cliente.id ? true : false
                                      }
                                    >
                                      {cliente.cliente}
                                    </option>
                                  )}
                                </>
                              ))}
                            </select>
                          </div>
                          <div class="col-lg-3 col-md-6 col-sm-12 col-xs-12 margintop20px ">
                            <Label className="floatleft">
                              En atencion a*:{" "}
                            </Label>
                            <Input
                              name="atencionA"
                              onChange={onChangesDatosEmbarques}
                              value={atencionA}
                            />
                          </div>
                          <div class="col-lg-3 col-md-10 col-sm-12 col-xs-12 margintop20px ">
                            <Label className="floatleft">
                              {rCliente === "Olson Internacional"
                                ? "Lote*:"
                                : "Orden de compra*:"}{" "}
                            </Label>
                            <Input
                              type="textarea"
                              name="ordenDeCompra"
                              onChange={onChangesDatosEmbarques}
                              value={ordenDeCompra}
                              rows="1"
                            />
                          </div>
                        </Row>
                        <Row>
                          <div class="col-lg-5 col-md-6 col-sm-12 col-xs-12 margintop10px ">
                            <Label className="floatleft">
                              Cliente a entregar el embarque*:
                            </Label>
                            <select
                              name="clienteEntregaID"
                              className="floatleft custom-select"
                              onChange={onChangesClientesEntrega}
                            >
                              {clientes.map((cliente) => (
                                <>
                                  {cliente.activo && (
                                    <option
                                      className=""
                                      value={cliente.id}
                                      selected={
                                        clienteEntregaID === cliente.id
                                          ? true
                                          : false
                                      }
                                    >
                                      {cliente.cliente}
                                    </option>
                                  )}
                                </>
                              ))}
                            </select>
                          </div>
                          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 margintop10px ">
                            <Label className="floatleft">
                              Facturar a: {/*embarqueEditando.updatedAt*/}
                            </Label>
                            <Input
                              name="rClienteFacturarA"
                              onChange={onChangesDatosEmbarques}
                              value={rClienteFacturarA}
                            />
                          </div>
                          {(!inputList[0] && !inputListServicios[0]) && (
                            <div class={"col-lg-1 col-md-2 col-sm-12 col-xs-12  margintop40px "}>
                              <button
                                className="cbutton btn-primary floatright "
                                color="primary"
                                disabled={(clienteID != "") ? false : true}
                                size="sm"
                                title="Guardar datos de embarque"
                                onClick={() => crearEmbarque()}
                              > Guardar
                              </button>
                            </div>
                          )}
                        </Row>
                        {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(recibaSinFiltro)}</div>*/}
                        <Row>

                          <div class={"col-lg-10 col-md-12 col-sm-12 col-xs-12  margintop10px "}>
                            {!inputListServicios[0] && (
                              <>
                                <Label className="floatleft "><input type="checkbox" name="iTotalNParte" checked={iTotalNParte} onChange={onChangesDatosEmbarques} className='ml-2' />Imprimir con total por número de parte</Label>
                                <Label className="floatleft "><input type="checkbox" name="sinTotalScrap" checked={sinTotalScrap} onChange={onChangesDatosEmbarques} className='ml-2' />No sumar scrap en formato impreso</Label>
                                <Label className="floatleft "><input type="checkbox" name="sinTotalScrapFactura" checked={sinTotalScrapFactura} onChange={onChangesDatosEmbarques} className='ml-2' />No sumar scrap en Factura</Label>
                                <Label className="floatleft "><input type="checkbox" name="desgloceVer" checked={desgloceVer} onChange={onChangesDatosEmbarques} className='ml-2' />Mostrar detalle en impresión</Label>
                              </>
                            )}
                          </div>
                          {editar && (

                            <div class={"col-lg-2 col-md-12 col-sm-12 col-xs-12  margintop10px "}>
                              <BarcodeReader
                                onError={handleError}
                                onScan={handleScan}
                                minLength={1}
                              />
                              {!(inputListServicios.length > 0) && (
                                <button
                                  className="cbutton btn-success floatright ml-2 "
                                  color="success"
                                  disabled={(clienteID != "") ? false : true}
                                  size="sm"
                                  title="Agregar material para embarcar"
                                  onClick={() => clicAgregarMaterial("")}
                                >
                                  <span className="fa fa-plus"> Material</span>
                                </button>)}
                              {!(inputList.length > 0) && (
                                <button
                                  className="cbutton btn-success ml-4 floatrightleft "
                                  color="success"
                                  disabled={(clienteID != "") ? false : true}
                                  size="sm"
                                  title="Agregar servicios para embarcar"
                                  onClick={(e) => AgregarServicios()}
                                >
                                  <span className="fa fa-plus"> Servicio</span>
                                </button>
                              )}
                            </div>

                          )}
                        </Row>
                        {inputList.length > 0 && (
                          <>
                            <Row>
                              <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12  scroll">
                                <Table className=" mb-2  ">
                                  <Thead class="thead-secondary">
                                    <Tr>
                                      <Th>Número</Th>
                                      <Th className="minwidth100px">Cliente</Th>
                                      <Th className="minwidth130px">
                                        Número de parte
                                      </Th>
                                      <Th className="minwidth100px">
                                        Descripción
                                      </Th>
                                      <Th>Serial </Th>
                                      <Th>Serial BTI</Th>
                                      <Th>
                                        {rCliente === "Olson Internacional"
                                          ? "PO"
                                          : "Lote"}
                                      </Th>
                                      <Th>
                                        {rCliente === "Olson Internacional"
                                          ? "Line"
                                          : "Packing"}
                                      </Th>
                                      <Th className="minwidth100px">
                                        MFG Fecha
                                      </Th>
                                      {/*<Th className="minwidth100px">
                                        Desgloce Detalles
                                      </Th>*/}
                                      <Th className="minwidth130px">
                                        Nuevo Serial del cliente
                                      </Th>
                                      <Th>Piezas pintadas*</Th>
                                      <Th>Piezas pintadas extra</Th>
                                      <Th>Piezas no recuperadas*</Th>
                                      <Th>Piezas no pintadas*</Th>
                                      <Th className="minwidth130px">
                                        Material en*:
                                      </Th>
                                      <Th className="">Empaques*:</Th>
                                      {
                                        <Th className="minwidth130px">
                                          Comentarios
                                        </Th>
                                      }
                                      {/*<Th className="width30px"> Modificado </Th>*/}
                                      <Th className="width30px"> Eliminar </Th>
                                    </Tr>
                                  </Thead>
                                  <Tbody>
                                    {inputList.map(
                                      (x, i) =>
                                        x.activo && (
                                          <Tr
                                            className={
                                              i % 2 !== 0 ? "table-active" : ""
                                            }
                                          >
                                            <Td>{x.orden ? x.orden : i + 1}</Td>
                                            <Td>{x.cliente}</Td>
                                            <Td className="">
                                              {x.numerodeParte}
                                            </Td>
                                            <Td className="">
                                              {x.descripcion}
                                            </Td>
                                            <Td className={x.descripcion ? "" : "margintopmobil20px"}>{x.serial}</Td>
                                            <Td className="">
                                              {x.serialRecibaBTI}
                                            </Td>
                                            <Td className="">
                                              {rCliente ===
                                                "Olson Internacional"
                                                ? x.po
                                                : x.lote}
                                            </Td>
                                            <Td className="">{x.packing}</Td>
                                            <Td className="">{x.MFGFecha}</Td>
                                            {/*<Td className="">{JSON.stringify(x.desgloceDetalles)}</Td>*/}
                                            <Td className="">
                                              {/*<Input name="comentarios" type="textarea" rows="1" value={x.comentarios} onChange={e => setInputList(handleInputChange(e, i, [...inputList]))} placeholder="" />*/}
                                              <Input
                                                name="serialNRecuperado"
                                                value={x.serialNRecuperado}
                                                onChange={(e) =>
                                                  setInputList(
                                                    handleInputChange(e, i, [
                                                      ...inputList,
                                                    ])
                                                  )
                                                }
                                                placeholder=""
                                              />
                                            </Td>
                                            <Td
                                              className={
                                                (parseInt(x.pPintadasOriginal ? x.pPintadasOriginal : 0) +
                                                  parseInt(x.pNRecuperadasOriginal ? x.pNRecuperadasOriginal : 0)) !=
                                                  (parseInt(x.piezasNRecuperadas ? x.piezasNRecuperadas : 0) +
                                                    parseInt(x.piezasPintadas ? x.piezasPintadas : 0)) ||
                                                  (x.piezasPintadas == 0 &&
                                                    x.piezasNRecuperadas == 0)
                                                  ? "margintopmobil0px novalido"
                                                  : "margintopmobil0px"
                                              }
                                            >
                                              <Input
                                                name="piezasPintadas"
                                                value={x.piezasPintadas}
                                                onChange={(e) =>
                                                  setInputList(
                                                    handleInputChange(e, i, [
                                                      ...inputList,
                                                    ])
                                                  )
                                                }
                                                placeholder=""
                                              />
                                            </Td>
                                            <Td
                                              className={"margintopmobi40px"}
                                            >
                                              <Input
                                                name="piezasPintadasExtra"
                                                value={
                                                  x.piezasPintadasExtra > 0
                                                    ? x.piezasPintadasExtra
                                                    : ""
                                                }
                                                onChange={(e) =>
                                                  setInputList(
                                                    handleInputChange(e, i, [
                                                      ...inputList,
                                                    ])
                                                  )
                                                }
                                                placeholder=""
                                              />
                                            </Td>
                                            <Td
                                              className={
                                                (parseInt(x.pPintadasOriginal ? x.pPintadasOriginal : 0) +
                                                  parseInt(x.pNRecuperadasOriginal ? x.pNRecuperadasOriginal : 0)) !=
                                                  (parseInt(x.piezasNRecuperadas ? x.piezasNRecuperadas : 0) +
                                                    parseInt(x.piezasPintadas ? x.piezasPintadas : 0))
                                                  ? "margintopmobi40px novalido"
                                                  : "margintopmobi40px"
                                              }
                                            >
                                              <Input
                                                name="piezasNRecuperadas"
                                                value={
                                                  x.piezasNRecuperadas > 0
                                                    ? x.piezasNRecuperadas
                                                    : ""
                                                }
                                                onChange={(e) =>
                                                  setInputList(
                                                    handleInputChange(e, i, [
                                                      ...inputList,
                                                    ])
                                                  )
                                                }
                                                placeholder=""
                                              />
                                            </Td>
                                            <Td
                                              className={
                                                (x.MaterialPintado === false ||
                                                  x.ambos === true) &&
                                                  x.piezasNoPintadas == 0
                                                  ? "margintopmobi40px novalido"
                                                  : "margintopmobi40px"
                                              }
                                            >
                                              <Input
                                                name="piezasNoPintadas"
                                                value={
                                                  x.piezasNoPintadas > 0
                                                    ? x.piezasNoPintadas
                                                    : ""
                                                }
                                                disabled={
                                                  x.ambos === true
                                                    ? false
                                                    : x.MaterialPintado
                                                }
                                                onChange={(e) =>
                                                  setInputList(
                                                    handleInputChange(e, i, [
                                                      ...inputList,
                                                    ])
                                                  )
                                                }
                                                placeholder=""
                                              />
                                            </Td>
                                            <Td>
                                              <select
                                                name="materialEn"
                                                className=" custom-select"
                                                onChange={(e) =>
                                                  setInputList(
                                                    handleInputChange(e, i, [
                                                      ...inputList,
                                                    ])
                                                  )
                                                }
                                              >
                                                <option
                                                  value="Contenedor"
                                                  selected={
                                                    x.materialEn ===
                                                      "Contenedor"
                                                      ? true
                                                      : false
                                                  }
                                                >
                                                  Contenedor
                                                </option>
                                                <option
                                                  value="Caja"
                                                  selected={
                                                    x.materialEn === "Caja"
                                                      ? true
                                                      : false
                                                  }
                                                >
                                                  Caja
                                                </option>
                                                <option
                                                  value="Tarima"
                                                  selected={
                                                    x.materialEn === "Tarima"
                                                      ? true
                                                      : false
                                                  }
                                                >
                                                  Tarima
                                                </option>
                                              </select>
                                            </Td>
                                            <Td className={"margintopmobil0px"}>
                                              <Input
                                                name="materialEnCantidad"
                                                value={x.materialEnCantidad}
                                                onChange={(e) =>
                                                  setInputList(
                                                    handleInputChange(e, i, [
                                                      ...inputList,
                                                    ])
                                                  )
                                                }
                                                placeholder=""
                                              />
                                            </Td>
                                            <Td className="">
                                              <Input
                                                name="comentarios"
                                                type="textarea"
                                                rows="1"
                                                value={x.comentarios}
                                                onChange={(e) =>
                                                  setInputList(
                                                    handleInputChange(e, i, [
                                                      ...inputList,
                                                    ])
                                                  )
                                                }
                                                placeholder=""
                                              />
                                            </Td>
                                            {/*<Td className="">
                                              {x.modificado ? "Sí" : "No"}
                                            </Td>*/}
                                            <Td className="margintopmobil20px">
                                              <Button
                                                className=" "
                                                title="Eliminar registro"
                                                size="sm"
                                                color="danger"
                                                onClick={() =>
                                                  setInputList(
                                                    handleRemoveClick(i, [
                                                      ...inputList,
                                                    ])
                                                  )
                                                }
                                              >
                                                <IoIcons.IoMdClose />
                                              </Button>

                                              {/*<button
                                                class="btn-info cbutton mt-1 ml-1"
                                                onClick={() => clicMostrarDatosSerial(x)}
                                                title="Detalles del serial"
                                              >
                                                {" "}
                                                <IoIcons.IoIosListBox />{" "}
                                              </button>*/}
                                            </Td>
                                          </Tr>
                                        )
                                    )}
                                  </Tbody>
                                </Table>
                              </div>
                            </Row>
                            <Row>
                              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop20px">
                                {/*JSON.stringify(inputList)*/}
                                <Button
                                  className="floatright mr-3"
                                  onClick={cancelarEmbarques}
                                  color="danger"
                                >
                                  Terminar
                                </Button>
                                <Button
                                  className="floatright"
                                  onClick={() => manageEmbarques()}
                                  disabled={isDisabled}
                                  color="primary"
                                >
                                  Guardar
                                </Button>
                              </div>
                            </Row>
                            {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(inputList)}</div>*/}
                            {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(recibaSinFiltro)}</div>*/}
                          </>
                        )}
                        {inputListServicios.length > 0 && (
                          <>
                            <Row>
                              <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12  scroll">
                                <Table className=" mb-2  ">
                                  <Thead class="thead-secondary">
                                    <Tr>
                                      <Th>Número</Th>
                                      <Th className="minwidth130px">
                                        Número de parte*
                                      </Th>
                                      <Th className="minwidth100px">
                                        Descripción
                                      </Th>
                                      <Th>Serial* </Th>
                                      <Th>Cantidad de Piezas*</Th>
                                      <Th className="minwidth130px">
                                        Material en*:
                                      </Th>
                                      <Th className="">Empaques*:</Th>
                                      <Th className="minwidth130px">
                                        SHIPPER
                                      </Th>
                                      {/*<Th className="width30px"> Modificado </Th>*/}
                                      <Th className="width30px"> Eliminar </Th>
                                    </Tr>
                                  </Thead>
                                  <Tbody>
                                    {inputListServicios.map(
                                      (x, i) =>
                                        <Tr
                                          className={
                                            i % 2 !== 0 ? "table-active" : ""
                                          }
                                        >
                                          <Td>{x.orden ? x.orden + 1 : i + 1}</Td>
                                          <Td className="">
                                            <Input
                                              name="numerodeParte"
                                              value={x.numerodeParte}
                                              onChange={(e) => setInputListServicios(
                                                handleInputChangeServicios(e, i, [...inputListServicios,]))}
                                            />
                                          </Td>
                                          <Td className="">
                                            <Input
                                              name="descripcion"
                                              value={x.descripcion}
                                              onChange={(e) => setInputListServicios(
                                                handleInputChangeServicios(e, i, [...inputListServicios,]))}
                                            />
                                          </Td>
                                          <Td className={x.descripcion ? "" : "margintopmobil20px"}>
                                            <Input
                                              name="serial"
                                              value={x.serial}
                                              onChange={(e) => setInputListServicios(
                                                handleInputChangeServicios(e, i, [...inputListServicios,]))}
                                            />
                                          </Td>
                                          <Td >
                                            <Input
                                              name="piezasPintadas"
                                              value={x.piezasPintadas}
                                              onChange={(e) => setInputListServicios(
                                                handleInputChangeServicios(e, i, [...inputListServicios,]))}
                                            />
                                          </Td>
                                          <Td>
                                            <select
                                              name="materialEn"
                                              className=" custom-select"
                                              onChange={(e) => setInputListServicios(
                                                handleInputChangeServicios(e, i, [...inputListServicios,]))}
                                            >
                                              <option
                                                value="Contenedor"
                                                selected={
                                                  x.materialEn ===
                                                    "Contenedor"
                                                    ? true
                                                    : false
                                                }
                                              >
                                                Contenedor
                                              </option>
                                              <option
                                                value="Caja"
                                                selected={
                                                  x.materialEn === "Caja"
                                                    ? true
                                                    : false
                                                }
                                              >
                                                Caja
                                              </option>
                                              <option
                                                value="Tarima"
                                                selected={
                                                  x.materialEn === "Tarima"
                                                    ? true
                                                    : false
                                                }
                                              >
                                                Tarima
                                              </option>
                                            </select>
                                          </Td>
                                          <Td className={"margintopmobil0px"}>
                                            <Input
                                              name="materialEnCantidad"
                                              value={x.materialEnCantidad}
                                              onChange={(e) => setInputListServicios(
                                                handleInputChangeServicios(e, i, [...inputListServicios,]))}
                                            />
                                          </Td>
                                          <Td className="">
                                            <Input
                                              name="shipper"
                                              value={x.shipper}
                                              onChange={(e) => setInputListServicios(
                                                handleInputChangeServicios(e, i, [...inputListServicios,]))}
                                            />
                                          </Td>
                                          <Td className="margintopmobil20px">
                                            <Button
                                              className=" "
                                              title="Eliminar registro"
                                              size="sm"
                                              color="danger"
                                              onClick={() => setInputListServicios(handleRemoveClickServicios(i, [
                                                ...inputListServicios,
                                              ]))}
                                            >
                                              <IoIcons.IoMdClose />
                                            </Button>
                                          </Td>
                                        </Tr>

                                    )}
                                  </Tbody>
                                </Table>
                              </div>
                            </Row>
                            <Row>
                              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop20px">
                                <Button
                                  className="floatright mr-3"
                                  onClick={cancelarEmbarques}
                                  color="danger"
                                >
                                  Terminar
                                </Button>
                                <Button
                                  className="floatright"
                                  onClick={() => manageEmbarques()}
                                  color="primary"
                                >
                                  Guardar Servicios
                                </Button>
                              </div>
                            </Row>
                            {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(inputList)}</div>*/}
                            {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(recibaSinFiltro)}</div>*/}
                          </>
                        )}
                        {/*JSON.stringify(inputListServicios)*/}
                      </>
                    )}
                    {datosReciba === true && (
                      <GeneralProduccion
                        sProduccion={datosSerial}
                        bColor={"warning mr-2"}
                        btitle={"Embarcar Material"}
                        modulo={"Embarques"}
                        usuario={userName}
                        modalO={true}
                        valorDeREtorno={handleCallback}
                      />
                    )}
                    {tituloTab === "Detalle de embarque" && (
                      <>
                        <Row>
                          {pembarques && (
                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 floatleft">
                              <button
                                class=" btn-primary cbutton floatleft  margintop10px "
                                onClick={() => clicEditar()}
                                title="Editar"
                              >
                                <IoIcons.IoIosCreate />
                                Editar{" "}
                              </button>
                            </div>
                          )}
                          <div
                            className={
                              pembarques
                                ? "col-lg-6 col-md-6 col-sm-6 col-xs-6  margintop10px floatright"
                                : "col-lg-12 col-md-12 col-sm-12 col-xs-12  margintop10px floatright"
                            }
                          >
                            <button
                              class="btn-info cbutton floatright "
                              onClick={cancelarEmbarques}
                              title="Regresar"
                            >
                              <IoIcons.IoMdArrowRoundBack />
                              Regresar{" "}
                            </button>
                          </div>
                        </Row>
                        <Row>
                          <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12  scroll">
                            <div className="textaligmentleft">
                              {" "}
                              <h5>Datos generales</h5>
                            </div>
                            <Table className="margintop20px mb-2  ">
                              <Thead class="thead-secondary">
                                <Tr>
                                  <Th>Packing ID</Th>
                                  <Th className="minwidth100px">Fecha</Th>
                                  <Th className="minwidth100px">
                                    Cliente de recepción
                                  </Th>
                                  <Th className="minwidth100px">
                                    Cliente de entrega
                                  </Th>
                                  <Th className="minwidth100px">Facturar a</Th>
                                  <Th className="minwidth100px">
                                    En atencion a
                                  </Th>
                                  <Th>
                                    {rCliente === "Olson Internacional"
                                      ? "Lote"
                                      : "Orden de compra"}
                                  </Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                <Tr>
                                  <Td>
                                    {numeroP ? numeroP : ""}
                                  </Td>
                                  <Td>{fechaDeEmbarque}</Td>
                                  <Td className=""> {rCliente} </Td>
                                  <Td className=""> {rClienteEntrega} </Td>
                                  <Td className=""> {rClienteFacturarA} </Td>
                                  <Td className="">{atencionA} </Td>
                                  <Td className="">{ordenDeCompra}</Td>
                                </Tr>
                              </Tbody>
                            </Table>
                          </div>
                        </Row>
                        {inputList.length > 0 && (
                          <Row>
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 textaligmentleft margintop20px">
                              <h5>Detalle Seriales</h5>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 margintop20px">
                              <button
                                class="btn-warning cbutton floatrightleft"
                                title="Imprimir todas las etiquetas"
                                onClick={() => handlePrintTEV()}
                              >
                                {" "}
                                <IoIcons.IoIosPrint /> Imprimir todo
                              </button>
                            </div>
                            <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                              <Table className="mb-2  ">
                                <Thead class="thead-secondary">
                                  <Tr>
                                    <Th>No.</Th>
                                    <Th className="minwidth100px">Cliente</Th>
                                    <Th className="minwidth100px">
                                      Número de parte
                                    </Th>
                                    <Th className="minwidth100px">
                                      Número de parte Embarques
                                    </Th>
                                    <Th className="minwidth100px">Descripción</Th>
                                    <Th>Serial </Th>
                                    <Th>Serial BTI</Th>
                                    <Th>Serial Embarques </Th>
                                    <Th>Nuevo Serial del cliente</Th>
                                    <Th>
                                      {rCliente === "Olson Internacional"
                                        ? "PO:"
                                        : "Lote:"}
                                    </Th>
                                    <Th>
                                      {rCliente === "Olson Internacional"
                                        ? "Line"
                                        : "Packing"}
                                    </Th>
                                    <Th className="minwidth100px">MFG Fecha</Th>
                                    <Th>Comentarios</Th>
                                    <Th>Piezas pintadas</Th>
                                    <Th>Piezas no recuperadas</Th>
                                    <Th>Piezas no pintadas</Th>
                                    <Th className="">Material en:</Th>
                                    <Th className="">Empaques:</Th>
                                    {/*<Th >Barra</Th>*/}
                                    <Th>Imprimir Etiqueta</Th>
                                  </Tr>
                                </Thead>
                                <Tbody>
                                  {inputList.map(
                                    (x, i) =>
                                      x.activo && (
                                        <Tr
                                          className={
                                            i % 2 !== 0 ? "table-active" : ""
                                          }
                                        >
                                          <Td>{x.orden}</Td>
                                          <Td>{x.cliente}</Td>
                                          <Td className="">{x.numerodeParte}</Td>
                                          <Td className="">
                                            {x.numerodeParteSalida}
                                          </Td>
                                          <Td
                                            className={
                                              !x.numerodeParteSalida
                                                ? "margintopmobil20px"
                                                : ""
                                            }
                                          >
                                            {x.descripcion}
                                          </Td>
                                          <Td className={!x.descripcion ? "margintopmobil20px" : ""}>
                                            {x.serial}
                                          </Td>
                                          <Td className="">
                                            {x.serialRecibaBTI}
                                          </Td>
                                          <Td className="">{x.numeroSerial}</Td>
                                          <Td className="">
                                            {x.serialNRecuperado}
                                          </Td>
                                          <Td className="">
                                            {rCliente === "Olson Internacional"
                                              ? x.po
                                              : x.lote}
                                          </Td>
                                          <Td className="">{x.packing}</Td>
                                          <Td className="">{x.MFGFecha}</Td>
                                          <Td className=""> {x.comentarios} </Td>
                                          <Td className="">{x.piezasPintadas}</Td>
                                          <Td className="">
                                            {x.piezasNRecuperadas > 0
                                              ? x.piezasNRecuperadas
                                              : ""}
                                          </Td>
                                          <Td className={!x.piezasNRecuperadas ? "margintopmobil20px" : ""}>
                                            {x.piezasNoPintadas > 0
                                              ? x.piezasNoPintadas
                                              : ""}
                                          </Td>
                                          <Td
                                            className={
                                              x.piezasNoPintadas > 0
                                                ? ""
                                                : "margintopmobil20px"
                                            }
                                          >
                                            {x.materialEn}
                                          </Td>
                                          <Td className={"margintopmobil0px"}>
                                            {x.materialEnCantidad}{" "}
                                          </Td>
                                          {/*<Td><Bargenerator data={x.serial} /></Td>*/}
                                          <Td>
                                            <button
                                              class="btn-warning cbutton mt-1 ml-1"
                                              title="Etiqueta viajera"
                                              onMouseDown={() =>
                                                setIndexImp(i + 1)
                                              }
                                              onClick={() =>
                                                clicImprimirEtiqueta(x)
                                              }
                                            >
                                              {" "}
                                              <IoIcons.IoIosPrint />{" "}
                                            </button>
                                          </Td>
                                        </Tr>
                                      )
                                  )}
                                </Tbody>
                              </Table>
                            </div>
                          </Row>
                        )}
                        {inputListServicios.length > 0 && (
                          <Row>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 textaligmentleft margintop20px">
                              <h5>Detalle Servicios</h5>
                            </div>
                            <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                              <Table className=" mb-2  ">
                                <Thead class="thead-secondary">
                                  <Tr>
                                    <Th>Número</Th>
                                    <Th className="minwidth130px">
                                      Número de parte
                                    </Th>
                                    <Th className="minwidth100px">
                                      Descripción
                                    </Th>
                                    <Th>Serial </Th>
                                    <Th>Cantidad de Piezas</Th>
                                    <Th className="minwidth130px">
                                      Material en:
                                    </Th>
                                    <Th className="">Empaques:</Th>
                                    <Th className="minwidth130px">
                                      SHIPPER
                                    </Th>
                                  </Tr>
                                </Thead>
                                <Tbody>
                                  {inputListServicios.map(
                                    (x, i) =>
                                      <Tr
                                        className={
                                          i % 2 !== 0 ? "table-active" : ""
                                        }
                                      >
                                        <Td>{x.orden ? x.orden + 1 : i + 1}</Td>
                                        <Td className="">
                                          {x.numerodeParte}
                                        </Td>
                                        <Td className="">
                                          {x.descripcion}
                                        </Td>
                                        <Td className={x.descripcion ? "" : "margintopmobil20px"}>
                                          {x.serial}
                                        </Td>
                                        <Td >
                                          {x.piezasPintadas}
                                        </Td>
                                        <Td>
                                          {x.materialEn}
                                        </Td>
                                        <Td className={"margintopmobil0px"}>
                                          {x.materialEnCantidad}
                                        </Td>
                                        <Td className="">
                                          {x.shipper}
                                        </Td>
                                      </Tr>

                                  )}
                                </Tbody>
                              </Table>
                            </div>
                          </Row>
                        )}
                        <div style={{ display: "none" }}>
                          <div ref={componentRefTEV}>
                            {inputList.map((x, i) => {
                              return (
                                x.activo && (
                                  <div ref={componentRef[i + 1]}>
                                    {(x.piezasPintadas ? x.piezasPintadas : 0) >
                                      0 && (
                                        <div className="page-breaksmtop">
                                          <Row>
                                            <div class="col-lg-12 col-md-12 col-sm-12  textaligmentcenter">
                                              <img
                                                className="imgmaretiqueta"
                                                src="assets/img/Logo/logon.png"
                                              />
                                            </div>
                                            <div class="col-lg-12 col-md-12 col-sm-12 textaligmentcenter ">
                                              <h1 class=" textaligmentcenter fontblackbold ">
                                                BOON TEC INTERNATIONAL, S. de R.L.
                                                de C.V.
                                              </h1>
                                            </div>
                                            <div class="col-lg-12 col-md-12 col-sm-12 margintop-16px textaligmentcenter">
                                              <h3 class="  textaligmentcenter  fontblackbold ">
                                                Norte 2 #14, Fracc. Cd.
                                                Industrial.H. Matamoros, Mexico CP
                                                87499
                                              </h3>
                                            </div>
                                          </Row>
                                          <div>
                                            <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                                              <Table bordered className=" ">
                                                <Thead>
                                                  <Tr>
                                                    <Th></Th>
                                                    <Th></Th>
                                                  </Tr>
                                                </Thead>
                                                <Tbody>
                                                  <Tr>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <Label className="fontblackbold">
                                                        PART NO:
                                                      </Label>
                                                    </Td>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <p className="floatleft fontblackbold subrayado">
                                                        {x.numerodeParteSalida
                                                          ? x.numerodeParteSalida
                                                          : x.numerodeParte}
                                                      </p>{" "}
                                                    </Td>
                                                  </Tr>
                                                  {x.cliente !=
                                                    "Olson Internacional" && (
                                                      <Tr>
                                                        <Td className="fontsize50px textaligmentcenter">
                                                          <Label className="  fontblackbold">
                                                            DESCRIPTION:
                                                          </Label>
                                                        </Td>
                                                        <Td className="fontsize50px textaligmentcenter">
                                                          <p className="floatleft  fontblackbold">
                                                            {x.descripcion}
                                                          </p>
                                                        </Td>
                                                      </Tr>
                                                    )}
                                                  {x.cliente ===
                                                    "Olson Internacional" && (
                                                      <Tr>
                                                        <Td className="fontsize50px textaligmentcenter">
                                                          <Label className="  fontblackbold">
                                                            LINE/REL:
                                                          </Label>
                                                        </Td>
                                                        <Td className="fontsize50px textaligmentcenter">
                                                          <p className="floatleft  fontblackbold">
                                                            {x.packing}
                                                          </p>
                                                        </Td>
                                                      </Tr>
                                                    )}
                                                  <Tr>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <Label className="fontblackbold">
                                                        MFG DATE:
                                                      </Label>
                                                    </Td>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <p className="floatleft fontblackbold">
                                                        {x.MFGFecha}
                                                      </p>{" "}
                                                    </Td>
                                                  </Tr>
                                                  <Tr>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <Label className="fontblackbold">
                                                        QUANTITY:
                                                      </Label>
                                                    </Td>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <p className="floatleft fontblackbold">
                                                        {x.piezasPintadas}
                                                      </p>
                                                    </Td>
                                                  </Tr>
                                                  <Tr>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <Label className="fontblackbold">
                                                        LOT:
                                                      </Label>
                                                    </Td>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <p className="floatleft fontblackbold">
                                                        {x.lote}
                                                      </p>{" "}
                                                    </Td>
                                                  </Tr>
                                                  <Tr>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <Label className="fontblackbold">
                                                        PO:
                                                      </Label>
                                                    </Td>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <p className="floatleft fontblackbold">
                                                        {x.po}
                                                      </p>{" "}
                                                    </Td>
                                                  </Tr>
                                                  <Tr>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <Label className="fontblackbold">
                                                        CLIENT:
                                                      </Label>
                                                    </Td>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <p className="floatleft fontblackbold">
                                                        {x.clienteEntrega}
                                                      </p>{" "}
                                                    </Td>
                                                  </Tr>
                                                  <Tr>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <Label className="fontblackbold">
                                                        SERIAL NUMBER:
                                                      </Label>
                                                    </Td>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <p className="floatleft fontblackbold">
                                                        {x.serial}
                                                      </p>{" "}
                                                    </Td>
                                                  </Tr>
                                                </Tbody>
                                              </Table>
                                            </div>
                                          </div>
                                          <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 textaligmentcenter mt-3">
                                            <Bargenerator data={x.numeroSerial} />
                                          </div>
                                        </div>
                                      )}
                                    {((x.piezasNRecuperadas
                                      ? x.piezasNRecuperadas
                                      : 0) > 0 ||
                                      (x.piezasNoPintadas
                                        ? x.piezasNoPintadas
                                        : 0) > 0) && (
                                        <div className="page-breaksmtop">
                                          <Row>
                                            <div class="col-lg-12 col-md-12 col-sm-12  textaligmentcenter">
                                              <img
                                                className="imgmaretiqueta"
                                                src="assets/img/Logo/logon.png"
                                              />
                                            </div>
                                            <div class="col-lg-12 col-md-12 col-sm-12 textaligmentcenter ">
                                              <h1 class=" textaligmentcenter fontblackbold ">
                                                BOON TEC INTERNATIONAL, S. de R.L.
                                                de C.V.
                                              </h1>
                                            </div>
                                            <div class="col-lg-12 col-md-12 col-sm-12 margintop-16px textaligmentcenter">
                                              <h3 class="  textaligmentcenter  fontblackbold ">
                                                Norte 2 #14, Fracc. Cd.
                                                Industrial.H. Matamoros, Mexico CP
                                                87499
                                              </h3>
                                            </div>
                                          </Row>
                                          <div>
                                            <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
                                              <Table bordered className=" ">
                                                <Thead>
                                                  <Tr>
                                                    <Th></Th>
                                                    <Th></Th>
                                                  </Tr>
                                                </Thead>
                                                <Tbody>
                                                  <Tr>
                                                    <Td
                                                      colspan="2"
                                                      className="fontsize50px textaligmentcenter"
                                                    >
                                                      <Label className="fontblackbold">
                                                        MATERIAL NO CONFORME
                                                      </Label>
                                                    </Td>
                                                  </Tr>
                                                  <Tr>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <Label className="fontblackbold">
                                                        PART NO:
                                                      </Label>
                                                    </Td>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <p className="floatleft fontblackbold subrayado">
                                                        {x.numerodeParteSalida
                                                          ? x.numerodeParteSalida
                                                          : x.numerodeParte}
                                                      </p>{" "}
                                                    </Td>
                                                  </Tr>
                                                  {x.cliente !=
                                                    "Olson Internacional" && (
                                                      <Tr>
                                                        <Td className="fontsize50px textaligmentcenter">
                                                          <Label className="  fontblackbold">
                                                            DESCRIPTION:
                                                          </Label>
                                                        </Td>
                                                        <Td className="fontsize50px textaligmentcenter">
                                                          <p className="floatleft  fontblackbold">
                                                            {x.descripcion}
                                                          </p>
                                                        </Td>
                                                      </Tr>
                                                    )}
                                                  {x.cliente ===
                                                    "Olson Internacional" && (
                                                      <Tr>
                                                        <Td className="fontsize50px textaligmentcenter">
                                                          <Label className="  fontblackbold">
                                                            LINE/REL:
                                                          </Label>
                                                        </Td>
                                                        <Td className="fontsize50px textaligmentcenter">
                                                          <p className="floatleft  fontblackbold">
                                                            {x.packing}
                                                          </p>
                                                        </Td>
                                                      </Tr>
                                                    )}
                                                  <Tr>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <Label className="fontblackbold">
                                                        MFG DATE:
                                                      </Label>
                                                    </Td>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <p className="floatleft fontblackbold">
                                                        {x.MFGFecha}
                                                      </p>{" "}
                                                    </Td>
                                                  </Tr>
                                                  <Tr>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <Label className="fontblackbold">
                                                        QUANTITY:
                                                      </Label>
                                                    </Td>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <p className="floatleft fontblackbold">
                                                        {(x.piezasNRecuperadas
                                                          ? x.piezasNRecuperadas
                                                          : 0) +
                                                          (x.piezasNoPintadas
                                                            ? x.piezasNoPintadas
                                                            : 0)}
                                                      </p>
                                                    </Td>
                                                  </Tr>
                                                  <Tr>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <Label className="fontblackbold">
                                                        LOT:
                                                      </Label>
                                                    </Td>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <p className="floatleft fontblackbold">
                                                        {x.lote}
                                                      </p>{" "}
                                                    </Td>
                                                  </Tr>
                                                  <Tr>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <Label className="fontblackbold">
                                                        PO:
                                                      </Label>
                                                    </Td>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <p className="floatleft fontblackbold">
                                                        {x.po}
                                                      </p>{" "}
                                                    </Td>
                                                  </Tr>
                                                  <Tr>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <Label className="fontblackbold">
                                                        CLIENT:
                                                      </Label>
                                                    </Td>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <p className="floatleft fontblackbold">
                                                        {x.clienteEntrega}
                                                      </p>{" "}
                                                    </Td>
                                                  </Tr>
                                                  <Tr>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <Label className="fontblackbold">
                                                        SERIAL NUMBER:
                                                      </Label>
                                                    </Td>
                                                    <Td className="fontsize50px textaligmentcenter">
                                                      <p className="floatleft fontblackbold">
                                                        {x.serial}
                                                      </p>{" "}
                                                    </Td>
                                                  </Tr>
                                                </Tbody>
                                              </Table>
                                            </div>
                                          </div>
                                          <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 textaligmentcenter mt-3">
                                            <Bargenerator data={x.numeroSerial} />
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                )
                              );
                            })}
                          </div>
                        </div>
                      </>
                    )}
                    <Modal isOpen={modal2} size="lg" toggle={toggle2}>
                      <ModalHeader toggle={toggle2}>
                        Embarcar material
                      </ModalHeader>
                      <ModalBody>
                        <Alert color={colorr} isOpen={aVisibler} toggle={onDismissr}>
                          {mensajeAlertr}
                        </Alert>
                        {cargando1 === true && (
                          <Row>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                              <img width="150px" alt="cargando" src="assets/img/preloader.gif" />
                            </div>
                          </Row>
                        )}
                        {embarqueParticular === false && (
                          <>
                            <Row>
                              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                <Label>
                                  <h5>Busqueda por: </h5>
                                </Label>
                                <select
                                  name="recibaSearchBy"
                                  onChange={buscarporReciba}
                                >
                                  <option value="id de reciba" selected={searchByReciba === "id de reciba" ? true : false}>ID de Reciba</option>
                                  <option value="numero de parte" selected={searchByReciba === "numero de parte" ? true : false}>
                                    Número de parte
                                  </option>
                                  <option value="paking" selected={searchByReciba === "paking" ? true : false}>Packing/Line</option>
                                  <option value="lote" selected={searchByReciba === "lote" ? true : false}>Lote</option>
                                  <option value="po" selected={searchByReciba === "po" ? true : false}>PO</option>
                                  <option value="serial" selected={searchByReciba === "serial" ? true : false}>Serial</option>
                                  <option value="serial BTI" selected={searchByReciba === "serial BTI" ? true : false}>Serial BTI</option>
                                  <option value="fecha de reciba" selected={searchByReciba === "fecha de reciba" ? true : false}>Fecha de reciba</option>
                                </select>
                                <Label className="floatright"><input type="checkbox" name="VUAP" onChange={agregarMaterialCAS} className='ml-2' checked={comCAS} />Agregar material de CAS</Label>

                                <Input
                                  type={searchByReciba !== "text"}
                                  placeholder={"Búsqueda por " + searchByReciba}
                                  onChange={onSearchReciba}
                                  value={searchReciba}
                                />


                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop10px">
                                  <div className=" form-group row col-lg-12 col-md-12 col-sm-12 col-xs-12  floatleft">
                                    <label
                                      class="form-check-label ml-2"
                                      for="aMRecuperado"
                                    >
                                      Fecha de reciba
                                    </label>
                                    <input
                                      type="checkbox"
                                      name="buscarporFecha"
                                      class="form-check-input"
                                      checked={buscarporFecha}
                                      onChange={clicBusquedaporFecha}
                                    />
                                    <div className=" form-group row col-lg-5 col-md-5 col-sm-12 col-xs-12   margintop10px   ml-1 ">
                                      <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                          <InputGroupText>Del:</InputGroupText>
                                        </InputGroupAddon>
                                        <Input
                                          name="rFechaIniag"
                                          type="date"
                                          value={Moment(rfechainiag).format("YYYY-MM-DD")}
                                          onChange={onChangesRFechainiag}
                                        />
                                      </InputGroup>
                                    </div>
                                    <div className=" form-group row col-lg-5 col-md-5 col-sm-12 col-xs-12   margintop10px  floatrightleft ml-1 ">
                                      <InputGroup className="floatrightleft ml-1">
                                        <InputGroupAddon addonType="prepend">
                                          <InputGroupText>Al:</InputGroupText>
                                        </InputGroupAddon>
                                        <Input
                                          name="rFechaFinag"
                                          type="date"
                                          value={Moment(rfechafinag).format("YYYY-MM-DD")}
                                          onChange={onChangesRFechainiag}
                                        />
                                      </InputGroup>
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </Row>
                            <button className="cbutton btn-dark floatright " title="Recargar página" onClick={() => { fetchReciba(comCAS, false, buscarporFecha, searchByReciba, searchReciba); }}><IoIcons.IoMdRefresh /> Recargar </button>
                            <Row>
                              <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                <Label className="floatleft">
                                  Material Pintado
                                </Label>
                                <div className="floatright mr-3">
                                  <label
                                    class="form-check-label"
                                    for="aMRecuperado"
                                  >
                                    Agregar material no recuperado
                                  </label>
                                  <input
                                    type="checkbox"
                                    name="aMRecuperado"
                                    class="form-check-input ml-1"
                                    checked={aMRecuperado}
                                    onChange={clicCHAMNRecuperado}
                                  />
                                </div>
                              </div>
                            </Row>
                            {reciba[0] && (
                              <>
                                <Row>
                                  <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                                    <Table className=" mb-2 scroll ">
                                      <Thead class="thead-secondary">
                                        <Tr>
                                          <Th>ID</Th>
                                          <Th>Cliente</Th>
                                          <Th>Número de parte</Th>
                                          {/*<Th >Número de parte Embarques</Th>*/}
                                          <Th>Descripción</Th>
                                          <Th>
                                            {/*Cantidad recibida*/}
                                            {rCliente === "Olson Internacional"
                                              ? "Line"
                                              : "Packing"}
                                          </Th>
                                          <Th>Lote {/*cantidad Planeada*/}</Th>
                                          <Th>PO</Th>
                                          <Th>Fecha de reciba</Th>
                                          <Th>Serial </Th>
                                          <Th>Serial BTI</Th>
                                          <Th>Piezas pintadas</Th>
                                          {aMRecuperado && (
                                            <Th>Piezas no recuperadas</Th>
                                          )}
                                          <Th className="width30px"> Embarcar </Th>
                                          <Th className={(ppEmbarquesMEmbarcado === false) ? " displaynone" : "minwidth30px"}> Marcar embarcado </Th>
                                        </Tr>
                                      </Thead>
                                      <Tbody>
                                        {reciba.map((reciba, i) => (
                                          //!reciba.piezasCtnaNRecuperadas && (
                                          <Tr
                                            className={
                                              i % 2 !== 0 ? "table-active" : ""
                                            }
                                          >
                                            <Td>{reciba.numero}</Td>
                                            <Td>{reciba.cliente}</Td>
                                            <Td className="margintopmobil20px">
                                              {reciba.numerodeParte}
                                            </Td>
                                            {/*<Td className="margintopmobil20px">{reciba.numerodeParteSalida}</Td>*/}
                                            <Td className="margintopmobil20px">
                                              {reciba.descripcion}
                                            </Td>
                                            <Td className="margintopmobil20px">
                                              {reciba.packing/*reciba.cantidadRecibida*/}
                                            </Td>
                                            <Td className="margintopmobil20px">
                                              {reciba.lote/*reciba.cantidadPlaneada*/}
                                            </Td>
                                            <Td className="margintopmobil20px">
                                              {reciba.po/*reciba.cantidadPlaneada*/}
                                            </Td>
                                            <Td className="margintopmobil20px">
                                              {reciba.fechaDeReciba}
                                            </Td>
                                            <Td className="margintopmobil40px">
                                              {reciba.serial}{" "}
                                            </Td>
                                            <Td className="margintopmobil40px">
                                              {reciba.serialRecibaBTI}{" "}
                                            </Td>
                                            <Td className="margintopmobil20px">
                                              {reciba.Pcoat === true ? reciba.piezasPintadasPC :
                                                reciba.piezasPintadas}
                                            </Td>
                                            {aMRecuperado && (
                                              <Td className="margintopmobil20px">
                                                {parseInt(reciba.piezasCtnaPintadasPC ? reciba.piezasCtnaPintadasPC : 0) + parseInt(reciba.piezasCtnaPintadas ? reciba.piezasCtnaPintadas : 0)}
                                              </Td>
                                            )}
                                            <Td className="margintopmobil40px">
                                              {((reciba.piezasPintadas > 0 || reciba.piezasPintadasPC > 0) ||
                                                (aMRecuperado === true &&
                                                  (reciba.piezasNRecuperadas > 0 || reciba.piezasNRecuperadasPC > 0))) && (
                                                  <button
                                                    class="btn-success cbutton mt-1 ml-1"
                                                    onClick={() =>
                                                      clicEmbarqueParticular(reciba, true)
                                                    }
                                                    title="Agregar a embarque"
                                                  >
                                                    {" "}
                                                    <IoIcons.IoMdAdd />{" "}
                                                  </button>
                                                )}
                                            </Td>
                                            <Td className={(ppEmbarquesMEmbarcado === false) ? " displaynone" : "margintopmobil40px"}>
                                              <button
                                                class="btn-danger cbutton mt-1 ml-1"
                                                onClick={() => marcarFueradePlanta(reciba)}
                                                title="Marcar el material fuera de planta"
                                              >
                                                <IoIcons.IoIosAnalytics />{" "}
                                              </button>
                                            </Td>
                                          </Tr>
                                          // )
                                        ))}
                                      </Tbody>
                                    </Table>
                                  </div>
                                  <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 ">{/*JSON.stringify(recibaSinFiltro)*/}</div>
                                </Row>
                                <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12  textaligmentcenter">
                                  Página {currentPage}, mostrando del{" "}
                                  {recordPerPage * currentPage - recordPerPage + 1}{" "}
                                  al{" "}
                                  {totalRecords < recordPerPage * currentPage
                                    ? totalRecords
                                    : recordPerPage * currentPage}{" "}
                                  de {totalRecords} registros
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12  textaligmentcenter ">
                                  <div className="floatcenter">
                                    <Pagination
                                      itemClass="page-item" // add it for bootstrap 4
                                      linkClass="page-link" // add it for bootstrap 4
                                      activePage={currentPage}
                                      itemsCountPerPage={recordPerPage}
                                      totalItemsCount={totalRecords}
                                      pageRangeDisplayed={pageRange}
                                      onChange={handlePageChange}
                                    />
                                  </div>
                                </div>
                              </>
                            )}
                            {recibaDevolucion[0] && (
                              <>
                                <Row>
                                  <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 margintop10px">
                                    <Label className="floatleft">
                                      Material No Pintado
                                    </Label>
                                  </div>
                                </Row>
                                <Row>
                                  <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll">
                                    <Table className=" mb-2 scroll ">
                                      <Thead class="thead-secondary">
                                        <Tr>
                                          <Th>ID</Th>
                                          <Th>Cliente</Th>
                                          <Th>Número de parte</Th>
                                          {/*<Th >Número de parte Embarques</Th>*/}
                                          <Th>Descripción</Th>
                                          <Th>
                                            {rCliente === "Olson Internacional"
                                              ? "Line"
                                              : "Packing"}
                                          </Th>
                                          <Th>Lote </Th>
                                          <Th>PO</Th>
                                          <Th>Serial </Th>
                                          <Th>Serial BTI</Th>
                                          <Th>Piezas a devolver</Th>
                                          <Th className="width30px"> Embarcar </Th>
                                          <Th className={(ppEmbarquesMEmbarcado === false) ? " displaynone" : "minwidth30px"}> Marcar embarcado </Th>
                                        </Tr>
                                      </Thead>
                                      <Tbody>
                                        {recibaDevolucion.map((reciba, i) => (
                                          //reciba.piezasCtnaNRecuperadas && (
                                          <Tr
                                            className={
                                              i % 2 !== 0 ? "table-active" : ""
                                            }
                                          >
                                            <Td>{reciba.numero}</Td>
                                            <Td>{reciba.cliente}</Td>
                                            <Td className="margintopmobil20px">
                                              {reciba.numerodeParte}
                                            </Td>
                                            {/*<Td className="margintopmobil20px">{reciba.numerodeParteSalida}</Td>*/}
                                            <Td className="margintopmobil20px">
                                              {reciba.descripcion}
                                            </Td>
                                            <Td className="margintopmobil20px">
                                              {reciba.packing}
                                            </Td>
                                            <Td className="margintopmobil20px">
                                              {reciba.lote}
                                            </Td>
                                            <Td className="margintopmobil20px">
                                              {reciba.po}
                                            </Td>
                                            <Td className="margintopmobil40px">
                                              {reciba.serial}{" "}
                                            </Td>
                                            <Td className="margintopmobil40px">
                                              {reciba.serialRecibaBTI}{" "}
                                            </Td>
                                            <Td className="margintopmobil20px">
                                              {reciba.piezasCtnaNRecuperadas}
                                            </Td>
                                            <Td className="margintopmobil40px">
                                              {reciba.piezasCtnaNRecuperadas >
                                                0 && (
                                                  <button
                                                    class="btn-success cbutton mt-1 ml-1"
                                                    onClick={() =>
                                                      clicEmbarqueParticular(reciba, false)
                                                    }
                                                    title="Agregar a embarque"
                                                  >
                                                    {" "}
                                                    <IoIcons.IoMdAdd />{" "}
                                                  </button>
                                                )}
                                            </Td>
                                            <Td className={(ppEmbarquesMEmbarcado === false) ? " displaynone" : "margintopmobil40px"}>
                                              <button
                                                class="btn-danger cbutton mt-1 ml-1"
                                                onClick={() => marcarFueradePlanta(reciba)}
                                                title="Marcar el material fuera de planta"
                                              >
                                                <IoIcons.IoIosAnalytics />{" "}
                                              </button>
                                            </Td>
                                          </Tr>
                                          // )
                                        ))}
                                      </Tbody>
                                    </Table>
                                  </div>
                                </Row>
                                <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12  textaligmentcenter">
                                  Página {currentPageNPintado}, mostrando del{" "}
                                  {recordPerPage * currentPageNPintado -
                                    recordPerPage +
                                    1}{" "}
                                  al{" "}
                                  {totalRecordsNP <
                                    recordPerPage * currentPageNPintado
                                    ? totalRecordsNP
                                    : recordPerPage * currentPageNPintado}{" "}
                                  de {totalRecordsNP} registros
                                </div>
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12  textaligmentcenter ">
                                  <div className="floatcenter">
                                    <Pagination
                                      itemClass="page-item" // add it for bootstrap 4
                                      linkClass="page-link" // add it for bootstrap 4
                                      activePage={currentPageNPintado}
                                      itemsCountPerPage={recordPerPage}
                                      totalItemsCount={totalRecordsNP}
                                      pageRangeDisplayed={pageRange}
                                      onChange={handlePageChangeNP}
                                    />
                                  </div>
                                </div>
                              </>
                            )}
                          </>
                        )}
                        {embarqueParticular === true && (
                          <>
                            <Row>
                              <div className="col-lg-12 col-md-6 col-sm-12 col-xs-12 mb-2 ">
                                <button
                                  class="btn-info cbutton floatright "
                                  onClick={() => { setEmbarqueParticular(false) }}
                                  title="Regresar"
                                  disabled={dRegresarAE}
                                >
                                  <IoIcons.IoMdArrowRoundBack />
                                  Regresar
                                </button>
                              </div>
                            </Row>
                            <Row>
                              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                                <Label className="floatleft">
                                  Cliente: {embarcando.cliente}
                                </Label>
                              </div>
                              <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                                <Label className="floatright">
                                  Número de parte: {embarcando.numerodeParte}
                                </Label>
                              </div>
                              <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                                <Label className="floatleft">
                                  Descripción: {embarcando.descripcion}
                                </Label>
                              </div>
                              <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                                <Label className="floatleft">
                                  Serial: {embarcando.serial}
                                </Label>
                              </div>
                              <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                                <Label className="floatleft">
                                  Serial BTI: {embarcando.serialRecibaBTI}
                                </Label>
                              </div>
                              <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                                <Label className="floatleft">
                                  {rCliente === "Olson Internacional"
                                    ? "PO: " + embarcando.po
                                    : "Lote: " + embarcando.lote}
                                </Label>
                              </div>
                              <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                                <Label className="floatleft">
                                  {rCliente === "Olson Internacional"
                                    ? "Line: " + embarcando.packing
                                    : "Packing :" + embarcando.packing}
                                </Label>
                              </div>
                              <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                                <Label className="floatleft">
                                  MFG Fecha: {embarcando.MFGFecha}
                                </Label>
                              </div>
                              <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                                <Label className="floatleft">
                                  Nuevo Serial del cliente: {/*clienteID*/}
                                </Label>
                                <Input
                                  name="serialNRecuperado"
                                  value={embarcando.serialNRecuperado}
                                  onChange={onChangesEmbarcando}
                                  placeholder=""
                                />
                              </div>
                              <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                                <Label
                                  className={
                                    (parseInt(embarcando.pPintadasOriginal ? embarcando.pPintadasOriginal : 0) +
                                      parseInt(embarcando.pNRecuperadasOriginal ? embarcando.pNRecuperadasOriginal : 0)) <
                                      (parseInt(embarcando.piezasPintadas ? embarcando.piezasPintadas : 0) +
                                        parseInt(embarcando.piezasNRecuperadas ? embarcando.piezasNRecuperadas : 0)) ||
                                      (parseInt(embarcando.piezasPintadas ? embarcando.piezasPintadas : 0) == 0 &&
                                        parseInt(embarcando.piezasNRecuperadas ? embarcando.piezasNRecuperadas : 0) == 0)
                                      ? "floatleft fcolorred"
                                      : "floatleft"
                                  }>
                                  Piezas pintadas*: {/*clienteID*/}
                                </Label>
                                <Input
                                  name="piezasPintadas"
                                  value={embarcando.piezasPintadas}
                                  disabled={
                                    embarcando.ambos === true
                                      ? false
                                      : !embarcando.MaterialPintado
                                  }
                                  onChange={onChangesEmbarcando}
                                  placeholder=""
                                />
                              </div>
                              <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                                <Label
                                  className={"floatleft"}>
                                  Piezas pintadas extra: {/*clienteID*/}
                                </Label>
                                <Input
                                  name="piezasPintadasExtra"
                                  value={embarcando.piezasPintadasExtra}
                                  onChange={onChangesEmbarcando}
                                  placeholder=""
                                />
                              </div>
                              <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                                <Label
                                  className={
                                    (embarcando.piezasNRecuperadasE === true &&
                                      (parseInt(embarcando.pPintadasOriginal ? embarcando.pPintadasOriginal : 0) +
                                        parseInt(embarcando.pNRecuperadasOriginal ? embarcando.pNRecuperadasOriginal : 0)) <
                                      (parseInt(embarcando.piezasPintadas ? embarcando.piezasPintadas : 0) +
                                        parseInt(embarcando.piezasNRecuperadas ? embarcando.piezasNRecuperadas : 0)))
                                      ? "floatleft fcolorred"
                                      : "floatleft"
                                  }
                                >
                                  Piezas no recuperadas*: {/*clienteID*/}
                                </Label>
                                <Input
                                  name="piezasNRecuperadas"
                                  value={
                                    embarcando.piezasNRecuperadas > 0
                                      ? embarcando.piezasNRecuperadas
                                      : ""
                                  }
                                  disabled={
                                    embarcando.pNRecuperadasOriginal > 0
                                      ? !embarcando.piezasNRecuperadasE
                                      : true
                                  }
                                  onChange={onChangesEmbarcando}
                                  placeholder=""
                                />
                              </div>
                              <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                                <Label
                                  className={
                                    (embarcando.MaterialPintado === false ||
                                      embarcando.ambos === true) &&
                                      embarcando.piezasNoPintadas == 0
                                      ? "floatleft fcolorred"
                                      : "floatleft"
                                  }
                                >
                                  Piezas no pintadas*: {/*clienteID*/}
                                </Label>
                                <Input
                                  name="piezasNoPintadas"
                                  value={
                                    embarcando.piezasNoPintadas > 0
                                      ? embarcando.piezasNoPintadas
                                      : ""
                                  }
                                  disabled={
                                    embarcando.ambos === true
                                      ? false
                                      : embarcando.MaterialPintado
                                  }
                                  onChange={onChangesEmbarcando}
                                  placeholder=""
                                />
                              </div>
                              <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                                <Label className="floatleft">
                                  Material en*: {/*clienteID*/}
                                </Label>

                                <select
                                  name="materialEn"
                                  className=" custom-select"
                                  onChange={onChangesEmbarcando}
                                >
                                  <option
                                    value="Contenedor"
                                    selected={
                                      embarcando.materialEn ===
                                        "Contenedor"
                                        ? true
                                        : false
                                    }
                                  >
                                    Contenedor
                                  </option>
                                  <option
                                    value="Caja"
                                    selected={
                                      embarcando.materialEn === "Caja"
                                        ? true
                                        : false
                                    }
                                  >
                                    Caja
                                  </option>
                                  <option
                                    value="Tarima"
                                    selected={
                                      embarcando.materialEn === "Tarima"
                                        ? true
                                        : false
                                    }
                                  >
                                    Tarima
                                  </option>
                                </select>
                              </div>
                              <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                                <Label className={(embarcando.materialEnCantidad === "" || !embarcando.materialEnCantidad) ?
                                  "floatleft fcolorred" : "floatleft"}>
                                  Empaques*: {/*clienteID*/}
                                </Label>

                                <Input
                                  name="materialEnCantidad"
                                  value={embarcando.materialEnCantidad}
                                  onChange={onChangesEmbarcando}
                                  placeholder=""
                                />
                              </div>
                              <div className="col-lg-8 col-md-6 col-sm-12 col-xs-12 ">
                                <Label className="floatleft">
                                  Comentarios: {/*clienteID*/}
                                </Label>
                                <Input
                                  name="comentarios"
                                  type="textarea"
                                  rows="1"
                                  value={embarcando.comentarios}
                                  onChange={onChangesEmbarcando}
                                  placeholder=""
                                />
                              </div>
                            </Row>
                            <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 ">{/*JSON.stringify(recibaSinFiltro)*/}</div>
                          </>
                        )}
                      </ModalBody>
                      <ModalFooter>
                        {!embarcando.recibaSerialID && (
                          <Button color="danger" onClick={toggle2}>
                            Cerrar
                          </Button>
                        )}
                        {embarcando.recibaSerialID && (
                          <button
                            className="cbutton btn-primary floatright "
                            color="primary"
                            size="sm"
                            title="Guardar serial de embarque"
                            disabled={cargando1}
                            onClick={() => guardarEmbarqueSerial()}
                          > Guardar
                          </button>
                        )}
                      </ModalFooter>
                      {/*JSON.stringify(embarcando)*/}
                      {/*<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{"AM: " + aMRecuperado + " " + JSON.stringify(recibaSinFiltro)}</div>*/}
                    </Modal>
                    {/*<Modal isOpen={modal3} size="lg" toggle={toggle3}>
                      <ModalHeader toggle={toggle3}>
                        Detalles de serial de Embarques
                      </ModalHeader>
                      <ModalBody>
                        <Alert color={colorr} isOpen={aVisibler} toggle={onDismissr}>
                          {mensajeAlertr}
                        </Alert>
                        {cargando1 === true && (
                          <Row>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " >
                              <img width="150px" alt="cargando" src="assets/img/preloader.gif" />
                            </div>
                          </Row>
                        )}

                        <Row>
                          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                            <Label className="floatleft">
                              Cliente: {embarcando.cliente}
                            </Label>
                          </div>
                          <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                            <Label className="floatright">
                              Número de parte: {embarcando.numerodeParte}
                            </Label>
                          </div>
                          <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                            <Label className="floatleft">
                              Descripción: {embarcando.descripcion}
                            </Label>
                          </div>
                          <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                            <Label className="floatleft">
                              Serial: {embarcando.serial}
                            </Label>
                          </div>
                          <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                            <Label className="floatleft">
                              Serial BTI: {embarcando.serialRecibaBTI}
                            </Label>
                          </div>
                          <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                            <Label className="floatleft">
                              {rCliente === "Olson Internacional"
                                ? "PO: " + embarcando.po
                                : "Lote: " + embarcando.lote}
                            </Label>
                          </div>
                          <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                            <Label className="floatleft">
                              {rCliente === "Olson Internacional"
                                ? "Line: " + embarcando.packing
                                : "Packing :" + embarcando.packing}
                            </Label>
                          </div>
                          <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                            <Label className="floatleft">
                              MFG Fecha: {embarcando.MFGFecha}
                            </Label>
                          </div>
                          <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                            <Label className="floatleft">
                              Nuevo Serial del cliente: 
                  </Label>
                  <Input
                    name="serialNRecuperado"
                    value={embarcando.serialNRecuperado}
                    onChange={onChangesEmbarcando}
                    placeholder=""
                  />
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                <Label
                  className={
                    (parseInt(embarcando.pPintadasOriginal ? embarcando.pPintadasOriginal : 0) +
                      parseInt(embarcando.pNRecuperadasOriginal ? embarcando.pNRecuperadasOriginal : 0)) <
                      (parseInt(embarcando.piezasPintadas ? embarcando.piezasPintadas : 0) +
                        parseInt(embarcando.piezasNRecuperadas ? embarcando.piezasNRecuperadas : 0)) ||
                      (parseInt(embarcando.piezasPintadas ? embarcando.piezasPintadas : 0) == 0 &&
                        parseInt(embarcando.piezasNRecuperadas ? embarcando.piezasNRecuperadas : 0) == 0)
                      ? "floatleft fcolorred"
                      : "floatleft"
                  }>
                  Piezas pintadas*: 
                </Label>
                <Input
                  name="piezasPintadas"
                  value={embarcando.piezasPintadas}
                  disabled={
                    embarcando.ambos === true
                      ? false
                      : !embarcando.MaterialPintado
                  }
                  onChange={onChangesEmbarcando}
                  placeholder=""
                />
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                <Label
                  className={"floatleft"}>
                  Piezas pintadas extra: 
                </Label>
                <Input
                  name="piezasPintadasExtra"
                  value={embarcando.piezasPintadasExtra}
                  onChange={onChangesEmbarcando}
                  placeholder=""
                />
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                <Label
                  className={
                    (embarcando.piezasNRecuperadasE === true &&
                      (parseInt(embarcando.pPintadasOriginal ? embarcando.pPintadasOriginal : 0) +
                        parseInt(embarcando.pNRecuperadasOriginal ? embarcando.pNRecuperadasOriginal : 0)) <
                      (parseInt(embarcando.piezasPintadas ? embarcando.piezasPintadas : 0) +
                        parseInt(embarcando.piezasNRecuperadas ? embarcando.piezasNRecuperadas : 0)))
                      ? "floatleft fcolorred"
                      : "floatleft"
                  }
                >
                  Piezas no recuperadas*: 
                </Label>
                <Input
                  name="piezasNRecuperadas"
                  value={
                    embarcando.piezasNRecuperadas > 0
                      ? embarcando.piezasNRecuperadas
                      : ""
                  }
                  disabled={
                    embarcando.pNRecuperadasOriginal > 0
                      ? !embarcando.piezasNRecuperadasE
                      : true
                  }
                  onChange={onChangesEmbarcando}
                  placeholder=""
                />
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                <Label
                  className={
                    (embarcando.MaterialPintado === false ||
                      embarcando.ambos === true) &&
                      embarcando.piezasNoPintadas == 0
                      ? "floatleft fcolorred"
                      : "floatleft"
                  }
                >
                  Piezas no pintadas*: 
                </Label>
                <Input
                  name="piezasNoPintadas"
                  value={
                    embarcando.piezasNoPintadas > 0
                      ? embarcando.piezasNoPintadas
                      : ""
                  }
                  disabled={
                    embarcando.ambos === true
                      ? false
                      : embarcando.MaterialPintado
                  }
                  onChange={onChangesEmbarcando}
                  placeholder=""
                />
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                <Label className="floatleft">
                  Material en*: 
                </Label>

                <select
                  name="materialEn"
                  className=" custom-select"
                  onChange={onChangesEmbarcando}
                >
                  <option
                    value="Contenedor"
                    selected={
                      embarcando.materialEn ===
                        "Contenedor"
                        ? true
                        : false
                    }
                  >
                    Contenedor
                  </option>
                  <option
                    value="Caja"
                    selected={
                      embarcando.materialEn === "Caja"
                        ? true
                        : false
                    }
                  >
                    Caja
                  </option>
                  <option
                    value="Tarima"
                    selected={
                      embarcando.materialEn === "Tarima"
                        ? true
                        : false
                    }
                  >
                    Tarima
                  </option>
                </select>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 ">
                <Label className={(embarcando.materialEnCantidad === "" || !embarcando.materialEnCantidad) ?
                  "floatleft fcolorred" : "floatleft"}>
                  Empaques*: 
                </Label>

                <Input
                  name="materialEnCantidad"
                  value={embarcando.materialEnCantidad}
                  onChange={onChangesEmbarcando}
                  placeholder=""
                />
              </div>
              <div className="col-lg-8 col-md-6 col-sm-12 col-xs-12 ">
                <Label className="floatleft">
                  Comentarios: 
                </Label>
                <Input
                  name="comentarios"
                  type="textarea"
                  rows="1"
                  value={embarcando.comentarios}
                  onChange={onChangesEmbarcando}
                  placeholder=""
                />
              </div>
            </Row>
            <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 "></div>
          </ModalBody>
          <ModalFooter>
            {!embarcando.recibaSerialID && (
              <Button color="danger" onClick={toggle3}>
                Cerrar
              </Button>
            )}
            {embarcando.recibaSerialID && (
              <button
                className="cbutton btn-primary floatright "
                color="primary"
                size="sm"
                title="Guardar serial de embarque"
                disabled={cargando1}
                onClick={() => guardarEmbarqueSerial()}
              > Guardar
              </button>
            )}
          </ModalFooter>
          </Modal>*/}
                  </TabPane >
                  <TabPane tabId="3">
                    <h5>Packings</h5>
                  </TabPane>
                  <TabPane tabId="4">
                    <div ref={componentRef[0]}>
                      <Row>
                        <img
                          className="imgmarlimp"
                          src="assets/img/Logo/logost.png"
                        />
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12 margintop20px  textaligmentcenter">
                          <h5 class=" textaligmentcenter  ">
                            Número de packing
                          </h5>
                          <h5 class="floatright margintop-33px">
                            Boon tec International S de RL de CV
                          </h5>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12   textaligmentcenter">
                          <h5 class=" fcolorred margintop-6px">{numeroP}</h5>
                          <h5 class="floatright  margintop-33px">
                            Calle norte 2 No. 14, Fracc. Ciudad Industrial{" "}
                          </h5>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12   textaligmentcenter">
                          <h5 class="margintop-6px"></h5>
                          <h5 class="floatright margintop-6px">
                            H.Matamoros, Tam, CP 87499{" "}
                          </h5>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12   margintop20px textaligmentcenter">
                          <h5 class=" floatleft margintop20px ml-3">
                            Entregado a:
                          </h5>
                          <h5 class=" margintop20px">Facturar a:</h5>
                          <h5 class=" floatright margintop-33px"></h5>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12    textaligmentcenter">
                          <h5 class=" floatleft ml-3"> {rClienteEntrega}</h5>
                          <h5 class="  ">
                            {rClienteFacturarA
                              ? rClienteFacturarA
                              : rClienteEntrega}
                          </h5>
                          <h5 class=" floatright margintop-33px"></h5>
                        </div>

                        <div class="col-lg-12 col-md-12 col-sm-12  col-xs-12   margintop20px textaligmentcenter">
                          <h5 class=" floatleft ml-3">Fecha:</h5>
                          <h5 class="">Atención:</h5>
                          <h5 class=" floatright margintop-33px">
                            {rCliente === "Olson Internacional"
                              ? "Lote:"
                              : "Orden de compra:"}
                          </h5>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4  col-xs-4   textaligmentcenter">
                          <h5 class=" floatleft ml-3">
                            {Moment(fechaDeEmbarque).format("DD/MM/YYYY")}
                          </h5>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4  col-xs-4   textaligmentcenter">
                          <h5 class="">{atencionA}</h5>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-4  col-xs-4   textaligmenright">
                          <h5 class=" floatright">
                            {ordenDeCompra}
                          </h5>
                        </div>
                      </Row>
                      <div>
                        {inputList.length > 0 && (
                          <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                            <Table
                              bordered
                              className="margintop20px mb-2  fontsize18px "
                            >
                              <Thead>
                                <Tr>
                                  <Th className="thtableImprimir  fontsize18px textaligmentcenter">
                                    Cantidad
                                  </Th>
                                  <Th className="minwidth200px thtableImprimir fontsize18px textaligmentcenter">
                                    Número de parte
                                  </Th>
                                  {/*<Th className="minwidth200px thtableImprimir fontsize18px textaligmentcenter">Lote</Th>*/}
                                  <Th className="thtableImprimir fontsize18px textaligmentcenter">
                                    Serial
                                  </Th>
                                  <Th className="minwidth200px thtableImprimir fontsize18px textaligmentcenter">
                                    Descripción
                                  </Th>
                                  <Th className="minwidth60px thtableImprimir fontsize18px textaligmentcenter">
                                    {rCliente === "Olson Internacional"
                                      ? "LINE"
                                      : "SHIPPER"}
                                  </Th>
                                  {(rCliente === "Olson Internacional" || rCliente === "Robertshaw Controls Nuevo Laredo") && (
                                    <Th className="minwidth60px thtableImprimir fontsize18px textaligmentcenter">
                                      PO
                                    </Th>
                                  )}
                                  <Th className="thtableImprimir fontsize18px textaligmentcenter">
                                    {aMRecuperado ? "Piezas conformes" : "Piezas"}
                                  </Th>
                                  {imprimirComentario && (
                                    <Th className="thtableImprimir fontsize18px textaligmentcenter">
                                      Comentarios
                                    </Th>
                                  )}
                                  {aMRecuperado && (
                                    <>
                                      <Th className="thtableImprimir fontsize18px textaligmentcenter">
                                        Piezas no conformes
                                      </Th>
                                      <Th className="thtableImprimir fontsize18px textaligmentcenter">
                                        Total Piezas
                                      </Th>
                                    </>
                                  )}
                                  {/*<Th className="minwidth200px thtableImprimir fontsize18px textaligmentcenter">
                                  Comentarios
                                </Th>*/}
                                </Tr>
                              </Thead>
                              <Tbody>
                                {inputList.map(
                                  (embarquess, i) =>
                                    i < 34 && (
                                      <Tr>
                                        <Td className="fontsize18px textaligmentcenter">
                                          {embarquess.materialEnCantidad}
                                        </Td>
                                        <Td className="fontsize18px textaligmentcenter">
                                          {embarquess.numerodeParteSalida
                                            ? embarquess.numerodeParteSalida
                                            : embarquess.numerodeParte}
                                        </Td>
                                        {/*<Td className="fontsize18px textaligmentcenter">{embarquess.lote}</Td>*/}
                                        <Td className="fontsize18px textaligmentcenter">
                                          {embarquess.serialNRecuperado
                                            ? embarquess.serialNRecuperado
                                            : embarquess.serial}
                                        </Td>
                                        <Td className="fontsize18px textaligmentcenter">
                                          {embarquess.descripcion}
                                        </Td>
                                        <Td
                                          className={
                                            embarquess.descripcion
                                              ? "fontsize18px textaligmentcenter"
                                              : "margintopmobil20px fontsize18px textaligmentcenter"
                                          }
                                        >
                                          {embarquess.packing}
                                        </Td>
                                        {rCliente === "Olson Internacional" && (
                                          <Td className="fontsize18px textaligmentcenter">
                                            {embarquess.po}
                                          </Td>
                                        )}
                                        {rCliente === "Robertshaw Controls Nuevo Laredo" && (
                                          <Td className="fontsize18px textaligmentcenter">
                                            {embarquess.poEmbarques ? embarquess.poEmbarques : embarquess.po}
                                          </Td>
                                        )}
                                        <Td className="fontsize18px textaligmentcenter">
                                          {embarquess.piezasPintadas}
                                        </Td>
                                        {imprimirComentario && (
                                          <Td className="fontsize18px textaligmentcenter">
                                            {embarquess.comentarios ? embarquess.comentarios : ""}
                                          </Td>
                                        )}
                                        {aMRecuperado && (
                                          <>
                                            <Td className="fontsize18px textaligmentcenter">
                                              {embarquess.piezasNRecuperadas +
                                                (embarquess.piezasNoPintadas
                                                  ? embarquess.piezasNoPintadas
                                                  : 0)}
                                            </Td>
                                            <Td className="fontsize18px textaligmentcenter">
                                              {parseInt(embarquess.piezasEmbarcadas) - parseInt(sinTotalScrap === true ? (embarquess.piezasNRecuperadas ? embarquess.piezasNRecuperadas : 0) : 0)}
                                            </Td>
                                          </>
                                        )}
                                        {/*<Td className="fontsize18px textaligmentcenter">
                                        {embarquess.comentarios}
                                      </Td>*/}
                                      </Tr>
                                    )
                                )}
                              </Tbody>
                            </Table>

                            {inputList.length > 33 && (
                              <>
                                <div className="page-break">
                                  <Table
                                    bordered
                                    className=" mb-2  fontsize18px "
                                  >
                                    <Thead>
                                      <Tr>
                                        <Th className="thtableImprimir  fontsize18px textaligmentcenter">
                                          Cantidad
                                        </Th>
                                        <Th className="minwidth200px thtableImprimir fontsize18px textaligmentcenter">
                                          Número de parte
                                        </Th>
                                        <Th className="thtableImprimir fontsize18px textaligmentcenter">
                                          Serial
                                        </Th>
                                        <Th className="minwidth200px thtableImprimir fontsize18px textaligmentcenter">
                                          Descripción
                                        </Th>
                                        <Th className="minwidth60px thtableImprimir fontsize18px textaligmentcenter">
                                          {rCliente === "Olson Internacional"
                                            ? "LINE"
                                            : "SHIPPER"}
                                        </Th>
                                        {rCliente === "Olson Internacional" && (
                                          <Th className="minwidth60px thtableImprimir fontsize18px textaligmentcenter">
                                            PO
                                          </Th>
                                        )}
                                        <Th className="thtableImprimir fontsize18px textaligmentcenter">
                                          {aMRecuperado
                                            ? "Piezas conformes"
                                            : "Piezas"}
                                        </Th>
                                        {imprimirComentario && (
                                          <Th className="thtableImprimir fontsize18px textaligmentcenter">
                                            Comentarios
                                          </Th>
                                        )}
                                        {aMRecuperado && (
                                          <>
                                            <Th className="thtableImprimir fontsize18px textaligmentcenter">
                                              Piezas no conformes{" "}
                                            </Th>
                                            <Th className="thtableImprimir fontsize18px textaligmentcenter">
                                              Total Piezas
                                            </Th>
                                          </>
                                        )}
                                        {/*<Th className="minwidth200px thtableImprimir fontsize18px textaligmentcenter">
                                        Comentarios
                                      </Th>*/}
                                      </Tr>
                                    </Thead>
                                    <Tbody>
                                      {inputList.map(
                                        (embarquess, i) =>
                                          i > 33 && (
                                            <Tr>
                                              <Td className="fontsize18px textaligmentcenter">
                                                {embarquess.materialEnCantidad}
                                              </Td>
                                              <Td className="fontsize18px textaligmentcenter">
                                                {embarquess.numerodeParteSalida
                                                  ? embarquess.numerodeParteSalida
                                                  : embarquess.numerodeParte}
                                              </Td>
                                              <Td className="fontsize18px textaligmentcenter">
                                                {embarquess.serialNRecuperado
                                                  ? embarquess.serialNRecuperado
                                                  : embarquess.serial}
                                              </Td>
                                              <Td className="fontsize18px textaligmentcenter">
                                                {embarquess.descripcion}
                                              </Td>
                                              <Td
                                                className={
                                                  embarquess.descripcion
                                                    ? "fontsize18px textaligmentcenter"
                                                    : "margintopmobil20px fontsize18px textaligmentcenter"
                                                }
                                              >
                                                {embarquess.packing}
                                              </Td>
                                              {rCliente ===
                                                "Olson Internacional" && (
                                                  <Td className="fontsize18px textaligmentcenter">
                                                    {embarquess.po}
                                                  </Td>
                                                )}
                                              <Td className="fontsize18px textaligmentcenter">
                                                {embarquess.piezasPintadas}
                                              </Td>
                                              {imprimirComentario && (
                                                <Td className="fontsize18px textaligmentcenter">
                                                  {embarquess.comentarios ? embarquess.comentarios : ""}
                                                </Td>
                                              )}
                                              {aMRecuperado && (
                                                <>
                                                  <Td className="fontsize18px textaligmentcenter">
                                                    {
                                                      embarquess.piezasNRecuperadas
                                                    }
                                                  </Td>
                                                  <Td className="fontsize18px textaligmentcenter">
                                                    {parseInt(embarquess.piezasEmbarcadas) - parseInt(sinTotalScrap === true ? (embarquess.piezasNRecuperadas ? embarquess.piezasNRecuperadas : 0) : 0)}
                                                  </Td>
                                                </>
                                              )}
                                              {/*<Td className="fontsize18px textaligmentcenter">
                                              {embarquess.comentarios}
                                            </Td>*/}
                                            </Tr>
                                          )
                                      )}
                                    </Tbody>
                                  </Table>
                                </div>
                              </>
                            )}
                          </div>
                        )}
                        {inputListServicios.length > 0 && (
                          <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                            <Table
                              bordered
                              className="margintop20px mb-2  fontsize18px "
                            >
                              <Thead>
                                <Tr>
                                  <Th className="thtableImprimir  fontsize18px textaligmentcenter">
                                    Cantidad
                                  </Th>
                                  <Th className="minwidth200px thtableImprimir fontsize18px textaligmentcenter">
                                    Número de parte
                                  </Th>
                                  {/*<Th className="minwidth200px thtableImprimir fontsize18px textaligmentcenter">Lote</Th>*/}
                                  <Th className="thtableImprimir fontsize18px textaligmentcenter">
                                    Serial
                                  </Th>
                                  <Th className="minwidth200px thtableImprimir fontsize18px textaligmentcenter">
                                    Descripción
                                  </Th>
                                  <Th className="minwidth60px thtableImprimir fontsize18px textaligmentcenter">
                                    SHIPPER
                                  </Th>
                                  {/*(rCliente === "Olson Internacional" || rCliente === "Robertshaw Controls Nuevo Laredo") && (
                                    <Th className="minwidth60px thtableImprimir fontsize18px textaligmentcenter">
                                      PO
                                    </Th>
                                  )*/}
                                  <Th className="thtableImprimir fontsize18px textaligmentcenter">
                                    Piezas
                                  </Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                {inputListServicios.map(
                                  (embarquess, i) =>
                                    i < 34 && (
                                      <Tr>
                                        <Td className="fontsize18px textaligmentcenter">
                                          {embarquess.materialEnCantidad}
                                        </Td>
                                        <Td className="fontsize18px textaligmentcenter">
                                          {embarquess.numerodeParte}
                                        </Td>
                                        {/*<Td className="fontsize18px textaligmentcenter">{embarquess.lote}</Td>*/}
                                        <Td className="fontsize18px textaligmentcenter">
                                          {embarquess.serial}
                                        </Td>
                                        <Td className="fontsize18px textaligmentcenter">
                                          {embarquess.descripcion}
                                        </Td>
                                        <Td
                                          className={
                                            embarquess.descripcion
                                              ? "fontsize18px textaligmentcenter"
                                              : "margintopmobil20px fontsize18px textaligmentcenter"
                                          }
                                        >
                                          {embarquess.shipper}
                                        </Td>
                                        <Td className="fontsize18px textaligmentcenter">
                                          {embarquess.piezasPintadas}
                                        </Td>
                                      </Tr>
                                    )
                                )}
                              </Tbody>
                            </Table>
                            {inputListServicios.length > 33 && (
                              <div className="page-break">
                                <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                  <Table
                                    bordered
                                    className="margintop20px mb-2  fontsize18px "
                                  >
                                    <Thead>
                                      <Tr>
                                        <Th className="thtableImprimir  fontsize18px textaligmentcenter">
                                          Cantidad
                                        </Th>
                                        <Th className="minwidth200px thtableImprimir fontsize18px textaligmentcenter">
                                          Número de parte
                                        </Th>
                                        {/*<Th className="minwidth200px thtableImprimir fontsize18px textaligmentcenter">Lote</Th>*/}
                                        <Th className="thtableImprimir fontsize18px textaligmentcenter">
                                          Serial
                                        </Th>
                                        <Th className="minwidth200px thtableImprimir fontsize18px textaligmentcenter">
                                          Descripción
                                        </Th>
                                        <Th className="minwidth60px thtableImprimir fontsize18px textaligmentcenter">
                                          SHIPPER
                                        </Th>
                                        {/*(rCliente === "Olson Internacional" || rCliente === "Robertshaw Controls Nuevo Laredo") && (
                                          <Th className="minwidth60px thtableImprimir fontsize18px textaligmentcenter">
                                            PO
                                          </Th>
                                        )*/}
                                        <Th className="thtableImprimir fontsize18px textaligmentcenter">
                                          Piezas
                                        </Th>
                                      </Tr>
                                    </Thead>
                                    <Tbody>
                                      {inputListServicios.map(
                                        (embarquess, i) =>
                                          i > 33 && (
                                            <Tr>
                                              <Td className="fontsize18px textaligmentcenter">
                                                {embarquess.materialEnCantidad}
                                              </Td>
                                              <Td className="fontsize18px textaligmentcenter">
                                                {embarquess.numerodeParte}
                                              </Td>
                                              {/*<Td className="fontsize18px textaligmentcenter">{embarquess.lote}</Td>*/}
                                              <Td className="fontsize18px textaligmentcenter">
                                                {embarquess.serial}
                                              </Td>
                                              <Td className="fontsize18px textaligmentcenter">
                                                {embarquess.descripcion}
                                              </Td>
                                              <Td
                                                className={
                                                  embarquess.descripcion
                                                    ? "fontsize18px textaligmentcenter"
                                                    : "margintopmobil20px fontsize18px textaligmentcenter"
                                                }
                                              >
                                                {embarquess.shipper}
                                              </Td>
                                              <Td className="fontsize18px textaligmentcenter">
                                                {embarquess.piezasPintadas}
                                              </Td>
                                            </Tr>
                                          )
                                      )}
                                    </Tbody>
                                  </Table>

                                </div>
                              </div>
                            )}
                          </div>
                        )}
                        <div class="col-lg-12 col-md-12 col-sm-12 mt-2 mb-1   ">
                          <h5 class="floatleft  margintop20px    ">
                            Total empaque:{" "}
                          </h5>
                          <h5 class="floatright margintop20px">
                            Total Piezas: {sumPiezas}
                          </h5>
                        </div>
                        <Row>
                          <div class="col-lg-12 col-md-12 col-sm-12 mt-2 mb-1   ">
                            {sumCajas > 0 && (
                              <h5 class="floatleft margintop13px">
                                {sumCajas + (sumCajas ? sumCajas > 1 ? " Cajas" : " Caja" : "")}
                              </h5>
                            )}
                          </div>
                        </Row>
                        <Row>
                          <div class="col-lg-12 col-md-12 col-sm-12 mt-2">
                            {sumContenedores > 0 && (
                              <h5
                                class={
                                  sumCajas > 0
                                    ? " marginleft165px margintop-20px"
                                    : ""
                                }
                              >
                                {" "}
                                {sumContenedores + (sumContenedores ? sumContenedores > 1 ? " Contenedores" : " Contenedor" : "")}
                              </h5>
                            )}
                          </div>
                        </Row>
                        <Row>
                          <div class="col-lg-12 col-md-12 col-sm-12 mt-2   ">
                            {sumTarimas > 0 && (
                              <h5 class={((sumCajas > 0) && (sumContenedores > 0))
                                ? " marginleft165px margintop-13px"
                                : (sumContenedores > 0) ? " marginleft165px margintop-10px" :
                                  (sumCajas > 0) ? " marginleft165px margintop-20px" : "margintop-6px"
                              }>
                                {sumTarimas + (sumTarimas ? sumTarimas > 1 ? " Tarimas" : " Tarima" : "")}
                              </h5>
                            )}
                          </div>
                        </Row>
                        <Row className="margintop20px">
                          {iTotalNParte === true && (
                            <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                              <Table
                                bordered
                                className="margintop20px mb-2  fontsize18px "
                              >
                                <Thead>
                                  <Tr>
                                    <Th className="thtableImprimir  fontsize18px textaligmentcenter">
                                      Cantidad
                                    </Th>
                                    <Th className="minwidth200px thtableImprimir fontsize18px textaligmentcenter">
                                      Número de parte
                                    </Th>
                                    {/*<Th className="minwidth200px thtableImprimir fontsize18px textaligmentcenter">Lote</Th>*/}
                                    <Th className="thtableImprimir fontsize18px textaligmentcenter">
                                      Piezas
                                    </Th>
                                  </Tr>
                                </Thead>
                                <Tbody>
                                  {totalNumeroParte.map(
                                    (embarquess, i) =>
                                      i < 34 && (
                                        <Tr>
                                          <Td className="fontsize18px textaligmentcenter">
                                            {embarquess.totalCantidad}
                                          </Td>
                                          <Td className="fontsize18px textaligmentcenter">
                                            {embarquess.numerodeParteSalida
                                              ? embarquess.numerodeParteSalida
                                              : embarquess.numerodeParte}
                                          </Td>
                                          {/*<Td className="fontsize18px textaligmentcenter">{embarquess.lote}</Td>*/}
                                          <Td className="fontsize18px textaligmentcenter">
                                            {embarquess.totalNumeroParte}
                                          </Td>
                                        </Tr>
                                      )
                                  )}
                                </Tbody>
                              </Table>

                              {totalNumeroParte.length > 33 && (
                                <>
                                  <div className="page-break">
                                    <Table
                                      bordered
                                      className=" mb-2  fontsize18px "
                                    >
                                      <Thead>
                                        <Tr>
                                          <Th className="thtableImprimir  fontsize18px textaligmentcenter">
                                            Cantidad
                                          </Th>
                                          <Th className="minwidth200px thtableImprimir fontsize18px textaligmentcenter">
                                            Número de parte
                                          </Th>
                                          <Th className="thtableImprimir fontsize18px textaligmentcenter">
                                            Piezas
                                          </Th>
                                        </Tr>
                                      </Thead>
                                      <Tbody>
                                        {totalNumeroParte.map(
                                          (embarquess, i) =>
                                            i > 33 && (
                                              <Tr>
                                                <Td className="fontsize18px textaligmentcenter">
                                                  {embarquess.totalCantidad}
                                                </Td>
                                                <Td className="fontsize18px textaligmentcenter">
                                                  {embarquess.numerodeParteSalida
                                                    ? embarquess.numerodeParteSalida
                                                    : embarquess.numerodeParte}
                                                </Td>
                                                <Td className="fontsize18px textaligmentcenter">
                                                  {embarquess.totalNumeroParte}
                                                </Td>
                                              </Tr>
                                            )
                                        )}
                                      </Tbody>
                                    </Table>
                                  </div>
                                </>
                              )}
                            </div>
                          )}
                        </Row>
                        <Row className="mt-5">
                          <h5 class="textaligmentcenter resppimp">
                            _______________________________________________{" "}
                          </h5>
                          <h5 class="textaligmentcenter autppimp">
                            _______________________________________________{" "}
                          </h5>
                          <h5 class="textaligmentcenter resppimpt">
                            Documento generado por
                          </h5>
                          <h5 class="textaligmentcenter autppimpt">
                            Firmado de recibido
                          </h5>
                        </Row>
                        <div class="footer">
                          <p className="floatright  mr-3">FOR-MA11 REV A</p> <br />
                        </div>
                      </div>
                    </div>
                    {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left " style={{ marginTop: 20 }}>{JSON.stringify(planeaciones)}</div>*/}
                  </TabPane>
                </TabContent >
              </div >
            </Fragment >
          </div >
        </>
      )
      }
    </>
  );
}

export default Embarques;
